import type { cacheExchange, Resolver as GraphCacheResolver, UpdateResolver as GraphCacheUpdateResolver, OptimisticMutationResolver as GraphCacheOptimisticMutationResolver } from '@urql/exchange-graphcache';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export enum AiTaskType {
  AreaLink = 'AREA_LINK',
  Task = 'TASK'
}

export type AddCalendarEventInput = {
  calendarDayId: Scalars['String']['input'];
  calendarEventDetails: CalendarEventDetailsInput;
  courseId: Scalars['String']['input'];
  day: Scalars['String']['input'];
};

export type AddCalendarEventsInput = {
  calendarDayId: Scalars['String']['input'];
  calendarEventDetails?: Array<CalendarEventDetailsInput>;
  courseId: Scalars['String']['input'];
  day: Scalars['String']['input'];
};

/** Input for adding a user to a course */
export type AddCourseCollaboratorInput = {
  courseId: Scalars['String']['input'];
  courseMembershipRole: CourseMembershipRole;
  userId: Scalars['String']['input'];
};

/** Input for adding an Item to the calendar */
export type AddItemToCalendarInput = {
  calendarDayId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
  day: Scalars['String']['input'];
  /** The id of the item */
  id: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
  topicId: Scalars['String']['input'];
};

export type AddTimetableExtensionInput = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  fromDay: Scalars['String']['input'];
  fromTime?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  timetableEntryId?: InputMaybe<Scalars['String']['input']>;
  toDay: Scalars['String']['input'];
  toTime?: InputMaybe<Scalars['String']['input']>;
  type?: PeriodType;
};

/** Input for adding multiple topics to multiple courses */
export type AddTopicsCoursesInput = {
  courseIds: Array<Scalars['String']['input']>;
  topicIds: Array<Scalars['String']['input']>;
};

export enum AiLanguage {
  Ar = 'ar',
  Cs = 'cs',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  Hi = 'hi',
  Hr = 'hr',
  It = 'it',
  Lb = 'lb',
  Nl = 'nl',
  Po = 'po',
  Pt = 'pt',
  Ro = 'ro',
  Rs = 'rs',
  Ru = 'ru',
  Se = 'se',
  Sl = 'sl',
  Sq = 'sq',
  Tr = 'tr',
  Ur = 'ur'
}

export type AiSettings = BaseModel & {
  __typename?: 'AiSettings';
  age: Scalars['Float']['output'];
  course: Course;
  createdAt: Scalars['DateTime']['output'];
  curriculum?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  language: AiLanguage;
  linkedCurriculum?: Maybe<Curriculum>;
  linkedCurriculumContent?: Maybe<CurriculumContent>;
  subject: Scalars['String']['output'];
};

export type AiSettingsInput = {
  age: Scalars['Float']['input'];
  courseId: Scalars['String']['input'];
  curriculum?: InputMaybe<Scalars['String']['input']>;
  language: AiLanguage;
  linkedCurriculum?: InputMaybe<Scalars['String']['input']>;
  linkedCurriculumContent?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

/** Result containing the ai settings of a course */
export type AiSettingsResult = {
  __typename?: 'AiSettingsResult';
  age: Scalars['Float']['output'];
  curriculum?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  linkedCurriculum?: Maybe<Scalars['String']['output']>;
  linkedCurriculumContent?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type AssignmentChatbot = {
  __typename?: 'AssignmentChatbot';
  id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type AssignmentChatbotHistory = {
  __typename?: 'AssignmentChatbotHistory';
  assignmentId: Scalars['String']['output'];
  instances: Array<AssignmentChatbotInstanceSummary>;
  nickname?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AssignmentChatbotHistoryInput = {
  assignmentId: Scalars['String']['input'];
  materialId: Scalars['String']['input'];
  studentSessionId: Scalars['String']['input'];
};

export type AssignmentChatbotInstanceSummary = {
  __typename?: 'AssignmentChatbotInstanceSummary';
  createdAt: Scalars['DateTime']['output'];
  instanceId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  messages: Array<AssignmentChatbotMessage>;
};

export type AssignmentChatbotMessage = {
  __typename?: 'AssignmentChatbotMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type AssignmentOpenQuestion = {
  __typename?: 'AssignmentOpenQuestion';
  guidance?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AssignmentOpenQuestionAttempt = {
  __typename?: 'AssignmentOpenQuestionAttempt';
  answer?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  hints: Array<Scalars['String']['output']>;
  rating?: Maybe<InteractiveAssignmentAiFeedbackRating>;
};

export type AssignmentOpenQuestionHistory = {
  __typename?: 'AssignmentOpenQuestionHistory';
  attempts: Array<AssignmentOpenQuestionAttempt>;
  guidance?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type AssignmentOpenQuestionHistoryInput = {
  assignmentId: Scalars['String']['input'];
  materialId: Scalars['String']['input'];
  studentSessionId: Scalars['String']['input'];
};

/** Status for a Question for a given student */
export type AssignmentStatus = {
  __typename?: 'AssignmentStatus';
  assignmentId: Scalars['String']['output'];
  feedbackCount: Scalars['Float']['output'];
  hintCount: Scalars['Float']['output'];
  latestAnswer?: Maybe<Scalars['String']['output']>;
  latestSelectedOptionIds?: Maybe<Array<Scalars['String']['output']>>;
  messageCount: Scalars['Float']['output'];
  status?: Maybe<InteractiveAssignmentStatus>;
};

/** Result containing JWT tokens */
export type AuthResult = {
  __typename?: 'AuthResult';
  /** Main JWT authentication token */
  access_token: Scalars['String']['output'];
  /** JWT refresh token */
  refresh_token: Scalars['String']['output'];
  /** Requesting users id */
  userId: Scalars['String']['output'];
};

export type BaseModel = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

export enum BillingCycle {
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  TwoYears = 'TWO_YEARS',
  Yearly = 'YEARLY'
}

export type CalendarEvent = CalendarNote | ItemInstance;

export type CalendarEventDetailsInput = {
  calendarEventId: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
  type: CalendarEventType;
};

export type CalendarEventListResult = {
  __typename?: 'CalendarEventListResult';
  calendarEvents: Array<CalendarEvent>;
};

export type CalendarEventResult = {
  __typename?: 'CalendarEventResult';
  calendarEvent: CalendarEvent;
};

export enum CalendarEventType {
  Item = 'ITEM',
  Note = 'NOTE',
  Todo = 'TODO'
}

export type CalendarNote = BaseModel & {
  __typename?: 'CalendarNote';
  backgroundColor: Scalars['String']['output'];
  course: Course;
  createdAt: Scalars['DateTime']['output'];
  foregroundColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
};

export type CalendarNoteResult = {
  __typename?: 'CalendarNoteResult';
  calendarNote: CalendarNote;
};

/** Input to change password using the existing one  */
export type ChangePasswordInput = {
  /** Users existing password */
  existingPassword: Scalars['String']['input'];
  /** Users new password with minimum length according to our policy */
  newPassword: Scalars['String']['input'];
};

/** Input that contains all required and optional values for checking if there are external courses that can be joined */
export type CheckExistingExternalCoursesInput = {
  /** Day of when to check */
  day?: InputMaybe<Scalars['String']['input']>;
  /** External course Id */
  externalCourseId?: InputMaybe<Scalars['String']['input']>;
  /** External user credentials id */
  externalUserCredentialsId: Scalars['String']['input'];
};

/** Input providing a code */
export type CodeInput = {
  /** A non-empty code */
  code: Scalars['String']['input'];
};

export type Configuration = {
  __typename?: 'Configuration';
  featureFlags?: Maybe<Array<FeatureFlag>>;
  global: GlobalConfiguration;
};

/** Input that contains all required and optional values for connecting a course */
export type ConnectExternalCourseInput = {
  /** Internal course id */
  courseId?: InputMaybe<Scalars['String']['input']>;
  /** External course display name */
  displayName: Scalars['String']['input'];
  /** External course Id */
  externalId: Scalars['String']['input'];
  /** External user credentials id */
  externalUserCredentialsId: Scalars['String']['input'];
};

export type ConnectedCourse = {
  __typename?: 'ConnectedCourse';
  course: Course;
  displayName: Scalars['String']['output'];
  externalCourseMappingId: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  externalUserCredentialsId: Scalars['String']['output'];
  roleInCourse: CourseMembershipRole;
};

export type Content = Folder | ItemInstance | Material | TopicInstance;

/** Input for searching content */
export type ContentSearchInput = {
  asOwner?: InputMaybe<Scalars['Boolean']['input']>;
  courseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  libraryFolderId?: InputMaybe<Scalars['String']['input']>;
  /** Defines what is returned */
  resultOrder?: InputMaybe<ContentSearchResultOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Defines what is being searched for */
  searchType?: ContentSearchType;
};

export enum ContentSearchResultOrder {
  Newest = 'NEWEST',
  None = 'NONE'
}

export enum ContentSearchType {
  ItemInstance = 'ITEM_INSTANCE',
  Material = 'MATERIAL',
  Topic = 'TOPIC',
  TopicInstance = 'TOPIC_INSTANCE'
}

export enum ContentVisibility {
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE'
}

export type Country = BaseModel & {
  __typename?: 'Country';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  languageDefault: Language;
  name: Scalars['String']['output'];
};

/** Object to combine Country and CountryState */
export type CountryStateCombo = {
  __typename?: 'CountryStateCombo';
  /** Name of the country */
  countryName: Scalars['String']['output'];
  /** Generated name for frontend use */
  displayName: Scalars['String']['output'];
  /** Id of the country */
  id: Scalars['String']['output'];
  /** The countries language */
  language: Language;
  /** Id of the associated country state */
  stateId: Scalars['String']['output'];
  /** Name of the associated country state */
  stateName: Scalars['String']['output'];
};

export type Course = BaseModel & {
  __typename?: 'Course';
  backgroundColor: Scalars['String']['output'];
  classLevelAge?: Maybe<Scalars['String']['output']>;
  classLevelKey?: Maybe<Scalars['String']['output']>;
  classLevelLabel?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  collaborators?: Maybe<Array<CourseCollaborator>>;
  countryKey?: Maybe<Scalars['String']['output']>;
  countryLabel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  days?: Maybe<Array<Scalars['String']['output']>>;
  externalCourseMappings?: Maybe<Array<ExternalCourseMapping>>;
  foregroundColor: Scalars['String']['output'];
  hasOrigin: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  languageKey?: Maybe<Scalars['String']['output']>;
  languageLabel?: Maybe<Scalars['String']['output']>;
  lastOriginSyncAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  origin?: Maybe<Course>;
  originDetails?: Maybe<OriginDetails>;
  owner: User;
  permissions?: Maybe<UserCoursePermission>;
  promptingAddition?: Maybe<Scalars['String']['output']>;
  schoolTypeKey?: Maybe<Scalars['String']['output']>;
  schoolTypeLabel?: Maybe<Scalars['String']['output']>;
  schoolYear?: Maybe<SchoolYear>;
  shortName?: Maybe<Scalars['String']['output']>;
  stateKey?: Maybe<Scalars['String']['output']>;
  stateLabel?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Subject>;
  subjectKey?: Maybe<Scalars['String']['output']>;
  subjectLabel?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  usage: UsageType;
};

export type CourseCalendarDay = {
  __typename?: 'CourseCalendarDay';
  calendarEvents: Array<CalendarEvent>;
  day: Scalars['String']['output'];
  id: Scalars['String']['output'];
  periodCourse: PeriodCourse;
};

export type CourseCalendarDaysInput = {
  courseId: Scalars['String']['input'];
  fromDay: Scalars['String']['input'];
  toDay: Scalars['String']['input'];
};

/** Output wrapper for a collaborator in a course */
export type CourseCollaborator = {
  __typename?: 'CourseCollaborator';
  courseRole: CourseMembershipRole;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  joinedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

/** Output wrapper for a course membership */
export type CourseCollaboratorResult = {
  __typename?: 'CourseCollaboratorResult';
  courseCollaborator: CourseCollaborator;
};

export type CourseContentVisibility = BaseModel & {
  __typename?: 'CourseContentVisibility';
  contentVisibility: ContentVisibility;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

/** Input that contains all required and optional values for changing the visibility of supported course content */
export type CourseContentVisibilityToggleInput = {
  /** The course ID for which you want to grant public access to */
  contentId: Scalars['String']['input'];
  /** Status for content visibility */
  contentVisibility?: ContentVisibility;
};

/** A folder inside a course */
export type CourseFolder = {
  __typename?: 'CourseFolder';
  courseId: Scalars['String']['output'];
  courseMaterials: Array<CourseMaterial>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  folder: Folder;
  id: Scalars['String']['output'];
  materialCount: Scalars['Float']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

/** Input for reordering a course folder */
export type CourseFolderReorderInput = {
  /** The id of the entity */
  id: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
};

/** Result containing a course folder */
export type CourseFolderResult = {
  __typename?: 'CourseFolderResult';
  courseFolder: CourseFolder;
};

/** Input for getting a course topic instances */
export type CourseIdWithFilterInput = {
  /** Non-empty id of an object or entity */
  id: Scalars['String']['input'];
  /** Optional: Boolean to fetch completed/not completed topic instances for a course  */
  topicInstanceCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CourseInvite = BaseModel & {
  __typename?: 'CourseInvite';
  code: Scalars['String']['output'];
  course: Course;
  courseMembershipRole: CourseMembershipRole;
  createdAt: Scalars['DateTime']['output'];
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
};

/** Output for public course preview data */
export type CourseInvitePreview = {
  __typename?: 'CourseInvitePreview';
  backgroundColor: Scalars['String']['output'];
  courseId: Scalars['String']['output'];
  courseMember: Scalars['Boolean']['output'];
  courseName: Scalars['String']['output'];
  courseOwner: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  foregroundColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Result containing a course invitation */
export type CourseInviteResult = {
  __typename?: 'CourseInviteResult';
  courseInvite?: Maybe<CourseInvite>;
};

/** Input for invalidating a course collaboration invite for a specific membership role or all */
export type CourseInvitesQueryInput = {
  courseId: Scalars['String']['input'];
  courseMembershipRole?: InputMaybe<CourseMembershipRole>;
};

export enum CourseListAccessFilter {
  All = 'ALL',
  ConnectExt = 'CONNECT_EXT',
  Read = 'READ',
  Write = 'WRITE'
}

export enum CourseListStatusFilter {
  All = 'ALL',
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export enum CourseListUsageFilter {
  All = 'ALL',
  Regular = 'REGULAR',
  Template = 'TEMPLATE'
}

/** A material inside a course */
export type CourseMaterial = {
  __typename?: 'CourseMaterial';
  courseId: Scalars['String']['output'];
  courseVisibility: Scalars['Boolean']['output'];
  /** Timestamp when the course was made visible */
  courseVisibleAt?: Maybe<Scalars['DateTime']['output']>;
  dates: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  material: Material;
};

/** Result containing a course material */
export type CourseMaterialResult = {
  __typename?: 'CourseMaterialResult';
  courseMaterial: CourseMaterial;
};

/** Input that contains all required and optional values for changing the visibility of a course material */
export type CourseMaterialVisibilityToggleInput = {
  /** Status for content visibility */
  contentVisibility?: ContentVisibility;
  /** The course ID related to the visibility change */
  courseId: Scalars['String']['input'];
  /** The material ID for which you want to toggle the visibility */
  materialId: Scalars['String']['input'];
};

export enum CourseMembershipRole {
  CoTeacher = 'CO_TEACHER',
  Guest = 'GUEST',
  None = 'NONE',
  Owner = 'OWNER',
  Student = 'STUDENT',
  SubTeacher = 'SUB_TEACHER',
  Teacher = 'TEACHER'
}

export type CoursePublicAccess = BaseModel & {
  __typename?: 'CoursePublicAccess';
  code: Scalars['String']['output'];
  course: Course;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

/** Result containing the public access details for a course */
export type CoursePublicAccessResult = {
  __typename?: 'CoursePublicAccessResult';
  coursePublicAccess: CoursePublicAccess;
};

/** Result containing a course */
export type CourseResult = {
  __typename?: 'CourseResult';
  course: Course;
};

export type CoursesQueryFilter = {
  /** Optional: Filter for course access, default ALL */
  access?: InputMaybe<CourseListAccessFilter>;
  /** Optional: Filter for course status, default ALL */
  status?: InputMaybe<CourseListStatusFilter>;
  /** Optional: Filter for course usage, default ALL */
  usage?: InputMaybe<CourseListUsageFilter>;
};

export type CreateCalendarNoteInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  calendarDayId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
  day: Scalars['String']['input'];
  foregroundColor?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
};

/** Input for creating a course collaboration invite for a specific membership role */
export type CreateCourseCollaborationInput = {
  courseId: Scalars['String']['input'];
  courseMembershipRole: CourseMembershipRole;
};

/** Input for creating a course folder */
export type CreateCourseFolderInput = {
  courseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
};

/** Input that contains all required and optional values for creating a course */
export type CreateCourseInput = {
  /** Background color for the course being created */
  backgroundColor: Scalars['String']['input'];
  /** Optional: Class level age */
  classLevelAge?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Class level key */
  classLevelKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Class level label */
  classLevelLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional: List of days of the week that the course will take place on. [1-7] */
  days?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Foreground color for the course being created */
  foregroundColor: Scalars['String']['input'];
  /** Optional: Language key */
  languageKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Language label */
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Name for the course being created */
  name: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Short name for the course being created */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Subject key */
  subjectKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Subject label */
  subjectLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Id of the template used as a base */
  templateId?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Usage of course, default REGULAR */
  usage?: InputMaybe<UsageType>;
};

/** Input for creating a course material */
export type CreateCourseMaterialInput = {
  contentHtml?: InputMaybe<MaterialContentHtmlInput>;
  /** Id of the folder associated with the material, if null, then it gets added to the courses unsorted folder */
  courseFolderId?: InputMaybe<Scalars['String']['input']>;
  /** The course to which the material should be added to */
  courseId: Scalars['String']['input'];
  /** The duration for the material */
  duration?: InputMaybe<Scalars['Float']['input']>;
  /** The icon for the material */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The ipi request id for the material creation */
  initialIpiRequestId?: InputMaybe<Scalars['String']['input']>;
  /** The name for the material */
  name: Scalars['String']['input'];
  /** If the material was created with the new editor */
  newEditor?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
};

/** Input for creating a library folder */
export type CreateLibraryFolderInput = {
  /** Optional: the color of the folder */
  folderColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Id of the parent folder or null if part of the root */
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
  /** The new position of the folder [-1..N], -1 adds it to the end of the list */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating a material */
export type CreateMaterialInput = {
  contentHtml?: InputMaybe<MaterialContentHtmlInput>;
  /** The duration for the material */
  duration?: InputMaybe<Scalars['Float']['input']>;
  /** Associated external content */
  externalContent?: InputMaybe<ExternalContentInput>;
  /** The icon for the material */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The ipi request id for the material creation */
  initialIpiRequestId?: InputMaybe<Scalars['String']['input']>;
  /** The name for the material */
  name: Scalars['String']['input'];
  /** If the material was created with the new editor */
  newEditor?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
  /** Id of the topic associated with the material, if null, then it gets added to the unsorted topic */
  topicId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStudentAiAssignmentInput = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Input for creating a todo */
export type CreateTodoInput = {
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  text: Scalars['String']['input'];
};

/** Input for creating a topic */
export type CreateTopicInput = {
  /** Associated external content */
  externalContent?: InputMaybe<ExternalContentInput>;
  /** The topics goals */
  goals?: InputMaybe<Scalars['String']['input']>;
  /** The id of the library folder */
  libraryFolderId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
};

/** Input for creating a new topic instance with a topic */
export type CreateTopicInstanceInput = {
  /** The course associated with the topic instance */
  courseId: Scalars['String']['input'];
  /** Defines if the topic instance is shown as expanded or not */
  expanded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Associated external content */
  externalContent?: InputMaybe<ExternalContentInput>;
  /** The topics goals */
  goals?: InputMaybe<Scalars['String']['input']>;
  /** The id of the library folder */
  libraryFolderId?: InputMaybe<Scalars['String']['input']>;
  /** The name for the topic */
  name: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
};

export type Curriculum = BaseModel & {
  __typename?: 'Curriculum';
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type CurriculumContent = BaseModel & {
  __typename?: 'CurriculumContent';
  classLevel: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  curriculum: Curriculum;
  id: Scalars['String']['output'];
  schoolType: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type DeleteInteractiveAssignmentSessionInput = {
  courseId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

/** Result containing a boolean */
export type DoneResult = {
  __typename?: 'DoneResult';
  /** Boolean indicating success or failure */
  done: Scalars['Boolean']['output'];
};

/** Input for fetching due todos within a span of days */
export type DueToDosInput = {
  fromDay: Scalars['String']['input'];
  toDay: Scalars['String']['input'];
};

export type DuplicateItemsInput = {
  itemIds: Array<Scalars['String']['input']>;
  targetTopicId: Scalars['String']['input'];
};

export type DuplicateMaterialsInput = {
  itemIds: Array<Scalars['String']['input']>;
  targetTopicId: Scalars['String']['input'];
};

export type DuplicateTopicsInput = {
  duplicationPosition?: InputMaybe<DuplicationPosition>;
  targetCourseId?: InputMaybe<Scalars['String']['input']>;
  targetFolderId?: InputMaybe<Scalars['String']['input']>;
  topicIds: Array<Scalars['String']['input']>;
};

export enum DuplicationPosition {
  End = 'END',
  Inline = 'INLINE'
}

/** Input that only requires a valid email address */
export type EmailInput = {
  /** Non-empty and valid email address */
  email: Scalars['String']['input'];
};

/** Input for updating  users email notification subscription */
export type EmailNotificationSubscriptionInput = {
  /** Id of the email notification */
  emailNotificationId: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
};

/** Input for signing up with email address only */
export type EmailSignupInput = {
  /** Data policy acceptance indicator */
  dataPolicyAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Non-empty and valid email address */
  email: Scalars['String']['input'];
  /** First name of the user */
  firstName: Scalars['String']['input'];
  /** Last name of the user */
  lastName: Scalars['String']['input'];
  /** Newsletter acceptance indicator */
  newsletterAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** New Password of the user */
  password: Scalars['String']['input'];
  /** The campaign through which the user signed up */
  signupCampaign?: InputMaybe<Scalars['String']['input']>;
  /** The content through which the user signed up */
  signupContent?: InputMaybe<Scalars['String']['input']>;
  /** The medium through which the user signed up */
  signupMedium?: InputMaybe<Scalars['String']['input']>;
  /** The source through which the user signed up */
  signupSource?: InputMaybe<Scalars['String']['input']>;
};

export type EntireUserTimetableInput = {
  inputMode?: TimetableInputMode;
  timetableEntries: Array<TimetableEntryInput>;
  timetableGrid: Array<TimetableGridEntryInput>;
};

export type ExistingCourseMapping = {
  __typename?: 'ExistingCourseMapping';
  courses: Array<Course>;
  externalCourse: ExternalCourse;
  externalId: Scalars['String']['output'];
};

export type ExistingCourseMappingResult = {
  __typename?: 'ExistingCourseMappingResult';
  existingCourseMappings: Array<ExistingCourseMapping>;
};

export type ExternalContent = {
  __typename?: 'ExternalContent';
  externalContentCategory: ExternalContentCategory;
  externalContentType: ExternalContentType;
  externalReferenceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  preview?: Maybe<ExternalContentPreview>;
  primaryUrl?: Maybe<Scalars['String']['output']>;
  rootId?: Maybe<Scalars['String']['output']>;
  secondaryUrl?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceCredentialsExternalId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ExternalContentApiError = {
  __typename?: 'ExternalContentApiError';
  code: ExternalContentErrorCode;
  internalMessage: Scalars['String']['output'];
};

export enum ExternalContentCategory {
  ClassFiles = 'CLASS_FILES',
  ClassNotes = 'CLASS_NOTES',
  Files = 'FILES',
  Notes = 'NOTES'
}

export enum ExternalContentErrorCode {
  ExpiredCredentials = 'EXPIRED_CREDENTIALS',
  NetworkError = 'NETWORK_ERROR',
  UnknownError = 'UNKNOWN_ERROR'
}

export type ExternalContentInput = {
  externalContentCategory: ExternalContentCategory;
  externalContentType: ExternalContentType;
  externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  preview?: InputMaybe<ExternalContentPreviewInput>;
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
  rootId?: InputMaybe<Scalars['String']['input']>;
  secondaryUrl?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  sourceCredentialsExternalId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ExternalContentPreview = {
  __typename?: 'ExternalContentPreview';
  contentId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  primaryUrl?: Maybe<Scalars['String']['output']>;
  secondaryUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ExternalContentPreviewInput = {
  contentId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
  secondaryUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ExternalContentQueryInput = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  externalContentCategory: ExternalContentCategory;
  externalUserCredentialsId?: InputMaybe<Scalars['String']['input']>;
  referenceContent?: InputMaybe<ExternalContentInput>;
};

export type ExternalContentRecentInput = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  externalContentCategory: ExternalContentCategory;
  externalUserCredentialsId?: InputMaybe<Scalars['String']['input']>;
  referenceContent?: InputMaybe<ExternalContentInput>;
};

export type ExternalContentResult = {
  __typename?: 'ExternalContentResult';
  errors?: Maybe<Array<ExternalContentApiError>>;
  externalContent: Array<ExternalContent>;
};

export type ExternalContentSearchInput = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  externalContentCategory: ExternalContentCategory;
  externalUserCredentialsId?: InputMaybe<Scalars['String']['input']>;
  referenceContent?: InputMaybe<ExternalContentInput>;
  search: Scalars['String']['input'];
};

export enum ExternalContentType {
  Container = 'CONTAINER',
  Content = 'CONTENT',
  Group = 'GROUP',
  Root = 'ROOT'
}

export type ExternalCourse = {
  __typename?: 'ExternalCourse';
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  externalUserCredentialsId: Scalars['String']['output'];
  roleInCourse: CourseMembershipRole;
};

export type ExternalCourseMapping = {
  __typename?: 'ExternalCourseMapping';
  course?: Maybe<Course>;
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  externalUserCredentials: ExternalUserCredentials;
  id: Scalars['String']['output'];
  roleInCourse: CourseMembershipRole;
};

/** Result containing external courses for a user */
export type ExternalCoursesResult = {
  __typename?: 'ExternalCoursesResult';
  /** Connected external courses */
  connectedCourses: Array<ConnectedCourse>;
  /** Ignored external courses */
  ignoredCourses: Array<IgnoredCourse>;
  /** Unmapped external courses */
  unmappedCourses: Array<UnmappedCourse>;
};

export enum ExternalIntegrationFeature {
  ClassBookWrite = 'CLASS_BOOK_WRITE',
  ClassFiles = 'CLASS_FILES',
  ClassNotes = 'CLASS_NOTES',
  Courses = 'COURSES',
  CoursesTimetable = 'COURSES_TIMETABLE',
  Files = 'FILES',
  Notes = 'NOTES',
  Sso = 'SSO',
  TenantDefaultLicense = 'TENANT_DEFAULT_LICENSE',
  Timetable = 'TIMETABLE'
}

export type ExternalIntegrationSetting = BaseModel & {
  __typename?: 'ExternalIntegrationSetting';
  additionalIdentifier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  integrationFeatures: Array<ExternalIntegrationFeature>;
  key: Scalars['String']['output'];
  tenant?: Maybe<Tenant>;
};

export type ExternalUserCredentials = BaseModel & {
  __typename?: 'ExternalUserCredentials';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  externalIntegrationSetting: ExternalIntegrationSetting;
  id: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type Feature = BaseModel & {
  __typename?: 'Feature';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  key: Scalars['String']['output'];
  settings?: Maybe<Scalars['JSON']['output']>;
};

export type Folder = BaseModel & SoftDeleteBaseModel & {
  __typename?: 'Folder';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  externalContent?: Maybe<ExternalContent>;
  goals?: Maybe<Scalars['String']['output']>;
  hasOrigin: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastOriginSyncAt?: Maybe<Scalars['DateTime']['output']>;
  libraryFolder?: Maybe<LibraryFolder>;
  name: Scalars['String']['output'];
  originDetails?: Maybe<OriginDetails>;
  owner: User;
  permissions?: Maybe<UserTopicPermission>;
  position: Scalars['Int']['output'];
  syncContentUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  topicCourses?: Maybe<Array<Course>>;
  topicStatistics?: Maybe<TopicStatistics>;
  usage: UsageType;
};

/** Input for copying a folder to a course */
export type FolderCopyInput = {
  /** The id of the folder */
  folderId: Scalars['String']['input'];
  /** The id of the target course */
  targetCourseId: Scalars['String']['input'];
};

/** Input for removing a topic */
export type FolderRemoveInput = {
  /** Optional: Boolean to override the active topic check when deleting an topic */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the topic */
  id: Scalars['String']['input'];
};

/** Result containing a folder */
export type FolderResult = {
  __typename?: 'FolderResult';
  folder: Folder;
};

export type GenerateLinkPreviewInput = {
  /** Id of the material */
  materialId?: InputMaybe<Scalars['String']['input']>;
  /** The url to generate a link preview for */
  url: Scalars['String']['input'];
};

export type GeneratePromptSuggestionInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  courseId: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalConfiguration = {
  __typename?: 'GlobalConfiguration';
  uploadConfiguration: Scalars['JSON']['output'];
};

/** Generic input for queries and mutations by id */
export type IdInput = {
  /** Non-empty id of an object or entity */
  id: Scalars['String']['input'];
};

/** Input that contains all required and optional values for ignoring a course */
export type IgnoreExternalCourseInput = {
  /** External course display name */
  displayName: Scalars['String']['input'];
  /** External course Id */
  externalId: Scalars['String']['input'];
  /** External user credentials id */
  externalUserCredentialsId: Scalars['String']['input'];
};

export type IgnoredCourse = {
  __typename?: 'IgnoredCourse';
  displayName: Scalars['String']['output'];
  externalCourseMappingId: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  externalUserCredentialsId: Scalars['String']['output'];
  roleInCourse: CourseMembershipRole;
};

/** Request containing the original ipi prompt for a material */
export type InitialIpiPromptResult = {
  __typename?: 'InitialIpiPromptResult';
  /** The ipi prompt */
  initialIpiPrompt?: Maybe<Scalars['String']['output']>;
};

/** Result containing a boolean */
export type IntegrationCheckResult = {
  __typename?: 'IntegrationCheckResult';
  /** AuthResult for user connected to temporary external credentials */
  connectedUserAuthResult?: Maybe<AuthResult>;
  integrationToS?: Maybe<Scalars['String']['output']>;
  temporaryExternalCredentials: TemporaryExternalCredentials;
};

export enum InteractiveAssignmentAiFeedbackRating {
  Correct = 'Correct',
  Incorrect = 'Incorrect',
  Partially = 'Partially'
}

export type InteractiveAssignmentOverviewInput = {
  courseId: Scalars['String']['input'];
  materialId: Scalars['String']['input'];
};

export enum InteractiveAssignmentStatus {
  Correct = 'Correct',
  Incorrect = 'Incorrect',
  Partially = 'Partially',
  Started = 'Started'
}

export type InteractiveAssignmentStatusByTopicInput = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  topicId: Scalars['String']['input'];
};

/** Input for invalidating a course collaboration invite for a specific membership role or all */
export type InvalidateCourseCollaborationInput = {
  courseId: Scalars['String']['input'];
  courseMembershipRole?: InputMaybe<CourseMembershipRole>;
};

/** A previous prompt submitted by the current user for IPI */
export type IpiPromptHistoryItem = {
  __typename?: 'IpiPromptHistoryItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  userPrompt: Scalars['String']['output'];
};

/** Recent prompt history for the current user */
export type IpiPromptHistoryResult = {
  __typename?: 'IpiPromptHistoryResult';
  prompts: Array<IpiPromptHistoryItem>;
};

export type IpiPromptSuggestion = {
  __typename?: 'IpiPromptSuggestion';
  icon: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Result containing an item and its accessible item instances */
export type ItemContent = {
  __typename?: 'ItemContent';
  id: Scalars['String']['output'];
  item: Material;
  itemInstances: Array<ItemInstance>;
};

export type ItemInstance = BaseModel & LockableBaseModel & {
  __typename?: 'ItemInstance';
  course?: Maybe<Course>;
  courseContentVisibility?: Maybe<CourseContentVisibility>;
  createdAt: Scalars['DateTime']['output'];
  dates: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  item: Material;
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  topicInstance: TopicInstance;
};

/** Result containing an item instance */
export type ItemInstanceResult = {
  __typename?: 'ItemInstanceResult';
  itemInstance: ItemInstance;
};

/** ReorderInput for items */
export type ItemReorderInput = {
  /** The id of the entity */
  id: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
  /** The id of the topic associated with the item */
  topicId: Scalars['String']['input'];
};

/** Result containing an item */
export type ItemResult = {
  __typename?: 'ItemResult';
  item: Material;
};

/** Input that contains all required and optional values for joining an external course */
export type JoinExistingExternalCoursesInput = {
  /** Internal Teachino course Id */
  courseId?: InputMaybe<Scalars['String']['input']>;
  /** Day of when to check, used for integrations providing courses via timetable */
  day?: InputMaybe<Scalars['String']['input']>;
  /** External course Id */
  externalCourseId?: InputMaybe<Scalars['String']['input']>;
  /** External user credentials id */
  externalUserCredentialsId: Scalars['String']['input'];
};

/** Input providing a key */
export type KeyInput = {
  /** A non-empty key */
  key: Scalars['String']['input'];
};

export enum Language {
  De = 'de',
  En = 'en',
  Fr = 'fr',
  It = 'it'
}

export type LibraryFolder = BaseModel & {
  __typename?: 'LibraryFolder';
  children?: Maybe<Array<LibraryFolder>>;
  createdAt: Scalars['DateTime']['output'];
  folderColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentFolder?: Maybe<LibraryFolder>;
  parents?: Maybe<Array<LibraryFolder>>;
  position: Scalars['Int']['output'];
  user: User;
};

/** Result containing a library folder */
export type LibraryFolderResult = {
  __typename?: 'LibraryFolderResult';
  libraryFolder: LibraryFolder;
};

/** Result containing library meta data */
export type LibraryMetaResult = {
  __typename?: 'LibraryMetaResult';
  totalTopicsCount: Scalars['Float']['output'];
  unsortedTopicsCount: Scalars['Float']['output'];
};

/** Result containing the newest content in the library */
export type LibraryNewestContentResult = {
  __typename?: 'LibraryNewestContentResult';
  id: Scalars['String']['output'];
  materials: Array<Material>;
  topics: Array<Folder>;
};

export type License = BaseModel & {
  __typename?: 'License';
  createdAt: Scalars['DateTime']['output'];
  cycleRenewalAt?: Maybe<Scalars['DateTime']['output']>;
  cycleStartAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  holderType: LicenseHolderType;
  id: Scalars['String']['output'];
  plan: Plan;
  planStartAt?: Maybe<Scalars['DateTime']['output']>;
  tenant: Tenant;
};

export enum LicenseHolderType {
  Tenant = 'TENANT',
  User = 'USER'
}

/** Input for requesting a licensing session checkout with a gateway */
export type LicensingSessionCheckoutInput = {
  billingCycle?: InputMaybe<BillingCycle>;
  discountId?: InputMaybe<Scalars['String']['input']>;
  planKey: Scalars['String']['input'];
  successPath?: InputMaybe<Scalars['String']['input']>;
};

/** Generic input for a limit of results */
export type LimitInput = {
  /** Nullable limit that defaults to 5 */
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type LinkPreviewExtra = {
  __typename?: 'LinkPreviewExtra';
  description?: Maybe<Scalars['String']['output']>;
  iframe?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LockableBaseModel = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Input for login */
export type LoginInput = {
  /** Users password with minimum length according to our policy */
  password: Scalars['String']['input'];
  /** Users username */
  username: Scalars['String']['input'];
};

export enum MailVerificationStatus {
  Email = 'EMAIL',
  Unverified = 'UNVERIFIED'
}

export type Material = BaseModel & SoftDeleteBaseModel & {
  __typename?: 'Material';
  annotationToolToken?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<MaterialContentHtml>;
  contentStatistics?: Maybe<MaterialContentStatistics>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The duration of an item in minutes */
  duration?: Maybe<Scalars['Float']['output']>;
  externalContent?: Maybe<ExternalContent>;
  hasOrigin: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initialIpiRequestId?: Maybe<Scalars['String']['output']>;
  lastOriginSyncAt?: Maybe<Scalars['DateTime']['output']>;
  linkedTopics?: Maybe<Array<Folder>>;
  migratedToMaterial?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  newEditor: Scalars['Boolean']['output'];
  originDetails?: Maybe<OriginDetails>;
  owner: User;
  permissions: UserItemPermission;
  position: Scalars['Float']['output'];
  syncContentUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  topic: Folder;
  updatedAt: Scalars['DateTime']['output'];
  usage: UsageType;
};

export type MaterialAnnotationToolAccess = {
  __typename?: 'MaterialAnnotationToolAccess';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type MaterialContentHtml = {
  __typename?: 'MaterialContentHtml';
  html?: Maybe<Scalars['String']['output']>;
};

/** Input for updating a material */
export type MaterialContentHtmlInput = {
  html?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialContentStatistics = {
  __typename?: 'MaterialContentStatistics';
  fileCount: Scalars['Float']['output'];
  imageCount: Scalars['Float']['output'];
  interactiveAssignmentCount: Scalars['Float']['output'];
  linkCount: Scalars['Float']['output'];
  noteCount: Scalars['Float']['output'];
};

/** Input for copying a material to another folder */
export type MaterialCopyInput = {
  /** The id of the material */
  materialId: Scalars['String']['input'];
  /** The id of the target folder */
  targetFolderId: Scalars['String']['input'];
};

export type MaterialCourse = {
  __typename?: 'MaterialCourse';
  backgroundColor: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  foregroundColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSharedWithStudents: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
};

/** status for all assignments in a material */
export type MaterialInteractiveAssignmentStatus = {
  __typename?: 'MaterialInteractiveAssignmentStatus';
  materialId: Scalars['String']['output'];
  started: Scalars['Float']['output'];
};

/** overview of all interactive assignments for a material */
export type MaterialInteractiveAssignmentsStudentOverview = {
  __typename?: 'MaterialInteractiveAssignmentsStudentOverview';
  assignmentsStatus: Array<AssignmentStatus>;
  lastActivity: Scalars['DateTime']['output'];
  nickname: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

/** Input for moving a material from a topic to another */
export type MaterialMoveInput = {
  /** Optional: Boolean to override the active item check when moving a material */
  forceMove?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the material */
  materialId: Scalars['String']['input'];
  /** The id of the target topic */
  targetTopicId: Scalars['String']['input'];
};

/** ReorderInput for material */
export type MaterialReorderInput = {
  /** The id of the entity */
  id: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
  /** The id of the topic associated with the material */
  topicId: Scalars['String']['input'];
};

/** Result containing a material */
export type MaterialResult = {
  __typename?: 'MaterialResult';
  material: Material;
};

export type MoveCalendarEventInput = {
  calendarDayId: Scalars['String']['input'];
  calendarEventId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
  fromDay: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
  toDay?: InputMaybe<Scalars['String']['input']>;
  type: CalendarEventType;
};

/** Input for updating a library folders position or parent, position is required */
export type MoveLibraryFolderInput = {
  /** The id of the entity */
  id: Scalars['String']['input'];
  /** Id of the parent folder or null if part of the root */
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
};

/** Input for removing multiple topic instances */
export type MultiRemoveTopicInstanceInput = {
  /** Optional: Boolean to override the active item check when deleting a topic instance  */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ids of the topic instances to be removed */
  ids: Array<Scalars['String']['input']>;
};

/** Topic Item Input for moving items from a topic to another */
export type MultiTopicItemMoveInput = {
  /** Optional: Boolean to override the active item check when moving an item */
  forceMove?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ids of the items */
  itemIds: Array<Scalars['String']['input']>;
  /** The id of the originating topic associated with the items */
  originTopicId: Scalars['String']['input'];
  /** The id of the target topic */
  targetTopicId: Scalars['String']['input'];
};

/** Topic Item Input for removing items from a topic */
export type MultiTopicItemRemoveInput = {
  /** Optional: Boolean to override the active item check when deleting an item */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ids of the items */
  itemIds: Array<Scalars['String']['input']>;
  /** The id of the topic associated with the item */
  topicId: Scalars['String']['input'];
};

/** Input for duplicating multiple topics */
export type MultiTopicLibraryFolderDuplicateInput = {
  /** The id of the library folder */
  libraryFolderId?: InputMaybe<Scalars['String']['input']>;
  /** The ids of the topics */
  topicIds: Array<Scalars['String']['input']>;
};

/** Input for moving and removing multiple topics from a folder */
export type MultiTopicLibraryFolderMoveInput = {
  /** The id of the library folder */
  libraryFolderId?: InputMaybe<Scalars['String']['input']>;
  /** The ids of the entities */
  topicIds: Array<Scalars['String']['input']>;
};

/** Topic Material Input for moving materials from a topic to another */
export type MultiTopicMaterialMoveInput = {
  /** Optional: Boolean to override the active item check when moving a material */
  forceMove?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ids of the materials */
  materialIds: Array<Scalars['String']['input']>;
  /** The id of the originating topic associated with the materials */
  originTopicId: Scalars['String']['input'];
  /** The id of the target topic */
  targetTopicId: Scalars['String']['input'];
};

/** Topic Material Input for removing materials from a topic */
export type MultiTopicMaterialRemoveInput = {
  /** Optional: Boolean to override the active item check when deleting a material */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ids of the materials */
  materialIds: Array<Scalars['String']['input']>;
  /** The id of the topic associated with the material */
  topicId: Scalars['String']['input'];
};

/** Input for removing a topic */
export type MultiTopicRemoveInput = {
  /** Optional: Boolean to override the active topic check when deleting an topic */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ids of the topics that should be removed */
  topicIds: Array<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accepts a course collaboration invite via code */
  acceptCourseCollaborationInvite: DoneResult;
  /** Accepts a tenant invite via code */
  acceptTenantInvite: DoneResult;
  /** Adds a new event to the calendar */
  addCalendarEvent: CalendarEventResult;
  /** Adds multiple new events to the calendar */
  addCalendarEvents: CalendarEventListResult;
  /** Adds a new calendar note to the calendar */
  addCalendarNote: CalendarNoteResult;
  /** Adds a course collaborator by id */
  addCollaborator: CourseCollaboratorResult;
  /** takes an itemId then adds it's corresponding itemInstance to the calendar */
  addItemToCalendar: CalendarEventResult;
  /** Adds a new timetable extension to the users timetable */
  addTimetableExtension: TimetableExtensionResult;
  /** Adds one or more topics to one or more courses */
  addTopicsToCourses: DoneResult;
  aiToolTextToSpeech: TextToSpeechLogResult;
  /** Change password using the existing one */
  changePassword: DoneResult;
  /** Endpoint to verify permission for a specific target */
  checkCoursePermission: UserCoursePermission;
  /** Check for external courses that are mapped in our system */
  checkExistingExternalCourses: ExistingCourseMappingResult;
  /** Endpoint to verify permission for a user and tenant */
  checkTenantPermission: UserTenantPermission;
  /** Closes a specific course */
  closeCourse: CourseResult;
  /** Connect external course to internal course */
  connectExternalCourse: DoneResult;
  /** Connects an external account via temporary integration code */
  connectExternalIntegration: DoneResult;
  /** Connects a course to a template if not already connected and adds all the content and ai settings */
  connectTemplateToCourse: DoneResult;
  /** Copies a folder to a course */
  copyFolderToCourse: DoneResult;
  /** Copies a material to another folder */
  copyMaterialToFolder: DoneResult;
  /** Created AI settings for a course */
  createAiSettingsForCourse: AiSettingsResult;
  /** Creates a course associated to a tenant */
  createCourse: CourseResult;
  /** Creates a public invite for a specific course */
  createCourseCollaborationInvite: CourseInviteResult;
  /** Create a new course folder */
  createCourseFolder: CourseFolderResult;
  /** Create a new course material */
  createCourseMaterial: CourseMaterialResult;
  /** Creates a public access link/code for a course */
  createCoursePublicAccess: CoursePublicAccessResult;
  /** Create a new library folder */
  createLibraryFolder: LibraryFolderResult;
  /** Create a new material */
  createMaterial: MaterialResult;
  createStudentAiAssignment: StudentAiAssignmentResult;
  /** Create a new todo */
  createToDo: TodoResult;
  /** Create a new topic */
  createTopic: TopicResult;
  /** Creates a new topic and topic instance inside a course */
  createTopicInstance: TopicInstanceResult;
  deleteInteractiveAssignmentSession: DoneResult;
  /** Delete an existing todo */
  deleteToDo: DoneResult;
  /** Disconnect external course from internal course */
  disconnectExternalCourse: DoneResult;
  /** Disconnects an external account via id */
  disconnectExternalIntegration: DoneResult;
  /** Duplicates items to a topic */
  duplicateItems: Array<Material>;
  /** Duplicates materials to a topic */
  duplicateMaterials: Array<Material>;
  /** Duplicates topics to user library, optionally to course as well */
  duplicateTopics: Array<Folder>;
  /** Duplicates multiple topics into another folder */
  duplicateTopicsToFolder: DoneResult;
  /** Signup with email only */
  emailSignup: AuthResult;
  /** Exports a users library content to a zip file */
  exportLibraryContent: DoneResult;
  /** Updates an item snippet */
  generateLinkPreview: LinkPreviewExtra;
  /** Generate ipi prompt suggestions based on a folder and/or course */
  generatePromptSuggestions: Array<IpiPromptSuggestion>;
  /** Ignore external course */
  ignoreExternalCourse: DoneResult;
  /** Load the inital ipi prompt for a material, if one exists */
  initialMaterialIpiPrompt: InitialIpiPromptResult;
  /** Checks temporary integration code */
  integrationCheck: IntegrationCheckResult;
  /** Invalidates a public invite for a specific course */
  invalidateCourseCollaborationInvite: DoneResult;
  /** Invalidates public access to a course */
  invalidateCoursePublicAccess: DoneResult;
  /** Join external mapped course */
  joinExistingExternalCourse: DoneResult;
  /** Normal user login */
  login: AuthResult;
  /** Migrates a material fom the old editor to the new one, only needs ID and contentHtml */
  migrateMaterial: DoneResult;
  /** Move an event between calendar days */
  moveCalendarEvent: CalendarEventResult;
  /** Moves items from one topic to another */
  moveItems: DoneResult;
  /** Moves a library folder between folders or reorders it inside a folder */
  moveLibraryFolder: LibraryFolderResult;
  /** Moves a material from one topic to another */
  moveMaterial: DoneResult;
  /** Moves materials from one topic to another */
  moveMaterials: DoneResult;
  /** Moves a topic, from and to folders, or inside folders */
  moveTopic: TopicResult;
  /** Moves multiple topics, from and to folders, or inside folders */
  moveTopics: DoneResult;
  /** Update a users timetable in a type safe manner */
  pushEntireUserTimetable: DoneResult;
  /** Push Lesson To External Source */
  pushLessonToExternalSource: DoneResult;
  /** Push an onboarding progress object for a user */
  pushOnboardingProgress: DoneResult;
  /** Rates an Ipi Request */
  rateIpiRequest: DoneResult;
  /** Refresh a JWT token using a refresh token */
  refreshToken: AuthResult;
  /** Removes an event from the calendar */
  removeCalendarEvent: DoneResult;
  /** Removes a course collaborator from the course */
  removeCollaborator: DoneResult;
  /** Removes a folder from a course */
  removeCourseFolder: DoneResult;
  /** Removes a folder */
  removeFolder: DoneResult;
  /** Remove an item associated with a topic */
  removeItem: DoneResult;
  /** Removes items associated with a topic */
  removeItems: DoneResult;
  /** Remove a library folder */
  removeLibraryFolder: DoneResult;
  /** Remove an material associated with a topic */
  removeMaterial: DoneResult;
  /** Removes materials associated with a topic */
  removeMaterials: DoneResult;
  removeStudentAiAssignment: DoneResult;
  /** Removes an existing timetable extension */
  removeTimetableExtension: DoneResult;
  /** Remove a topic */
  removeTopic: DoneResult;
  /** Removes a topic instance from the course */
  removeTopicInstance: DoneResult;
  /** Removes many topic instances from the course */
  removeTopicInstances: DoneResult;
  /** Remove multiple topics */
  removeTopics: DoneResult;
  /** Reorders a course for the user */
  reorderCourse: DoneResult;
  /** Reorders a folder within a course */
  reorderCourseFolder: CourseFolderResult;
  /** Reorders an item within a topic */
  reorderItem: ItemResult;
  /** Reorders a material within a folder */
  reorderMaterial: MaterialResult;
  /** Reorders a topic */
  reorderTopic: TopicResult;
  /** Reorders a topic instance within a course */
  reorderTopicInstance: TopicInstanceResult;
  /** Requests an url to a checkout session for a plan */
  requestCheckoutSessionData: PaymentGatewayManagementData;
  /** Requests an url to the payment gateway portal */
  requestPaymentGatewayPortalData: PaymentGatewayManagementData;
  /** Request email code for user password reset */
  requestUserPasswordReset: DoneResult;
  requestVerificationEmail: DoneResult;
  /** Sets the course first feature toggle for a user */
  setCourseFirstFeatureToggle: DoneResult;
  /** Signup via SSO */
  ssoSignup: AuthResult;
  /** Sync a course with all it's content from the originating template */
  syncCourseWithTemplate: DoneResult;
  /** Sync an item with the originating template */
  syncItemWithTemplate: DoneResult;
  /** Sync a topic with all its items from the originating template */
  syncTopicWithTemplate: DoneResult;
  /** Changes the visibility of an item instance for non-teacher parties */
  toggleCourseMaterialVisibility: DoneResult;
  /** Changes the visibility of an item instance for non-teacher parties */
  toggleItemInstanceVisibility: ItemInstanceResult;
  toggleStudentAiAssignment: StudentAiAssignmentResult;
  /** UnIgnore external course */
  unIgnoreExternalCourse: DoneResult;
  /** updates AI settings for a course */
  updateAiSettingsForCourse: AiSettingsResult;
  /** Updates a calendar note */
  updateCalendarNote: CalendarNoteResult;
  /** Updates a course collaborator within the course */
  updateCollaborator: DoneResult;
  /** Updates a specific course */
  updateCourse: CourseResult;
  /** Updates a specific folder */
  updateFolder: FolderResult;
  /** Update a specific item */
  updateItem: ItemResult;
  /** Update a specific library folder */
  updateLibraryFolder: LibraryFolderResult;
  /** Update a specific material */
  updateMaterial: MaterialResult;
  updateStudentAiAssignment: StudentAiAssignmentResult;
  /** Updates an existing timetable extension */
  updateTimetableExtension: TimetableExtensionResult;
  /** Create a new todo */
  updateToDo: TodoResult;
  /** Update a specific topic */
  updateTopic: TopicResult;
  /** Updates a topic instance */
  updateTopicInstance: TopicInstanceResult;
  /** Updates the users data, excluding the users email address */
  updateUser: UserResult;
  /** Updates only the users email address, requires email verification after the update */
  updateUserEmail: UserResult;
  /** Update users subscription status for an email notification */
  updateUserEmailNotificationSubscription: DoneResult;
  /** Updates the users preferences */
  updateUserPreferences: DoneResult;
  /** Verifies a requesting users email address via a code */
  verifyUserEmail: UserResult;
  /** Verify email-code combination and set the new password for the user in the case of success */
  verifyUserPasswordReset: AuthResult;
};


export type MutationAcceptCourseCollaborationInviteArgs = {
  codeInput: CodeInput;
};


export type MutationAcceptTenantInviteArgs = {
  codeInput: CodeInput;
};


export type MutationAddCalendarEventArgs = {
  addCalendarEventInput: AddCalendarEventInput;
};


export type MutationAddCalendarEventsArgs = {
  addCalendarEventsInput: AddCalendarEventsInput;
};


export type MutationAddCalendarNoteArgs = {
  createCalendarNoteInput: CreateCalendarNoteInput;
};


export type MutationAddCollaboratorArgs = {
  addCourseCollaboratorInput: AddCourseCollaboratorInput;
};


export type MutationAddItemToCalendarArgs = {
  addItemToCalendarInput: AddItemToCalendarInput;
};


export type MutationAddTimetableExtensionArgs = {
  addTimetableExtensionInput: AddTimetableExtensionInput;
};


export type MutationAddTopicsToCoursesArgs = {
  addTopicsCoursesInput: AddTopicsCoursesInput;
};


export type MutationAiToolTextToSpeechArgs = {
  textToSpeechInput: TextToSpeechInput;
};


export type MutationChangePasswordArgs = {
  changePasswordInput: ChangePasswordInput;
};


export type MutationCheckCoursePermissionArgs = {
  courseId: Scalars['String']['input'];
};


export type MutationCheckExistingExternalCoursesArgs = {
  checkExistingExternalCoursesInput: CheckExistingExternalCoursesInput;
};


export type MutationCheckTenantPermissionArgs = {
  tenantId: Scalars['String']['input'];
};


export type MutationCloseCourseArgs = {
  courseIdInput: IdInput;
};


export type MutationConnectExternalCourseArgs = {
  connectExternalCourseInput: ConnectExternalCourseInput;
};


export type MutationConnectExternalIntegrationArgs = {
  codeInput: CodeInput;
};


export type MutationConnectTemplateToCourseArgs = {
  templateCourseConnectInput: TemplateCourseConnectInput;
};


export type MutationCopyFolderToCourseArgs = {
  folderCopyInput: FolderCopyInput;
};


export type MutationCopyMaterialToFolderArgs = {
  materialCopyInput: MaterialCopyInput;
};


export type MutationCreateAiSettingsForCourseArgs = {
  createAiSettingsInput: AiSettingsInput;
};


export type MutationCreateCourseArgs = {
  createCourseInput: CreateCourseInput;
};


export type MutationCreateCourseCollaborationInviteArgs = {
  createCourseCollaborationInput: CreateCourseCollaborationInput;
};


export type MutationCreateCourseFolderArgs = {
  createCourseFolderInput: CreateCourseFolderInput;
};


export type MutationCreateCourseMaterialArgs = {
  createCourseMaterialInput: CreateCourseMaterialInput;
};


export type MutationCreateCoursePublicAccessArgs = {
  courseIdInput: IdInput;
};


export type MutationCreateLibraryFolderArgs = {
  createLibraryFolderInput: CreateLibraryFolderInput;
};


export type MutationCreateMaterialArgs = {
  createMaterialInput: CreateMaterialInput;
};


export type MutationCreateStudentAiAssignmentArgs = {
  createStudentAiAssignmentInput: CreateStudentAiAssignmentInput;
};


export type MutationCreateToDoArgs = {
  createTodoInput: CreateTodoInput;
};


export type MutationCreateTopicArgs = {
  createTopicInput: CreateTopicInput;
};


export type MutationCreateTopicInstanceArgs = {
  createTopicInstanceInput: CreateTopicInstanceInput;
};


export type MutationDeleteInteractiveAssignmentSessionArgs = {
  deleteInteractiveAssignmentSessionInput: DeleteInteractiveAssignmentSessionInput;
};


export type MutationDeleteToDoArgs = {
  idInput: IdInput;
};


export type MutationDisconnectExternalCourseArgs = {
  externalCourseMappingIdInput: IdInput;
};


export type MutationDisconnectExternalIntegrationArgs = {
  externalUserCredentialsIdInput: IdInput;
};


export type MutationDuplicateItemsArgs = {
  duplicateItemsInput: DuplicateItemsInput;
};


export type MutationDuplicateMaterialsArgs = {
  duplicateMaterialsInput: DuplicateMaterialsInput;
};


export type MutationDuplicateTopicsArgs = {
  duplicateTopicsInput: DuplicateTopicsInput;
};


export type MutationDuplicateTopicsToFolderArgs = {
  duplicateTopicsInput: MultiTopicLibraryFolderDuplicateInput;
};


export type MutationEmailSignupArgs = {
  emailSignUpInput: EmailSignupInput;
};


export type MutationGenerateLinkPreviewArgs = {
  generateLinkPreviewInput: GenerateLinkPreviewInput;
};


export type MutationGeneratePromptSuggestionsArgs = {
  generatePromptSuggestionInput: GeneratePromptSuggestionInput;
};


export type MutationIgnoreExternalCourseArgs = {
  ignoreExternalCourseInput: IgnoreExternalCourseInput;
};


export type MutationInitialMaterialIpiPromptArgs = {
  initialMaterialIpiRequestInput: IdInput;
};


export type MutationIntegrationCheckArgs = {
  codeInput: CodeInput;
};


export type MutationInvalidateCourseCollaborationInviteArgs = {
  invalidateCourseCollaborationInput: InvalidateCourseCollaborationInput;
};


export type MutationInvalidateCoursePublicAccessArgs = {
  courseIdInput: IdInput;
};


export type MutationJoinExistingExternalCourseArgs = {
  joinExistingExternalCoursesInput: JoinExistingExternalCoursesInput;
};


export type MutationLoginArgs = {
  loginInput: LoginInput;
};


export type MutationMigrateMaterialArgs = {
  migrateMaterialInput: UpdateMaterialInput;
};


export type MutationMoveCalendarEventArgs = {
  moveCalendarEventInput: MoveCalendarEventInput;
};


export type MutationMoveItemsArgs = {
  multiTopicItemMoveInput: MultiTopicItemMoveInput;
};


export type MutationMoveLibraryFolderArgs = {
  moveLibraryFolderInput: MoveLibraryFolderInput;
};


export type MutationMoveMaterialArgs = {
  materialMoveInput: MaterialMoveInput;
};


export type MutationMoveMaterialsArgs = {
  multiTopicMaterialMoveInput: MultiTopicMaterialMoveInput;
};


export type MutationMoveTopicArgs = {
  moveTopicInput: TopicLibraryFolderMoveInput;
};


export type MutationMoveTopicsArgs = {
  moveTopicInput: MultiTopicLibraryFolderMoveInput;
};


export type MutationPushEntireUserTimetableArgs = {
  entireUserTimetableInput: EntireUserTimetableInput;
};


export type MutationPushLessonToExternalSourceArgs = {
  pushLessonToExternalSourceInput: PushLessonToExternalSourceInput;
};


export type MutationPushOnboardingProgressArgs = {
  pushOnboardingProgressInput: PushOnboardingProgressInput;
};


export type MutationRateIpiRequestArgs = {
  rateIpiRequestInput: RateIpiRequestInput;
};


export type MutationRefreshTokenArgs = {
  refreshTokenInput: RefreshTokenInput;
};


export type MutationRemoveCalendarEventArgs = {
  removeCalendarEventInput: RemoveCalendarEventInput;
};


export type MutationRemoveCollaboratorArgs = {
  removeCourseCollaboratorInput: RemoveCourseCollaboratorInput;
};


export type MutationRemoveCourseFolderArgs = {
  removeCourseFolderInput: RemoveCourseFolderInput;
};


export type MutationRemoveFolderArgs = {
  folderRemoveInput: FolderRemoveInput;
};


export type MutationRemoveItemArgs = {
  topicItemRemoveInput: TopicItemRemoveInput;
};


export type MutationRemoveItemsArgs = {
  multiTopicItemRemoveInput: MultiTopicItemRemoveInput;
};


export type MutationRemoveLibraryFolderArgs = {
  libraryFolderRemoveInput: IdInput;
};


export type MutationRemoveMaterialArgs = {
  topicMaterialRemoveInput: TopicMaterialRemoveInput;
};


export type MutationRemoveMaterialsArgs = {
  multiTopicMaterialRemoveInput: MultiTopicMaterialRemoveInput;
};


export type MutationRemoveStudentAiAssignmentArgs = {
  removeStudentAiAssignmentInput: IdInput;
};


export type MutationRemoveTimetableExtensionArgs = {
  removeTimetableExtensionInput: IdInput;
};


export type MutationRemoveTopicArgs = {
  topicRemoveInput: TopicRemoveInput;
};


export type MutationRemoveTopicInstanceArgs = {
  removeTopicInstanceInput: RemoveTopicInstanceInput;
};


export type MutationRemoveTopicInstancesArgs = {
  removeTopicInstancesInput: MultiRemoveTopicInstanceInput;
};


export type MutationRemoveTopicsArgs = {
  multiTopicRemoveInput: MultiTopicRemoveInput;
};


export type MutationReorderCourseArgs = {
  reorderInput: ReorderInput;
};


export type MutationReorderCourseFolderArgs = {
  courseFolderReorderInput: CourseFolderReorderInput;
};


export type MutationReorderItemArgs = {
  itemReorderInput: ItemReorderInput;
};


export type MutationReorderMaterialArgs = {
  materialReorderInput: MaterialReorderInput;
};


export type MutationReorderTopicArgs = {
  reorderTopicInput: ReorderInput;
};


export type MutationReorderTopicInstanceArgs = {
  reorderTopicInstanceInput: ReorderInput;
};


export type MutationRequestCheckoutSessionDataArgs = {
  licensingSessionCheckoutInput: LicensingSessionCheckoutInput;
};


export type MutationRequestPaymentGatewayPortalDataArgs = {
  paymentGatewayPortalInput: PaymentGatewayPortalInput;
};


export type MutationRequestUserPasswordResetArgs = {
  emailInput: EmailInput;
};


export type MutationSetCourseFirstFeatureToggleArgs = {
  setCourseFirstFeatureToggleInput: SetCourseFirstFeatureToggleInput;
};


export type MutationSsoSignupArgs = {
  ssoSignupInput: CodeInput;
};


export type MutationSyncCourseWithTemplateArgs = {
  courseTemplateSyncInput: TemplateSyncInput;
};


export type MutationSyncItemWithTemplateArgs = {
  itemTemplateSyncInput: TemplateSyncInput;
};


export type MutationSyncTopicWithTemplateArgs = {
  topicTemplateSyncInput: TemplateSyncInput;
};


export type MutationToggleCourseMaterialVisibilityArgs = {
  visibilityToggleInput: CourseMaterialVisibilityToggleInput;
};


export type MutationToggleItemInstanceVisibilityArgs = {
  contentVisibilityToggleInput: CourseContentVisibilityToggleInput;
};


export type MutationToggleStudentAiAssignmentArgs = {
  toggleStudentAiAssignmentInput: ToggleStudentAiAssignmentInput;
};


export type MutationUnIgnoreExternalCourseArgs = {
  externalCourseMappingIdInput: IdInput;
};


export type MutationUpdateAiSettingsForCourseArgs = {
  updateAiSettingsInput: AiSettingsInput;
};


export type MutationUpdateCalendarNoteArgs = {
  updateCalendarNoteInput: UpdateCalendarNoteInput;
};


export type MutationUpdateCollaboratorArgs = {
  updateCourseCollaboratorInput: UpdateCourseCollaboratorInput;
};


export type MutationUpdateCourseArgs = {
  updateCourseInput: UpdateCourseInput;
};


export type MutationUpdateFolderArgs = {
  updateFolderInput: UpdateFolderInput;
};


export type MutationUpdateItemArgs = {
  updateItemInput: UpdateItemInput;
};


export type MutationUpdateLibraryFolderArgs = {
  updateLibraryFolderInput: UpdateLibraryFolderInput;
};


export type MutationUpdateMaterialArgs = {
  updateMaterialInput: UpdateMaterialInput;
};


export type MutationUpdateStudentAiAssignmentArgs = {
  updateStudentAiAssignmentInput: UpdateStudentAiAssignmentInput;
};


export type MutationUpdateTimetableExtensionArgs = {
  updateTimetableExtensionInput: UpdateTimetableExtensionInput;
};


export type MutationUpdateToDoArgs = {
  updateTodoInput: UpdateTodoInput;
};


export type MutationUpdateTopicArgs = {
  updateTopicInput: UpdateTopicInput;
};


export type MutationUpdateTopicInstanceArgs = {
  updateTopicInstanceInput: UpdateTopicInstanceInput;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateUserEmailArgs = {
  emailInput: EmailInput;
};


export type MutationUpdateUserEmailNotificationSubscriptionArgs = {
  emailNotificationSubscriptionInput: EmailNotificationSubscriptionInput;
};


export type MutationUpdateUserPreferencesArgs = {
  updateUserPreferencesInput: UpdateUserPreferencesInput;
};


export type MutationVerifyUserEmailArgs = {
  verificationInput: VerificationInput;
};


export type MutationVerifyUserPasswordResetArgs = {
  verifyUserPasswordResetInput: VerifyUserPasswordResetInput;
};

export type OriginDetails = {
  __typename?: 'OriginDetails';
  contentChanged: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  newAdditions: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usage: UsageType;
};

export enum PaymentGateway {
  Stripe = 'STRIPE'
}

/** Result containing a gateway management url */
export type PaymentGatewayManagementData = {
  __typename?: 'PaymentGatewayManagementData';
  gateway: PaymentGateway;
  url?: Maybe<Scalars['String']['output']>;
};

/** Input for requesting a payment gateway management session */
export type PaymentGatewayPortalInput = {
  licenseId: Scalars['String']['input'];
};

export type PeriodCourse = {
  __typename?: 'PeriodCourse';
  backgroundColor: Scalars['String']['output'];
  external: Scalars['Boolean']['output'];
  foregroundColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export enum PeriodType {
  Additional = 'ADDITIONAL',
  Cancellation = 'CANCELLATION',
  Change = 'CHANGE',
  Other = 'OTHER',
  Regular = 'REGULAR',
  Substitution = 'SUBSTITUTION',
  TeacherRemoved = 'TEACHER_REMOVED',
  Vacation = 'VACATION'
}

export type Plan = BaseModel & {
  __typename?: 'Plan';
  billingCycle: BillingCycle;
  createdAt: Scalars['DateTime']['output'];
  defaultForKey: Scalars['Boolean']['output'];
  defaultPrice?: Maybe<Scalars['Float']['output']>;
  defaultPriceMonth?: Maybe<Scalars['Float']['output']>;
  features: Array<Feature>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: PlanType;
};

export enum PlanType {
  Expired = 'EXPIRED',
  Free = 'FREE',
  Friends = 'FRIENDS',
  Paid = 'PAID',
  Trial = 'TRIAL'
}

export type PublicCalendarDaysInput = {
  /** A non-empty code */
  code: Scalars['String']['input'];
  fromDay: Scalars['String']['input'];
  toDay: Scalars['String']['input'];
};

export type PublicIdInput = {
  /** A non-empty code */
  code: Scalars['String']['input'];
  /** Non-empty id of an object or entity */
  id: Scalars['String']['input'];
};

/** Input that contains all required and optional values for pushing lesson to external source */
export type PushLessonToExternalSourceInput = {
  /** Internal course id */
  courseId?: InputMaybe<Scalars['String']['input']>;
  /** Day of the calendar */
  date: Scalars['String']['input'];
  /** text contains the plan for the lesson */
  lessonTopic: Scalars['String']['input'];
};

export type PushOnboardingProgressInput = {
  progress?: InputMaybe<Scalars['JSON']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Fetches a teachino ai area based on an id */
  aiArea: TeachinoAiArea;
  /** Gets the ai-settings of a course */
  aiSettings?: Maybe<AiSettings>;
  /** Fetches a single Task */
  aiTask: TeachinoAiTask;
  /** history for one student for a chatbot assignment */
  assignmentChatbotHistory?: Maybe<AssignmentChatbotHistory>;
  /** list of chatbot assignments for a material */
  assignmentChatbotsForMaterial: Array<AssignmentChatbot>;
  /** history for one student for an assignment open question */
  assignmentOpenQuestionHistory?: Maybe<AssignmentOpenQuestionHistory>;
  /** list of assignment open questions for a material */
  assignmentOpenQuestionsForMaterial: Array<AssignmentOpenQuestion>;
  /** Fetches a list of courses that do not contain the specified topic */
  availableCoursesToAddTopic: Array<Course>;
  /** Fetches calendar events for a set of days of a specific course */
  calendarDays: Array<CourseCalendarDay>;
  /** Fetches a config object */
  config: Configuration;
  /** Gets all country states grouped by country */
  countriesWithStates: Array<CountryStateCombo>;
  /** Fetches detailed data for a specific course */
  course: Course;
  /** Fetches calendar events for a set of days of a specific course */
  courseCalendarDays: Array<CourseCalendarDay>;
  /** Fetches the course collaborators */
  courseCollaborators: Array<CourseCollaborator>;
  /** Returns the folders for a course, including the folder structure and the materials within each folder */
  courseFolders: Array<CourseFolder>;
  /** Fetches the course invitation preview */
  courseInvitePreview: CourseInvitePreview;
  /** Fetches the course invitations for a course. If no course membership role is provided, all invitations are fetched. */
  courseInvites?: Maybe<Array<CourseInvite>>;
  /** Fetches the public access details for a course */
  coursePublicAccess?: Maybe<CoursePublicAccess>;
  /** Fetches a list of courses for a specific item */
  coursesForItem: Array<Course>;
  /** Fetches a list of courses for a specific itemInstance */
  coursesForItemInstance: Array<Course>;
  coursesForMaterial: Array<MaterialCourse>;
  /** Fetches the courses a topic belongs to */
  coursesForTopic: Array<Course>;
  currentLicense: License;
  curriculumContent: Array<CurriculumContent>;
  curriculums: Array<Curriculum>;
  /** Fetches due todos for a set of days */
  dueToDos: Array<ToDo>;
  /** Fetches topic instances for a topic in all accessible courses */
  editableTopicInstancesForTopic: Array<TopicInstance>;
  /** Gets the export tree for a user */
  exportTree: Array<LibraryFolder>;
  /** Fetches external content for an integration */
  externalContent: ExternalContentResult;
  /** Fetches user external courses */
  externalCourses: ExternalCoursesResult;
  /** Gets all external user credentials for a user */
  externalIntegrations: Array<ExternalUserCredentials>;
  globalSubjects: Array<Subject>;
  /** overview of all interactive assignments for a material */
  interactiveAssignmentsOverview: Array<MaterialInteractiveAssignmentsStudentOverview>;
  /** Gets the materials of a topic */
  interactiveAssignmentsStatusByTopic: Array<MaterialInteractiveAssignmentStatus>;
  /** Fetches detailed data for a specific item */
  item: Material;
  /** Gets the item instances for a course */
  itemInstances: Array<ItemInstance>;
  /** Gets the items of a topic */
  items: Array<Material>;
  /** Gets a library folder for a user */
  libraryFolder: LibraryFolder;
  /** Gets the library folders inside the users library */
  libraryFolders: Array<LibraryFolder>;
  /** Fetches meta data for a users library */
  libraryMeta: LibraryMetaResult;
  /** Gets the newest materials and topics created by the user */
  libraryNewestContent: LibraryNewestContentResult;
  licenses: Array<License>;
  /** Gets a single material */
  material: Material;
  /** Fetches the Pathfindr annotation-tool token for a material the user can access */
  materialAnnotationToolAccess?: Maybe<MaterialAnnotationToolAccess>;
  /** Gets the materials of a topic */
  materials: Array<Material>;
  /** Gets the user data for the user making the request */
  me: User;
  /** Fetches the list of courses that the user making the request has access to */
  myCourses: Array<Course>;
  /** Returns recent IPI prompts for the current user */
  myIpiPromptHistory: IpiPromptHistoryResult;
  /** Fetches the tenants a user has access to */
  myTenants: Array<Tenant>;
  /** Fetches an external content preview if possible */
  previewExternalContent?: Maybe<ExternalContentPreview>;
  /** Fetches a public course by access code */
  publicCourse?: Maybe<Course>;
  /** Fetches a public courses calendar days */
  publicCourseCalendarDays: Array<CourseCalendarDay>;
  /** Fetches the public course license features by access code */
  publicCourseFeatures: Array<Feature>;
  /** Returns the public and visible folders for a course, including the folder meta and the publicly visible materials within each folder */
  publicCourseFolders: Array<CourseFolder>;
  /** Fetches a specific item of a public course by item id and access code */
  publicItem: Material;
  /** Fetches a specific item instance of a public course by item instance id and access code */
  publicItemInstance: ItemInstance;
  /** Fetches item instances of a topic instance of a public course by topic instance id and access code */
  publicItemInstances: Array<ItemInstance>;
  /** Fetches a specific item of a public course by item id and access code */
  publicMaterial: Material;
  /** Fetches the Pathfindr annotation-tool token for a public material by item id and access code */
  publicMaterialAnnotationToolAccess?: Maybe<MaterialAnnotationToolAccess>;
  publicStudentAiAssignment: StudentAiAssignment;
  /** Fetches detailed data for a specific topic by topic id and access code */
  publicTopic: Folder;
  /** Fetches topic instances of a public course by courseId and access code */
  publicTopicInstances: Array<TopicInstance>;
  /** Fetches recent external content for an integration and content type */
  recentExternalContent: ExternalContentResult;
  /** Returns all school types for a country */
  schoolTypes: Array<SchoolType>;
  /** Searches for item instances in a course by string */
  searchContent: Array<Content>;
  /** Searches external content titles */
  searchExternalContent: ExternalContentResult;
  studentAiAssignment: StudentAiAssignment;
  studentAiAssignments: Array<StudentAiAssignment>;
  studentAiTemplate: StudentAiTemplate;
  studentAiTemplates: Array<StudentAiTemplate>;
  /** history for one student for an assignment open question */
  studentAssignmentOpenQuestionHistory?: Maybe<StudentAssignmentOpenQuestionHistory>;
  /** Gets the support token for logged in user */
  supportToken: SupportTokenResult;
  /** Gets all school years for a tenant that are not in the past */
  tenantEditableSchoolYears: Array<SchoolYear>;
  /** Fetches the tenant invitation preview */
  tenantInvitePreview: TenantInvitePreview;
  tenantMembers: Array<TenantMember>;
  /** Gets the user data for the user making the request */
  timetableExtension: TimetableExtension;
  /** Gets the user data for the user making the request */
  timetableExtensions: Array<TimetableExtension>;
  /** Timetable across a timeframe for a course */
  timetableForCourse: Array<TimetableDay>;
  /** Timetable across a timeframe for a user */
  timetableForUser: TimetableDayResult;
  /** Timetable periods for a course around provided dateTime */
  timetablePeriodAlternativesForCourse: Array<TimetablePeriod>;
  /** Gets a users timetable structure */
  timetableStructure: Timetable;
  /** Fetches a list of todos, either done or not */
  toDos: Array<ToDo>;
  /** Fetches detailed data for a specific topic */
  topic: Folder;
  /** Gets the topic and its user accessible content */
  topicContent: TopicContent;
  /** returns a topic instance */
  topicInstance: TopicInstance;
  /** Fetch a topic instance for a topic in a course */
  topicInstanceForTopicInCourse: TopicInstance;
  /** Gets all topic instances for a course */
  topicInstances: Array<TopicInstance>;
  /** Gets the topics inside the users library, can be filtered */
  topics: Array<Folder>;
  /** Fetches calendar events for a set of days of a specific course */
  userCalendarDays: Array<UserCalendarDay>;
  /** Fetches the users email notifications subscriptions */
  userEmailNotificationSubscriptions: Array<UserEmailNotificationSubscription>;
  userPlans: Array<Plan>;
};


export type QueryAiAreaArgs = {
  aiAreaInput: IdInput;
};


export type QueryAiSettingsArgs = {
  courseIdInput: IdInput;
};


export type QueryAiTaskArgs = {
  taskIdInput: IdInput;
};


export type QueryAssignmentChatbotHistoryArgs = {
  assignmentChatbotHistoryInput: AssignmentChatbotHistoryInput;
};


export type QueryAssignmentChatbotsForMaterialArgs = {
  materialIdInput: IdInput;
};


export type QueryAssignmentOpenQuestionHistoryArgs = {
  assignmentOpenQuestionHistoryInput: AssignmentOpenQuestionHistoryInput;
};


export type QueryAssignmentOpenQuestionsForMaterialArgs = {
  materialIdInput: IdInput;
};


export type QueryAvailableCoursesToAddTopicArgs = {
  topicIdInput: IdInput;
};


export type QueryCalendarDaysArgs = {
  calendarDaysInput: CourseCalendarDaysInput;
};


export type QueryCourseArgs = {
  courseIdInput: IdInput;
};


export type QueryCourseCalendarDaysArgs = {
  calendarDaysInput: CourseCalendarDaysInput;
};


export type QueryCourseCollaboratorsArgs = {
  courseIdInput: IdInput;
};


export type QueryCourseFoldersArgs = {
  courseIdInput: IdInput;
};


export type QueryCourseInvitePreviewArgs = {
  codeInput: CodeInput;
};


export type QueryCourseInvitesArgs = {
  courseInvitesQueryInput: CourseInvitesQueryInput;
};


export type QueryCoursePublicAccessArgs = {
  courseIdInput: IdInput;
};


export type QueryCoursesForItemArgs = {
  itemIdInput: IdInput;
};


export type QueryCoursesForItemInstanceArgs = {
  itemInstanceIdInput: IdInput;
};


export type QueryCoursesForMaterialArgs = {
  materialIdInput: IdInput;
};


export type QueryCoursesForTopicArgs = {
  topicIdInput: IdInput;
};


export type QueryCurriculumContentArgs = {
  curriculumIdInput: IdInput;
};


export type QueryDueToDosArgs = {
  dueToDosInput: DueToDosInput;
};


export type QueryEditableTopicInstancesForTopicArgs = {
  topicIDInput: IdInput;
};


export type QueryExternalContentArgs = {
  externalContentQueryInput: ExternalContentQueryInput;
};


export type QueryInteractiveAssignmentsOverviewArgs = {
  interactiveAssignmentOverviewInput: InteractiveAssignmentOverviewInput;
};


export type QueryInteractiveAssignmentsStatusByTopicArgs = {
  interactiveAssignmentStatusByTopicInput: InteractiveAssignmentStatusByTopicInput;
};


export type QueryItemArgs = {
  itemIdInput: IdInput;
};


export type QueryItemInstancesArgs = {
  topicInstanceIdInput: IdInput;
};


export type QueryItemsArgs = {
  topicIdInput: IdInput;
};


export type QueryLibraryFolderArgs = {
  libraryFolderIdInput: IdInput;
};


export type QueryLibraryNewestContentArgs = {
  libraryNewestContentInput: LimitInput;
};


export type QueryMaterialArgs = {
  materialIdInput: IdInput;
};


export type QueryMaterialAnnotationToolAccessArgs = {
  materialIdInput: IdInput;
};


export type QueryMaterialsArgs = {
  topicIdInput: IdInput;
};


export type QueryMyCoursesArgs = {
  coursesQueryFilter?: InputMaybe<CoursesQueryFilter>;
};


export type QueryPreviewExternalContentArgs = {
  externalContentQueryInput: ExternalContentQueryInput;
};


export type QueryPublicCourseArgs = {
  accessCodeInput: CodeInput;
};


export type QueryPublicCourseCalendarDaysArgs = {
  publicCalendarDaysInput: PublicCalendarDaysInput;
};


export type QueryPublicCourseFeaturesArgs = {
  accessCodeInput: CodeInput;
};


export type QueryPublicCourseFoldersArgs = {
  publicCourseIdInput: PublicIdInput;
};


export type QueryPublicItemArgs = {
  publicItemInput: PublicIdInput;
};


export type QueryPublicItemInstanceArgs = {
  publicItemInstanceInput: PublicIdInput;
};


export type QueryPublicItemInstancesArgs = {
  publicTopicInstanceIdInput: PublicIdInput;
};


export type QueryPublicMaterialArgs = {
  publicItemInput: PublicIdInput;
};


export type QueryPublicMaterialAnnotationToolAccessArgs = {
  publicItemInput: PublicIdInput;
};


export type QueryPublicStudentAiAssignmentArgs = {
  publicStudentAiAssignmentInput: CodeInput;
};


export type QueryPublicTopicArgs = {
  topicIdInput: PublicIdInput;
};


export type QueryPublicTopicInstancesArgs = {
  publicCourseIdInput: PublicIdInput;
};


export type QueryRecentExternalContentArgs = {
  externalContentRecentInput: ExternalContentRecentInput;
};


export type QuerySchoolTypesArgs = {
  countryIdInput: IdInput;
};


export type QuerySearchContentArgs = {
  contentSearchInput: ContentSearchInput;
};


export type QuerySearchExternalContentArgs = {
  externalContentSearchInput: ExternalContentSearchInput;
};


export type QueryStudentAiAssignmentArgs = {
  studentAiAssignmentIdInput: IdInput;
};


export type QueryStudentAiTemplateArgs = {
  studentAiTemplateKeyInput: KeyInput;
};


export type QueryStudentAssignmentOpenQuestionHistoryArgs = {
  assignmentOpenQuestionHistoryInput: StudentAssignmentOpenQuestionHistoryInput;
};


export type QueryTenantEditableSchoolYearsArgs = {
  tenantIdInput: IdInput;
};


export type QueryTenantInvitePreviewArgs = {
  codeInput: CodeInput;
};


export type QueryTenantMembersArgs = {
  tenantMembersInput?: InputMaybe<TenantMembersInput>;
};


export type QueryTimetableExtensionArgs = {
  timetableExtensionInput: IdInput;
};


export type QueryTimetableExtensionsArgs = {
  timetableExtensionFilterInput: TimetableExtensionFilterInput;
};


export type QueryTimetableForCourseArgs = {
  timetableDaysInput: TimetableDaysInput;
};


export type QueryTimetableForUserArgs = {
  timetableRangeInput: TimetableRangeInput;
};


export type QueryTimetablePeriodAlternativesForCourseArgs = {
  timetablePeriodAlternativesForCourseInput: TimetablePeriodAlternativesForCourseInput;
};


export type QueryTopicArgs = {
  topicIdInput: IdInput;
};


export type QueryTopicContentArgs = {
  topicIdInput: IdInput;
};


export type QueryTopicInstanceArgs = {
  topicInstanceIDInput: TopicInstanceIdInput;
};


export type QueryTopicInstanceForTopicInCourseArgs = {
  topicCourseIDInput: TopicCourseIdInput;
};


export type QueryTopicInstancesArgs = {
  courseIdInput: CourseIdWithFilterInput;
};


export type QueryTopicsArgs = {
  topicFilterInput?: InputMaybe<TopicFilterInput>;
};


export type QueryUserCalendarDaysArgs = {
  calendarRangeInput: RangeInput;
};

export type RangeInput = {
  fromDay: Scalars['String']['input'];
  toDay: Scalars['String']['input'];
};

export type RateIpiRequestInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  ipiRequestId: Scalars['String']['input'];
  rating?: Scalars['String']['input'];
};

/** Input for refreshing a JWT token using a refresh token */
export type RefreshTokenInput = {
  /** Refresh token for refresh */
  refreshToken: Scalars['String']['input'];
};

export type RemoveCalendarEventInput = {
  calendarEventId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
  day: Scalars['String']['input'];
  type: CalendarEventType;
};

/** Input for removing a collaborator from a course */
export type RemoveCourseCollaboratorInput = {
  collaboratorId: Scalars['String']['input'];
};

/** Input for removing a course folder */
export type RemoveCourseFolderInput = {
  /** Optional: Boolean to override the active material check when removing a course folder */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the course folder */
  id: Scalars['String']['input'];
};

/** Input for removing a topic instance */
export type RemoveTopicInstanceInput = {
  /** Optional: Boolean to override the active item check when deleting a topic instance  */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the topic instance to be removed */
  id: Scalars['String']['input'];
};

/** Input for reordering a entity */
export type ReorderInput = {
  /** The id of the entity */
  id: Scalars['String']['input'];
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
};

export type SchoolType = BaseModel & {
  __typename?: 'SchoolType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SchoolYear = BaseModel & {
  __typename?: 'SchoolYear';
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  tenant: Tenant;
};

/** Input for setting the course first feature toggle */
export type SetCourseFirstFeatureToggleInput = {
  enable: Scalars['Boolean']['input'];
};

export type SoftDeleteBaseModel = {
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
};

export type StudentAiAssignment = BaseModel & SoftDeleteBaseModel & {
  __typename?: 'StudentAiAssignment';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  studentAiTemplate?: Maybe<StudentAiTemplate>;
  studentTasks: Array<Scalars['String']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  user: User;
};

export type StudentAiAssignmentResult = {
  __typename?: 'StudentAiAssignmentResult';
  studentAiAssignment: StudentAiAssignment;
};

export type StudentAiTemplate = BaseModel & {
  __typename?: 'StudentAiTemplate';
  categories?: Maybe<Array<Scalars['String']['output']>>;
  classLevelName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  languageName: Scalars['String']['output'];
  publicDescription?: Maybe<Scalars['String']['output']>;
  published: Scalars['Boolean']['output'];
  status?: Maybe<StudentAiTemplateStatus>;
  studentAge: Scalars['String']['output'];
  studentTasks?: Maybe<Array<Scalars['String']['output']>>;
  subjectName: Scalars['String']['output'];
  systemPrompt?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum StudentAiTemplateStatus {
  Checked = 'CHECKED',
  CheckedChanged = 'CHECKED_CHANGED',
  ManuallyRemoved = 'MANUALLY_REMOVED',
  New = 'NEW'
}

export type StudentAssignmentOpenQuestionHistory = {
  __typename?: 'StudentAssignmentOpenQuestionHistory';
  attempts: Array<AssignmentOpenQuestionAttempt>;
  nickname?: Maybe<Scalars['String']['output']>;
};

export type StudentAssignmentOpenQuestionHistoryInput = {
  assignmentId: Scalars['String']['input'];
  studentSessionId: Scalars['String']['input'];
};

export type Subject = BaseModel & {
  __typename?: 'Subject';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Result containing a support token */
export type SupportTokenResult = {
  __typename?: 'SupportTokenResult';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type TeachinoAiArea = {
  __typename?: 'TeachinoAiArea';
  aiGroups: Array<TeachinoAiGroup>;
  freeInputTask?: Maybe<TeachinoAiTask>;
  id: Scalars['String']['output'];
};

export type TeachinoAiGroup = {
  __typename?: 'TeachinoAiGroup';
  aiTasks: Array<TeachinoAiTask>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TeachinoAiTask = {
  __typename?: 'TeachinoAiTask';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  supportedInputBlocks: Array<Scalars['String']['output']>;
  taskType: AiTaskType;
  title: Scalars['String']['output'];
};

/** Input for connecting a template to a course */
export type TemplateCourseConnectInput = {
  /** Id of the course */
  courseId: Scalars['String']['input'];
  /** Id of the template */
  templateId: Scalars['String']['input'];
};

/** Input for syncing a specific content with its template */
export type TemplateSyncInput = {
  /** Non-empty id of an object or entity */
  id: Scalars['String']['input'];
  /** How to sync the content */
  syncMode: TemplateSyncMode;
};

export enum TemplateSyncMode {
  All = 'ALL',
  Ignore = 'IGNORE',
  New = 'NEW',
  Single = 'SINGLE'
}

export type TemporaryExternalCredentials = BaseModel & {
  __typename?: 'TemporaryExternalCredentials';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  externalIntegrationSetting?: Maybe<ExternalIntegrationSetting>;
  id: Scalars['String']['output'];
  temporaryCode: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type Tenant = BaseModel & {
  __typename?: 'Tenant';
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  language: Language;
  managementType: TenantManagementType;
  members?: Maybe<Array<TenantMember>>;
  name: Scalars['String']['output'];
  parent?: Maybe<Tenant>;
  permissions?: Maybe<UserTenantPermission>;
  type: TenantType;
};

export type TenantInvite = BaseModel & {
  __typename?: 'TenantInvite';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  tenant: Tenant;
  tenantMembershipRole: TenantMembershipRole;
};

/** Output for public tenant invite preview data */
export type TenantInvitePreview = {
  __typename?: 'TenantInvitePreview';
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  tenantMember: Scalars['Boolean']['output'];
  tenantName: Scalars['String']['output'];
};

export enum TenantManagementType {
  Managed = 'MANAGED',
  User = 'USER'
}

/** Output wrapper for a member in a tenant */
export type TenantMember = {
  __typename?: 'TenantMember';
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  joinedAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  tenantRole: TenantMembershipRole;
  userId: Scalars['String']['output'];
};

/** Input for fetching the members of a tenant */
export type TenantMembersInput = {
  /** Optional: List of roles to be fetched */
  membershipRoles?: InputMaybe<Array<TenantMembershipRole>>;
  /** Optional: Id of the tenant for which the members should be retrieved, if not passed, then it fetches all accessible to user */
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export enum TenantMembershipRole {
  Admin = 'ADMIN',
  Student = 'STUDENT',
  Teacher = 'TEACHER'
}

export enum TenantType {
  Bucket = 'BUCKET',
  School = 'SCHOOL'
}

export type TextToSpeechInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TextToSpeechLog = BaseModel & {
  __typename?: 'TextToSpeechLog';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastListenedAt: Scalars['DateTime']['output'];
  speechUrl: Scalars['String']['output'];
  textHash: Scalars['String']['output'];
  textLength: Scalars['Float']['output'];
  user?: Maybe<User>;
};

/** Result containing a text to speech log */
export type TextToSpeechLogResult = {
  __typename?: 'TextToSpeechLogResult';
  textToSpeechLog: TextToSpeechLog;
};

export type Timetable = BaseModel & {
  __typename?: 'Timetable';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  inputMode: TimetableInputMode;
  timetableEntries: Array<TimetableEntry>;
  timetableGrid: Array<TimetableGridEntry>;
  user: User;
};

export type TimetableDay = {
  __typename?: 'TimetableDay';
  day: Scalars['String']['output'];
  id: Scalars['String']['output'];
  periods: Array<TimetablePeriod>;
};

export type TimetableDayError = {
  __typename?: 'TimetableDayError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type TimetableDayResult = {
  __typename?: 'TimetableDayResult';
  timetableDays: Array<TimetableDay>;
  timetableErrors: Array<TimetableDayError>;
};

export type TimetableDaysInput = {
  courseId: Scalars['String']['input'];
  fromDay: Scalars['String']['input'];
  toDay: Scalars['String']['input'];
};

export type TimetableEntry = BaseModel & {
  __typename?: 'TimetableEntry';
  course: Course;
  createdAt: Scalars['DateTime']['output'];
  dayOfWeek: Scalars['String']['output'];
  fromTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  timetable: Timetable;
  toTime: Scalars['String']['output'];
  user: User;
};

export type TimetableEntryInput = {
  courseId: Scalars['String']['input'];
  dayOfWeek: Scalars['String']['input'];
  existingId?: InputMaybe<Scalars['String']['input']>;
  fromTime: Scalars['String']['input'];
  toTime: Scalars['String']['input'];
};

export type TimetableExtension = {
  __typename?: 'TimetableExtension';
  course?: Maybe<Course>;
  createdAt: Scalars['DateTime']['output'];
  fromDay: Scalars['String']['output'];
  fromTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  timetable: Timetable;
  timetableEntry?: Maybe<TimetableEntry>;
  toDay: Scalars['String']['output'];
  toTime?: Maybe<Scalars['String']['output']>;
  type: PeriodType;
  user: User;
};

export type TimetableExtensionFilterInput = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  fromDay?: InputMaybe<Scalars['String']['input']>;
  toDay?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<PeriodType>>;
};

/** Result containing a timetable extension */
export type TimetableExtensionResult = {
  __typename?: 'TimetableExtensionResult';
  timetableExtension: TimetableExtension;
};

export type TimetableGridEntry = {
  __typename?: 'TimetableGridEntry';
  fromTime: Scalars['String']['output'];
  toTime: Scalars['String']['output'];
};

export type TimetableGridEntryInput = {
  fromTime: Scalars['String']['input'];
  toTime: Scalars['String']['input'];
};

export enum TimetableInputMode {
  Complex = 'COMPLEX',
  Grid = 'GRID'
}

export type TimetablePeriod = {
  __typename?: 'TimetablePeriod';
  endTime?: Maybe<Scalars['DateTime']['output']>;
  extensionId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  periodCourse?: Maybe<PeriodCourse>;
  source: Scalars['String']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  timetableEntryId?: Maybe<Scalars['String']['output']>;
  type: PeriodType;
};

export type TimetablePeriodAlternativesForCourseInput = {
  courseId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
};

export type TimetableRangeInput = {
  fromDay: Scalars['String']['input'];
  toDay: Scalars['String']['input'];
};

export type ToDo = BaseModel & {
  __typename?: 'ToDo';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  owner: User;
  text: Scalars['String']['output'];
};

/** Result containing a topic */
export type TodoResult = {
  __typename?: 'TodoResult';
  toDo: ToDo;
};

export type ToggleStudentAiAssignmentInput = {
  active: Scalars['Boolean']['input'];
  /** Non-empty id of an object or entity */
  id: Scalars['String']['input'];
};

/** Result containing a topic */
export type TopicContent = {
  __typename?: 'TopicContent';
  id: Folder;
  itemContents: Array<ItemContent>;
  topic: Folder;
  topicInstances: Array<TopicInstance>;
};

/** Input for fetching a topic instance for a topic in a course */
export type TopicCourseIdInput = {
  /** Non-empty id of a course */
  courseId: Scalars['String']['input'];
  /** Non-empty id of a topic */
  id: Scalars['String']['input'];
};

export type TopicFilterInput = {
  courseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TopicInstance = BaseModel & LockableBaseModel & {
  __typename?: 'TopicInstance';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  course: Course;
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  expanded: Scalars['Boolean']['output'];
  highlighted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  position: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  statistics?: Maybe<TopicInstanceStatistics>;
  topic: Folder;
};

/** Input for fetching a topic instance for a topic in a course */
export type TopicInstanceIdInput = {
  /** Non-empty id of a topicInstance */
  id: Scalars['String']['input'];
};

/** Result containing a topic instance */
export type TopicInstanceResult = {
  __typename?: 'TopicInstanceResult';
  topicInstance: TopicInstance;
};

export type TopicInstanceStatistics = {
  __typename?: 'TopicInstanceStatistics';
  doneItemInstances: Scalars['Float']['output'];
  plannedItemInstances: Scalars['Float']['output'];
  totalItemInstances: Scalars['Float']['output'];
  visibleItemInstances: Scalars['Float']['output'];
};

/** Topic Item Input for removing an item from a topic */
export type TopicItemRemoveInput = {
  /** Optional: Boolean to override the active item check when deleting an item */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the item */
  id: Scalars['String']['input'];
  /** The id of the topic associated with the item */
  topicId: Scalars['String']['input'];
};

/** Input for moving and removing a topic from a folder */
export type TopicLibraryFolderMoveInput = {
  /** The id of the entity */
  id: Scalars['String']['input'];
  /** The id of the library folder */
  libraryFolderId?: InputMaybe<Scalars['String']['input']>;
  /** The new position of the entity [-1..N], -1 adds it to the end of the list */
  position: Scalars['Int']['input'];
};

/** Topic Item Input for removing an item from a topic */
export type TopicMaterialRemoveInput = {
  /** Optional: Boolean to override the active material check when deleting a material */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the material */
  id: Scalars['String']['input'];
  /** The id of the topic associated with the material */
  topicId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for removing a topic */
export type TopicRemoveInput = {
  /** Optional: Boolean to override the active topic check when deleting an topic */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the topic */
  id: Scalars['String']['input'];
};

/** Result containing a topic */
export type TopicResult = {
  __typename?: 'TopicResult';
  topic: Folder;
};

export type TopicStatistics = {
  __typename?: 'TopicStatistics';
  linkedItemsTotal: Scalars['Float']['output'];
};

export type UnmappedCourse = {
  __typename?: 'UnmappedCourse';
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  externalUserCredentialsId: Scalars['String']['output'];
  roleInCourse: CourseMembershipRole;
};

export type UpdateCalendarNoteInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  foregroundColor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

/** Input for updating a collaborator within a course */
export type UpdateCourseCollaboratorInput = {
  collaboratorId: Scalars['String']['input'];
  courseMembershipRole?: InputMaybe<CourseMembershipRole>;
};

/** Input that contains all required and optional values for updating a course */
export type UpdateCourseInput = {
  /** Optional: Updated background color of the course */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Class level age */
  classLevelAge?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Class level key */
  classLevelKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Class level label */
  classLevelLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Country key */
  countryKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Country label */
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional: List of days of the week that the course will take place on. [1-7]  */
  days?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Optional: Updated foreground color of the course */
  foregroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Id of the course to be updated */
  id: Scalars['String']['input'];
  /** Optional: Language key */
  languageKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Language label */
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Updated name of the course */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Prompt additions for each prompt sent for this class */
  promptingAddition?: InputMaybe<Scalars['String']['input']>;
  /** Optional: School type key */
  schoolTypeKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: School type label */
  schoolTypeLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional: The ID of the new school year */
  schoolYearId?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Updated short name of the course */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Optional: State key */
  stateKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: State label */
  stateLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Subject key */
  subjectKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Subject label */
  subjectLabel?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a folder */
export type UpdateFolderInput = {
  /** The updated goals for the folder */
  goals?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** The updated name for the folder */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an item */
export type UpdateItemInput = {
  /** The updated duration for the item, null unsets it */
  duration?: InputMaybe<Scalars['Float']['input']>;
  /** Associated external content */
  externalContent?: InputMaybe<ExternalContentInput>;
  /** The updated icon for the item, null unsets it */
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** The updated name for the item */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a library folder */
export type UpdateLibraryFolderInput = {
  /** Optional: the color of the folder */
  folderColor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** The updated name for the library folder */
  name: Scalars['String']['input'];
};

/** Input for updating a material */
export type UpdateMaterialInput = {
  contentHtml?: InputMaybe<MaterialContentHtmlInput>;
  /** The updated duration for the material, null unsets it */
  duration?: InputMaybe<Scalars['Float']['input']>;
  /** Associated external content */
  externalContent?: InputMaybe<ExternalContentInput>;
  /** The updated icon for the material, null unsets it */
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** The updated name for the material */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, set migratedToMaterial to now */
  setMigratedToMaterial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateStudentAiAssignmentInput = {
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateTimetableExtensionInput = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  fromDay?: InputMaybe<Scalars['String']['input']>;
  fromTime?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  timetableExtensionId: Scalars['String']['input'];
  toDay?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a todo */
export type UpdateTodoInput = {
  doneAt?: InputMaybe<Scalars['DateTime']['input']>;
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  /** The updated name for the todo */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a topic */
export type UpdateTopicInput = {
  /** Associated external content */
  externalContent?: InputMaybe<ExternalContentInput>;
  /** The updated goals for the topic */
  goals?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** The updated name for the topic */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a topic instance */
export type UpdateTopicInstanceInput = {
  /** Mark a topic instance as completed or not */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** end date of a topic instance */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Defines if the topic instance is shown as expanded or not */
  expanded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if the topic instance is shown as highlighted or not */
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the topic instance to be updated */
  id: Scalars['String']['input'];
  /** start date of a topic instance */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input that contains all required and optional values for updating a user */
export type UpdateUserInput = {
  /** Optional: Country key */
  countryKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Country label */
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Users first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Users language */
  language?: InputMaybe<Language>;
  /** Optional: Users last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Optional: School type key */
  schoolTypeKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: School type label */
  schoolTypeLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional: State key */
  stateKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional: State label */
  stateLabel?: InputMaybe<Scalars['String']['input']>;
};

/** Input that contains all required and optional values for updating a users preferences */
export type UpdateUserPreferencesInput = {
  preferences?: InputMaybe<Scalars['JSON']['input']>;
};

export enum UsageType {
  CourseOnly = 'COURSE_ONLY',
  CourseOnlyHidden = 'COURSE_ONLY_HIDDEN',
  CourseOnlyUnorganized = 'COURSE_ONLY_UNORGANIZED',
  Regular = 'REGULAR',
  Template = 'TEMPLATE',
  Unorganized = 'UNORGANIZED'
}

export type User = BaseModel & {
  __typename?: 'User';
  countryKey?: Maybe<Scalars['String']['output']>;
  countryLabel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultTenant?: Maybe<Tenant>;
  email: Scalars['String']['output'];
  emailVerificationStatus: MailVerificationStatus;
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  forceNewEditor: Scalars['Boolean']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  language: Language;
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  lastLoginAt: Scalars['DateTime']['output'];
  lastName: Scalars['String']['output'];
  schoolTypeKey?: Maybe<Scalars['String']['output']>;
  schoolTypeLabel?: Maybe<Scalars['String']['output']>;
  signedUp: Scalars['Boolean']['output'];
  stateKey?: Maybe<Scalars['String']['output']>;
  stateLabel?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserCalendarDay = {
  __typename?: 'UserCalendarDay';
  courseCalendarDays: Array<CourseCalendarDay>;
  day: Scalars['String']['output'];
  id: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserCoursePermission = {
  __typename?: 'UserCoursePermission';
  canAddCalendarNote: Scalars['Boolean']['output'];
  canAddCourseFolder: Scalars['Boolean']['output'];
  canAddCourseTopicInstance: Scalars['Boolean']['output'];
  canArchiveCourse: Scalars['Boolean']['output'];
  canChangeCourseSharingSettings: Scalars['Boolean']['output'];
  canCloseCourse: Scalars['Boolean']['output'];
  canConnectToCourse: Scalars['Boolean']['output'];
  canEditCalendarNote: Scalars['Boolean']['output'];
  canEditCourseItemInstance: Scalars['Boolean']['output'];
  canEditCourseMaterial: Scalars['Boolean']['output'];
  canEditCoursePublicSettings: Scalars['Boolean']['output'];
  canEditCourseSettings: Scalars['Boolean']['output'];
  canEditCourseTopicInstance: Scalars['Boolean']['output'];
  canRemoveCourseTopicInstance: Scalars['Boolean']['output'];
  courseRole?: Maybe<CourseMembershipRole>;
  hasNoAccess: Scalars['Boolean']['output'];
  isCourseOwner: Scalars['Boolean']['output'];
};

/** Output wrapper displaying users Email notifications subscriptions */
export type UserEmailNotificationSubscription = {
  __typename?: 'UserEmailNotificationSubscription';
  description: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  notificationId: Scalars['String']['output'];
  subscribed: Scalars['Boolean']['output'];
  unsubscribable: Scalars['Boolean']['output'];
};

export type UserItemPermission = {
  __typename?: 'UserItemPermission';
  canDeleteCourseMaterialFromCourseFolder: Scalars['Boolean']['output'];
  canDeleteItemFromTopic: Scalars['Boolean']['output'];
  canDuplicateCourseMaterialIntoCourseFolder: Scalars['Boolean']['output'];
  canDuplicateItemIntoTopic: Scalars['Boolean']['output'];
  canEditCourseMaterial: Scalars['Boolean']['output'];
  canEditItem: Scalars['Boolean']['output'];
  canEditItemContentNote: Scalars['Boolean']['output'];
  canEditItemSnippetNote: Scalars['Boolean']['output'];
  canViewCourseMaterial: Scalars['Boolean']['output'];
  canViewItem: Scalars['Boolean']['output'];
  canViewItemContentNote: Scalars['Boolean']['output'];
  canViewItemSnippetNote: Scalars['Boolean']['output'];
};

/** Result containing a user */
export type UserResult = {
  __typename?: 'UserResult';
  user: User;
};

export type UserTenantPermission = {
  __typename?: 'UserTenantPermission';
  canCreateCourse: Scalars['Boolean']['output'];
  canManageLicense: Scalars['Boolean']['output'];
  hasNoAccess: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isTenantTeacher: Scalars['Boolean']['output'];
};

export type UserTopicPermission = {
  __typename?: 'UserTopicPermission';
  canChangeTopicSharingSettings: Scalars['Boolean']['output'];
  canDeleteTopicFromOwnLibrary: Scalars['Boolean']['output'];
  canDuplicateTopic: Scalars['Boolean']['output'];
  canEditCourseFolder: Scalars['Boolean']['output'];
  canEditTopic: Scalars['Boolean']['output'];
  canModifyCourseMaterials: Scalars['Boolean']['output'];
  canModifyMaterials: Scalars['Boolean']['output'];
  canMoveTopic: Scalars['Boolean']['output'];
  canViewTopic: Scalars['Boolean']['output'];
  isTopicOwner: Scalars['Boolean']['output'];
};

/** Input for verifying an object via code */
export type VerificationInput = {
  /** A non-empty code */
  code: Scalars['String']['input'];
};

/** Input for verifying and resetting a password for a user via email address */
export type VerifyUserPasswordResetInput = {
  /** Non-empty code */
  code: Scalars['String']['input'];
  /** Non-empty and valid email address */
  email: Scalars['String']['input'];
  /** Users password with minimum length according to our policy */
  password: Scalars['String']['input'];
};

export type WithTypename<T extends { __typename?: any }> = Partial<T> & { __typename: NonNullable<T['__typename']> };

export type GraphCacheKeysConfig = {
  AiSettings?: (data: WithTypename<AiSettings>) => null | string,
  AiSettingsResult?: (data: WithTypename<AiSettingsResult>) => null | string,
  AssignmentChatbot?: (data: WithTypename<AssignmentChatbot>) => null | string,
  AssignmentChatbotHistory?: (data: WithTypename<AssignmentChatbotHistory>) => null | string,
  AssignmentChatbotInstanceSummary?: (data: WithTypename<AssignmentChatbotInstanceSummary>) => null | string,
  AssignmentChatbotMessage?: (data: WithTypename<AssignmentChatbotMessage>) => null | string,
  AssignmentOpenQuestion?: (data: WithTypename<AssignmentOpenQuestion>) => null | string,
  AssignmentOpenQuestionAttempt?: (data: WithTypename<AssignmentOpenQuestionAttempt>) => null | string,
  AssignmentOpenQuestionHistory?: (data: WithTypename<AssignmentOpenQuestionHistory>) => null | string,
  AssignmentStatus?: (data: WithTypename<AssignmentStatus>) => null | string,
  AuthResult?: (data: WithTypename<AuthResult>) => null | string,
  CalendarEventListResult?: (data: WithTypename<CalendarEventListResult>) => null | string,
  CalendarEventResult?: (data: WithTypename<CalendarEventResult>) => null | string,
  CalendarNote?: (data: WithTypename<CalendarNote>) => null | string,
  CalendarNoteResult?: (data: WithTypename<CalendarNoteResult>) => null | string,
  Configuration?: (data: WithTypename<Configuration>) => null | string,
  ConnectedCourse?: (data: WithTypename<ConnectedCourse>) => null | string,
  Country?: (data: WithTypename<Country>) => null | string,
  CountryStateCombo?: (data: WithTypename<CountryStateCombo>) => null | string,
  Course?: (data: WithTypename<Course>) => null | string,
  CourseCalendarDay?: (data: WithTypename<CourseCalendarDay>) => null | string,
  CourseCollaborator?: (data: WithTypename<CourseCollaborator>) => null | string,
  CourseCollaboratorResult?: (data: WithTypename<CourseCollaboratorResult>) => null | string,
  CourseContentVisibility?: (data: WithTypename<CourseContentVisibility>) => null | string,
  CourseFolder?: (data: WithTypename<CourseFolder>) => null | string,
  CourseFolderResult?: (data: WithTypename<CourseFolderResult>) => null | string,
  CourseInvite?: (data: WithTypename<CourseInvite>) => null | string,
  CourseInvitePreview?: (data: WithTypename<CourseInvitePreview>) => null | string,
  CourseInviteResult?: (data: WithTypename<CourseInviteResult>) => null | string,
  CourseMaterial?: (data: WithTypename<CourseMaterial>) => null | string,
  CourseMaterialResult?: (data: WithTypename<CourseMaterialResult>) => null | string,
  CoursePublicAccess?: (data: WithTypename<CoursePublicAccess>) => null | string,
  CoursePublicAccessResult?: (data: WithTypename<CoursePublicAccessResult>) => null | string,
  CourseResult?: (data: WithTypename<CourseResult>) => null | string,
  Curriculum?: (data: WithTypename<Curriculum>) => null | string,
  CurriculumContent?: (data: WithTypename<CurriculumContent>) => null | string,
  DoneResult?: (data: WithTypename<DoneResult>) => null | string,
  ExistingCourseMapping?: (data: WithTypename<ExistingCourseMapping>) => null | string,
  ExistingCourseMappingResult?: (data: WithTypename<ExistingCourseMappingResult>) => null | string,
  ExternalContent?: (data: WithTypename<ExternalContent>) => null | string,
  ExternalContentApiError?: (data: WithTypename<ExternalContentApiError>) => null | string,
  ExternalContentPreview?: (data: WithTypename<ExternalContentPreview>) => null | string,
  ExternalContentResult?: (data: WithTypename<ExternalContentResult>) => null | string,
  ExternalCourse?: (data: WithTypename<ExternalCourse>) => null | string,
  ExternalCourseMapping?: (data: WithTypename<ExternalCourseMapping>) => null | string,
  ExternalCoursesResult?: (data: WithTypename<ExternalCoursesResult>) => null | string,
  ExternalIntegrationSetting?: (data: WithTypename<ExternalIntegrationSetting>) => null | string,
  ExternalUserCredentials?: (data: WithTypename<ExternalUserCredentials>) => null | string,
  Feature?: (data: WithTypename<Feature>) => null | string,
  FeatureFlag?: (data: WithTypename<FeatureFlag>) => null | string,
  Folder?: (data: WithTypename<Folder>) => null | string,
  FolderResult?: (data: WithTypename<FolderResult>) => null | string,
  GlobalConfiguration?: (data: WithTypename<GlobalConfiguration>) => null | string,
  IgnoredCourse?: (data: WithTypename<IgnoredCourse>) => null | string,
  InitialIpiPromptResult?: (data: WithTypename<InitialIpiPromptResult>) => null | string,
  IntegrationCheckResult?: (data: WithTypename<IntegrationCheckResult>) => null | string,
  IpiPromptHistoryItem?: (data: WithTypename<IpiPromptHistoryItem>) => null | string,
  IpiPromptHistoryResult?: (data: WithTypename<IpiPromptHistoryResult>) => null | string,
  IpiPromptSuggestion?: (data: WithTypename<IpiPromptSuggestion>) => null | string,
  ItemContent?: (data: WithTypename<ItemContent>) => null | string,
  ItemInstance?: (data: WithTypename<ItemInstance>) => null | string,
  ItemInstanceResult?: (data: WithTypename<ItemInstanceResult>) => null | string,
  ItemResult?: (data: WithTypename<ItemResult>) => null | string,
  LibraryFolder?: (data: WithTypename<LibraryFolder>) => null | string,
  LibraryFolderResult?: (data: WithTypename<LibraryFolderResult>) => null | string,
  LibraryMetaResult?: (data: WithTypename<LibraryMetaResult>) => null | string,
  LibraryNewestContentResult?: (data: WithTypename<LibraryNewestContentResult>) => null | string,
  License?: (data: WithTypename<License>) => null | string,
  LinkPreviewExtra?: (data: WithTypename<LinkPreviewExtra>) => null | string,
  Material?: (data: WithTypename<Material>) => null | string,
  MaterialAnnotationToolAccess?: (data: WithTypename<MaterialAnnotationToolAccess>) => null | string,
  MaterialContentHtml?: (data: WithTypename<MaterialContentHtml>) => null | string,
  MaterialContentStatistics?: (data: WithTypename<MaterialContentStatistics>) => null | string,
  MaterialCourse?: (data: WithTypename<MaterialCourse>) => null | string,
  MaterialInteractiveAssignmentStatus?: (data: WithTypename<MaterialInteractiveAssignmentStatus>) => null | string,
  MaterialInteractiveAssignmentsStudentOverview?: (data: WithTypename<MaterialInteractiveAssignmentsStudentOverview>) => null | string,
  MaterialResult?: (data: WithTypename<MaterialResult>) => null | string,
  OriginDetails?: (data: WithTypename<OriginDetails>) => null | string,
  PaymentGatewayManagementData?: (data: WithTypename<PaymentGatewayManagementData>) => null | string,
  PeriodCourse?: (data: WithTypename<PeriodCourse>) => null | string,
  Plan?: (data: WithTypename<Plan>) => null | string,
  SchoolType?: (data: WithTypename<SchoolType>) => null | string,
  SchoolYear?: (data: WithTypename<SchoolYear>) => null | string,
  StudentAiAssignment?: (data: WithTypename<StudentAiAssignment>) => null | string,
  StudentAiAssignmentResult?: (data: WithTypename<StudentAiAssignmentResult>) => null | string,
  StudentAiTemplate?: (data: WithTypename<StudentAiTemplate>) => null | string,
  StudentAssignmentOpenQuestionHistory?: (data: WithTypename<StudentAssignmentOpenQuestionHistory>) => null | string,
  Subject?: (data: WithTypename<Subject>) => null | string,
  SupportTokenResult?: (data: WithTypename<SupportTokenResult>) => null | string,
  TeachinoAiArea?: (data: WithTypename<TeachinoAiArea>) => null | string,
  TeachinoAiGroup?: (data: WithTypename<TeachinoAiGroup>) => null | string,
  TeachinoAiTask?: (data: WithTypename<TeachinoAiTask>) => null | string,
  TemporaryExternalCredentials?: (data: WithTypename<TemporaryExternalCredentials>) => null | string,
  Tenant?: (data: WithTypename<Tenant>) => null | string,
  TenantInvite?: (data: WithTypename<TenantInvite>) => null | string,
  TenantInvitePreview?: (data: WithTypename<TenantInvitePreview>) => null | string,
  TenantMember?: (data: WithTypename<TenantMember>) => null | string,
  TextToSpeechLog?: (data: WithTypename<TextToSpeechLog>) => null | string,
  TextToSpeechLogResult?: (data: WithTypename<TextToSpeechLogResult>) => null | string,
  Timetable?: (data: WithTypename<Timetable>) => null | string,
  TimetableDay?: (data: WithTypename<TimetableDay>) => null | string,
  TimetableDayError?: (data: WithTypename<TimetableDayError>) => null | string,
  TimetableDayResult?: (data: WithTypename<TimetableDayResult>) => null | string,
  TimetableEntry?: (data: WithTypename<TimetableEntry>) => null | string,
  TimetableExtension?: (data: WithTypename<TimetableExtension>) => null | string,
  TimetableExtensionResult?: (data: WithTypename<TimetableExtensionResult>) => null | string,
  TimetableGridEntry?: (data: WithTypename<TimetableGridEntry>) => null | string,
  TimetablePeriod?: (data: WithTypename<TimetablePeriod>) => null | string,
  ToDo?: (data: WithTypename<ToDo>) => null | string,
  TodoResult?: (data: WithTypename<TodoResult>) => null | string,
  TopicContent?: (data: WithTypename<TopicContent>) => null | string,
  TopicInstance?: (data: WithTypename<TopicInstance>) => null | string,
  TopicInstanceResult?: (data: WithTypename<TopicInstanceResult>) => null | string,
  TopicInstanceStatistics?: (data: WithTypename<TopicInstanceStatistics>) => null | string,
  TopicResult?: (data: WithTypename<TopicResult>) => null | string,
  TopicStatistics?: (data: WithTypename<TopicStatistics>) => null | string,
  UnmappedCourse?: (data: WithTypename<UnmappedCourse>) => null | string,
  User?: (data: WithTypename<User>) => null | string,
  UserCalendarDay?: (data: WithTypename<UserCalendarDay>) => null | string,
  UserCoursePermission?: (data: WithTypename<UserCoursePermission>) => null | string,
  UserEmailNotificationSubscription?: (data: WithTypename<UserEmailNotificationSubscription>) => null | string,
  UserItemPermission?: (data: WithTypename<UserItemPermission>) => null | string,
  UserResult?: (data: WithTypename<UserResult>) => null | string,
  UserTenantPermission?: (data: WithTypename<UserTenantPermission>) => null | string,
  UserTopicPermission?: (data: WithTypename<UserTopicPermission>) => null | string
}

export type GraphCacheResolvers = {
  Query?: {
    aiArea?: GraphCacheResolver<WithTypename<Query>, QueryAiAreaArgs, WithTypename<TeachinoAiArea> | string>,
    aiSettings?: GraphCacheResolver<WithTypename<Query>, QueryAiSettingsArgs, WithTypename<AiSettings> | string>,
    aiTask?: GraphCacheResolver<WithTypename<Query>, QueryAiTaskArgs, WithTypename<TeachinoAiTask> | string>,
    assignmentChatbotHistory?: GraphCacheResolver<WithTypename<Query>, QueryAssignmentChatbotHistoryArgs, WithTypename<AssignmentChatbotHistory> | string>,
    assignmentChatbotsForMaterial?: GraphCacheResolver<WithTypename<Query>, QueryAssignmentChatbotsForMaterialArgs, Array<WithTypename<AssignmentChatbot> | string>>,
    assignmentOpenQuestionHistory?: GraphCacheResolver<WithTypename<Query>, QueryAssignmentOpenQuestionHistoryArgs, WithTypename<AssignmentOpenQuestionHistory> | string>,
    assignmentOpenQuestionsForMaterial?: GraphCacheResolver<WithTypename<Query>, QueryAssignmentOpenQuestionsForMaterialArgs, Array<WithTypename<AssignmentOpenQuestion> | string>>,
    availableCoursesToAddTopic?: GraphCacheResolver<WithTypename<Query>, QueryAvailableCoursesToAddTopicArgs, Array<WithTypename<Course> | string>>,
    calendarDays?: GraphCacheResolver<WithTypename<Query>, QueryCalendarDaysArgs, Array<WithTypename<CourseCalendarDay> | string>>,
    config?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<Configuration> | string>,
    countriesWithStates?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<CountryStateCombo> | string>>,
    course?: GraphCacheResolver<WithTypename<Query>, QueryCourseArgs, WithTypename<Course> | string>,
    courseCalendarDays?: GraphCacheResolver<WithTypename<Query>, QueryCourseCalendarDaysArgs, Array<WithTypename<CourseCalendarDay> | string>>,
    courseCollaborators?: GraphCacheResolver<WithTypename<Query>, QueryCourseCollaboratorsArgs, Array<WithTypename<CourseCollaborator> | string>>,
    courseFolders?: GraphCacheResolver<WithTypename<Query>, QueryCourseFoldersArgs, Array<WithTypename<CourseFolder> | string>>,
    courseInvitePreview?: GraphCacheResolver<WithTypename<Query>, QueryCourseInvitePreviewArgs, WithTypename<CourseInvitePreview> | string>,
    courseInvites?: GraphCacheResolver<WithTypename<Query>, QueryCourseInvitesArgs, Array<WithTypename<CourseInvite> | string>>,
    coursePublicAccess?: GraphCacheResolver<WithTypename<Query>, QueryCoursePublicAccessArgs, WithTypename<CoursePublicAccess> | string>,
    coursesForItem?: GraphCacheResolver<WithTypename<Query>, QueryCoursesForItemArgs, Array<WithTypename<Course> | string>>,
    coursesForItemInstance?: GraphCacheResolver<WithTypename<Query>, QueryCoursesForItemInstanceArgs, Array<WithTypename<Course> | string>>,
    coursesForMaterial?: GraphCacheResolver<WithTypename<Query>, QueryCoursesForMaterialArgs, Array<WithTypename<MaterialCourse> | string>>,
    coursesForTopic?: GraphCacheResolver<WithTypename<Query>, QueryCoursesForTopicArgs, Array<WithTypename<Course> | string>>,
    currentLicense?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<License> | string>,
    curriculumContent?: GraphCacheResolver<WithTypename<Query>, QueryCurriculumContentArgs, Array<WithTypename<CurriculumContent> | string>>,
    curriculums?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<Curriculum> | string>>,
    dueToDos?: GraphCacheResolver<WithTypename<Query>, QueryDueToDosArgs, Array<WithTypename<ToDo> | string>>,
    editableTopicInstancesForTopic?: GraphCacheResolver<WithTypename<Query>, QueryEditableTopicInstancesForTopicArgs, Array<WithTypename<TopicInstance> | string>>,
    exportTree?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<LibraryFolder> | string>>,
    externalContent?: GraphCacheResolver<WithTypename<Query>, QueryExternalContentArgs, WithTypename<ExternalContentResult> | string>,
    externalCourses?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<ExternalCoursesResult> | string>,
    externalIntegrations?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<ExternalUserCredentials> | string>>,
    globalSubjects?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<Subject> | string>>,
    interactiveAssignmentsOverview?: GraphCacheResolver<WithTypename<Query>, QueryInteractiveAssignmentsOverviewArgs, Array<WithTypename<MaterialInteractiveAssignmentsStudentOverview> | string>>,
    interactiveAssignmentsStatusByTopic?: GraphCacheResolver<WithTypename<Query>, QueryInteractiveAssignmentsStatusByTopicArgs, Array<WithTypename<MaterialInteractiveAssignmentStatus> | string>>,
    item?: GraphCacheResolver<WithTypename<Query>, QueryItemArgs, WithTypename<Material> | string>,
    itemInstances?: GraphCacheResolver<WithTypename<Query>, QueryItemInstancesArgs, Array<WithTypename<ItemInstance> | string>>,
    items?: GraphCacheResolver<WithTypename<Query>, QueryItemsArgs, Array<WithTypename<Material> | string>>,
    libraryFolder?: GraphCacheResolver<WithTypename<Query>, QueryLibraryFolderArgs, WithTypename<LibraryFolder> | string>,
    libraryFolders?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<LibraryFolder> | string>>,
    libraryMeta?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<LibraryMetaResult> | string>,
    libraryNewestContent?: GraphCacheResolver<WithTypename<Query>, QueryLibraryNewestContentArgs, WithTypename<LibraryNewestContentResult> | string>,
    licenses?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<License> | string>>,
    material?: GraphCacheResolver<WithTypename<Query>, QueryMaterialArgs, WithTypename<Material> | string>,
    materialAnnotationToolAccess?: GraphCacheResolver<WithTypename<Query>, QueryMaterialAnnotationToolAccessArgs, WithTypename<MaterialAnnotationToolAccess> | string>,
    materials?: GraphCacheResolver<WithTypename<Query>, QueryMaterialsArgs, Array<WithTypename<Material> | string>>,
    me?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<User> | string>,
    myCourses?: GraphCacheResolver<WithTypename<Query>, QueryMyCoursesArgs, Array<WithTypename<Course> | string>>,
    myIpiPromptHistory?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<IpiPromptHistoryResult> | string>,
    myTenants?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<Tenant> | string>>,
    previewExternalContent?: GraphCacheResolver<WithTypename<Query>, QueryPreviewExternalContentArgs, WithTypename<ExternalContentPreview> | string>,
    publicCourse?: GraphCacheResolver<WithTypename<Query>, QueryPublicCourseArgs, WithTypename<Course> | string>,
    publicCourseCalendarDays?: GraphCacheResolver<WithTypename<Query>, QueryPublicCourseCalendarDaysArgs, Array<WithTypename<CourseCalendarDay> | string>>,
    publicCourseFeatures?: GraphCacheResolver<WithTypename<Query>, QueryPublicCourseFeaturesArgs, Array<WithTypename<Feature> | string>>,
    publicCourseFolders?: GraphCacheResolver<WithTypename<Query>, QueryPublicCourseFoldersArgs, Array<WithTypename<CourseFolder> | string>>,
    publicItem?: GraphCacheResolver<WithTypename<Query>, QueryPublicItemArgs, WithTypename<Material> | string>,
    publicItemInstance?: GraphCacheResolver<WithTypename<Query>, QueryPublicItemInstanceArgs, WithTypename<ItemInstance> | string>,
    publicItemInstances?: GraphCacheResolver<WithTypename<Query>, QueryPublicItemInstancesArgs, Array<WithTypename<ItemInstance> | string>>,
    publicMaterial?: GraphCacheResolver<WithTypename<Query>, QueryPublicMaterialArgs, WithTypename<Material> | string>,
    publicMaterialAnnotationToolAccess?: GraphCacheResolver<WithTypename<Query>, QueryPublicMaterialAnnotationToolAccessArgs, WithTypename<MaterialAnnotationToolAccess> | string>,
    publicStudentAiAssignment?: GraphCacheResolver<WithTypename<Query>, QueryPublicStudentAiAssignmentArgs, WithTypename<StudentAiAssignment> | string>,
    publicTopic?: GraphCacheResolver<WithTypename<Query>, QueryPublicTopicArgs, WithTypename<Folder> | string>,
    publicTopicInstances?: GraphCacheResolver<WithTypename<Query>, QueryPublicTopicInstancesArgs, Array<WithTypename<TopicInstance> | string>>,
    recentExternalContent?: GraphCacheResolver<WithTypename<Query>, QueryRecentExternalContentArgs, WithTypename<ExternalContentResult> | string>,
    schoolTypes?: GraphCacheResolver<WithTypename<Query>, QuerySchoolTypesArgs, Array<WithTypename<SchoolType> | string>>,
    searchContent?: GraphCacheResolver<WithTypename<Query>, QuerySearchContentArgs, Array<WithTypename<Content> | string>>,
    searchExternalContent?: GraphCacheResolver<WithTypename<Query>, QuerySearchExternalContentArgs, WithTypename<ExternalContentResult> | string>,
    studentAiAssignment?: GraphCacheResolver<WithTypename<Query>, QueryStudentAiAssignmentArgs, WithTypename<StudentAiAssignment> | string>,
    studentAiAssignments?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<StudentAiAssignment> | string>>,
    studentAiTemplate?: GraphCacheResolver<WithTypename<Query>, QueryStudentAiTemplateArgs, WithTypename<StudentAiTemplate> | string>,
    studentAiTemplates?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<StudentAiTemplate> | string>>,
    studentAssignmentOpenQuestionHistory?: GraphCacheResolver<WithTypename<Query>, QueryStudentAssignmentOpenQuestionHistoryArgs, WithTypename<StudentAssignmentOpenQuestionHistory> | string>,
    supportToken?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<SupportTokenResult> | string>,
    tenantEditableSchoolYears?: GraphCacheResolver<WithTypename<Query>, QueryTenantEditableSchoolYearsArgs, Array<WithTypename<SchoolYear> | string>>,
    tenantInvitePreview?: GraphCacheResolver<WithTypename<Query>, QueryTenantInvitePreviewArgs, WithTypename<TenantInvitePreview> | string>,
    tenantMembers?: GraphCacheResolver<WithTypename<Query>, QueryTenantMembersArgs, Array<WithTypename<TenantMember> | string>>,
    timetableExtension?: GraphCacheResolver<WithTypename<Query>, QueryTimetableExtensionArgs, WithTypename<TimetableExtension> | string>,
    timetableExtensions?: GraphCacheResolver<WithTypename<Query>, QueryTimetableExtensionsArgs, Array<WithTypename<TimetableExtension> | string>>,
    timetableForCourse?: GraphCacheResolver<WithTypename<Query>, QueryTimetableForCourseArgs, Array<WithTypename<TimetableDay> | string>>,
    timetableForUser?: GraphCacheResolver<WithTypename<Query>, QueryTimetableForUserArgs, WithTypename<TimetableDayResult> | string>,
    timetablePeriodAlternativesForCourse?: GraphCacheResolver<WithTypename<Query>, QueryTimetablePeriodAlternativesForCourseArgs, Array<WithTypename<TimetablePeriod> | string>>,
    timetableStructure?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<Timetable> | string>,
    toDos?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<ToDo> | string>>,
    topic?: GraphCacheResolver<WithTypename<Query>, QueryTopicArgs, WithTypename<Folder> | string>,
    topicContent?: GraphCacheResolver<WithTypename<Query>, QueryTopicContentArgs, WithTypename<TopicContent> | string>,
    topicInstance?: GraphCacheResolver<WithTypename<Query>, QueryTopicInstanceArgs, WithTypename<TopicInstance> | string>,
    topicInstanceForTopicInCourse?: GraphCacheResolver<WithTypename<Query>, QueryTopicInstanceForTopicInCourseArgs, WithTypename<TopicInstance> | string>,
    topicInstances?: GraphCacheResolver<WithTypename<Query>, QueryTopicInstancesArgs, Array<WithTypename<TopicInstance> | string>>,
    topics?: GraphCacheResolver<WithTypename<Query>, QueryTopicsArgs, Array<WithTypename<Folder> | string>>,
    userCalendarDays?: GraphCacheResolver<WithTypename<Query>, QueryUserCalendarDaysArgs, Array<WithTypename<UserCalendarDay> | string>>,
    userEmailNotificationSubscriptions?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<UserEmailNotificationSubscription> | string>>,
    userPlans?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<Plan> | string>>
  },
  AiSettings?: {
    age?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['Float']['output'] | string>,
    course?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, WithTypename<Course> | string>,
    createdAt?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    curriculum?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['String']['output'] | string>,
    language?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, AiLanguage | string>,
    linkedCurriculum?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, WithTypename<Curriculum> | string>,
    linkedCurriculumContent?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, WithTypename<CurriculumContent> | string>,
    subject?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['String']['output'] | string>
  },
  AiSettingsResult?: {
    age?: GraphCacheResolver<WithTypename<AiSettingsResult>, Record<string, never>, Scalars['Float']['output'] | string>,
    curriculum?: GraphCacheResolver<WithTypename<AiSettingsResult>, Record<string, never>, Scalars['String']['output'] | string>,
    language?: GraphCacheResolver<WithTypename<AiSettingsResult>, Record<string, never>, Scalars['String']['output'] | string>,
    linkedCurriculum?: GraphCacheResolver<WithTypename<AiSettingsResult>, Record<string, never>, Scalars['String']['output'] | string>,
    linkedCurriculumContent?: GraphCacheResolver<WithTypename<AiSettingsResult>, Record<string, never>, Scalars['String']['output'] | string>,
    subject?: GraphCacheResolver<WithTypename<AiSettingsResult>, Record<string, never>, Scalars['String']['output'] | string>
  },
  AssignmentChatbot?: {
    id?: GraphCacheResolver<WithTypename<AssignmentChatbot>, Record<string, never>, Scalars['String']['output'] | string>,
    title?: GraphCacheResolver<WithTypename<AssignmentChatbot>, Record<string, never>, Scalars['String']['output'] | string>
  },
  AssignmentChatbotHistory?: {
    assignmentId?: GraphCacheResolver<WithTypename<AssignmentChatbotHistory>, Record<string, never>, Scalars['String']['output'] | string>,
    instances?: GraphCacheResolver<WithTypename<AssignmentChatbotHistory>, Record<string, never>, Array<WithTypename<AssignmentChatbotInstanceSummary> | string>>,
    nickname?: GraphCacheResolver<WithTypename<AssignmentChatbotHistory>, Record<string, never>, Scalars['String']['output'] | string>,
    title?: GraphCacheResolver<WithTypename<AssignmentChatbotHistory>, Record<string, never>, Scalars['String']['output'] | string>
  },
  AssignmentChatbotInstanceSummary?: {
    createdAt?: GraphCacheResolver<WithTypename<AssignmentChatbotInstanceSummary>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    instanceId?: GraphCacheResolver<WithTypename<AssignmentChatbotInstanceSummary>, Record<string, never>, Scalars['String']['output'] | string>,
    isActive?: GraphCacheResolver<WithTypename<AssignmentChatbotInstanceSummary>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    messages?: GraphCacheResolver<WithTypename<AssignmentChatbotInstanceSummary>, Record<string, never>, Array<WithTypename<AssignmentChatbotMessage> | string>>
  },
  AssignmentChatbotMessage?: {
    content?: GraphCacheResolver<WithTypename<AssignmentChatbotMessage>, Record<string, never>, Scalars['String']['output'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<AssignmentChatbotMessage>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<AssignmentChatbotMessage>, Record<string, never>, Scalars['String']['output'] | string>,
    role?: GraphCacheResolver<WithTypename<AssignmentChatbotMessage>, Record<string, never>, Scalars['String']['output'] | string>
  },
  AssignmentOpenQuestion?: {
    guidance?: GraphCacheResolver<WithTypename<AssignmentOpenQuestion>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<AssignmentOpenQuestion>, Record<string, never>, Scalars['String']['output'] | string>,
    question?: GraphCacheResolver<WithTypename<AssignmentOpenQuestion>, Record<string, never>, Scalars['String']['output'] | string>,
    type?: GraphCacheResolver<WithTypename<AssignmentOpenQuestion>, Record<string, never>, Scalars['String']['output'] | string>
  },
  AssignmentOpenQuestionAttempt?: {
    answer?: GraphCacheResolver<WithTypename<AssignmentOpenQuestionAttempt>, Record<string, never>, Scalars['String']['output'] | string>,
    feedback?: GraphCacheResolver<WithTypename<AssignmentOpenQuestionAttempt>, Record<string, never>, Scalars['String']['output'] | string>,
    hints?: GraphCacheResolver<WithTypename<AssignmentOpenQuestionAttempt>, Record<string, never>, Array<Scalars['String']['output'] | string>>,
    rating?: GraphCacheResolver<WithTypename<AssignmentOpenQuestionAttempt>, Record<string, never>, InteractiveAssignmentAiFeedbackRating | string>
  },
  AssignmentOpenQuestionHistory?: {
    attempts?: GraphCacheResolver<WithTypename<AssignmentOpenQuestionHistory>, Record<string, never>, Array<WithTypename<AssignmentOpenQuestionAttempt> | string>>,
    guidance?: GraphCacheResolver<WithTypename<AssignmentOpenQuestionHistory>, Record<string, never>, Scalars['String']['output'] | string>,
    nickname?: GraphCacheResolver<WithTypename<AssignmentOpenQuestionHistory>, Record<string, never>, Scalars['String']['output'] | string>,
    question?: GraphCacheResolver<WithTypename<AssignmentOpenQuestionHistory>, Record<string, never>, Scalars['String']['output'] | string>
  },
  AssignmentStatus?: {
    assignmentId?: GraphCacheResolver<WithTypename<AssignmentStatus>, Record<string, never>, Scalars['String']['output'] | string>,
    feedbackCount?: GraphCacheResolver<WithTypename<AssignmentStatus>, Record<string, never>, Scalars['Float']['output'] | string>,
    hintCount?: GraphCacheResolver<WithTypename<AssignmentStatus>, Record<string, never>, Scalars['Float']['output'] | string>,
    latestAnswer?: GraphCacheResolver<WithTypename<AssignmentStatus>, Record<string, never>, Scalars['String']['output'] | string>,
    latestSelectedOptionIds?: GraphCacheResolver<WithTypename<AssignmentStatus>, Record<string, never>, Array<Scalars['String']['output'] | string>>,
    messageCount?: GraphCacheResolver<WithTypename<AssignmentStatus>, Record<string, never>, Scalars['Float']['output'] | string>,
    status?: GraphCacheResolver<WithTypename<AssignmentStatus>, Record<string, never>, InteractiveAssignmentStatus | string>
  },
  AuthResult?: {
    access_token?: GraphCacheResolver<WithTypename<AuthResult>, Record<string, never>, Scalars['String']['output'] | string>,
    refresh_token?: GraphCacheResolver<WithTypename<AuthResult>, Record<string, never>, Scalars['String']['output'] | string>,
    userId?: GraphCacheResolver<WithTypename<AuthResult>, Record<string, never>, Scalars['String']['output'] | string>
  },
  CalendarEventListResult?: {
    calendarEvents?: GraphCacheResolver<WithTypename<CalendarEventListResult>, Record<string, never>, Array<WithTypename<CalendarEvent> | string>>
  },
  CalendarEventResult?: {
    calendarEvent?: GraphCacheResolver<WithTypename<CalendarEventResult>, Record<string, never>, WithTypename<CalendarEvent> | string>
  },
  CalendarNote?: {
    backgroundColor?: GraphCacheResolver<WithTypename<CalendarNote>, Record<string, never>, Scalars['String']['output'] | string>,
    course?: GraphCacheResolver<WithTypename<CalendarNote>, Record<string, never>, WithTypename<Course> | string>,
    createdAt?: GraphCacheResolver<WithTypename<CalendarNote>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    foregroundColor?: GraphCacheResolver<WithTypename<CalendarNote>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<CalendarNote>, Record<string, never>, Scalars['String']['output'] | string>,
    note?: GraphCacheResolver<WithTypename<CalendarNote>, Record<string, never>, Scalars['String']['output'] | string>
  },
  CalendarNoteResult?: {
    calendarNote?: GraphCacheResolver<WithTypename<CalendarNoteResult>, Record<string, never>, WithTypename<CalendarNote> | string>
  },
  Configuration?: {
    featureFlags?: GraphCacheResolver<WithTypename<Configuration>, Record<string, never>, Array<WithTypename<FeatureFlag> | string>>,
    global?: GraphCacheResolver<WithTypename<Configuration>, Record<string, never>, WithTypename<GlobalConfiguration> | string>
  },
  ConnectedCourse?: {
    course?: GraphCacheResolver<WithTypename<ConnectedCourse>, Record<string, never>, WithTypename<Course> | string>,
    displayName?: GraphCacheResolver<WithTypename<ConnectedCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    externalCourseMappingId?: GraphCacheResolver<WithTypename<ConnectedCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    externalId?: GraphCacheResolver<WithTypename<ConnectedCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    externalUserCredentialsId?: GraphCacheResolver<WithTypename<ConnectedCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    roleInCourse?: GraphCacheResolver<WithTypename<ConnectedCourse>, Record<string, never>, CourseMembershipRole | string>
  },
  Country?: {
    createdAt?: GraphCacheResolver<WithTypename<Country>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<Country>, Record<string, never>, Scalars['String']['output'] | string>,
    languageDefault?: GraphCacheResolver<WithTypename<Country>, Record<string, never>, Language | string>,
    name?: GraphCacheResolver<WithTypename<Country>, Record<string, never>, Scalars['String']['output'] | string>
  },
  CountryStateCombo?: {
    countryName?: GraphCacheResolver<WithTypename<CountryStateCombo>, Record<string, never>, Scalars['String']['output'] | string>,
    displayName?: GraphCacheResolver<WithTypename<CountryStateCombo>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<CountryStateCombo>, Record<string, never>, Scalars['String']['output'] | string>,
    language?: GraphCacheResolver<WithTypename<CountryStateCombo>, Record<string, never>, Language | string>,
    stateId?: GraphCacheResolver<WithTypename<CountryStateCombo>, Record<string, never>, Scalars['String']['output'] | string>,
    stateName?: GraphCacheResolver<WithTypename<CountryStateCombo>, Record<string, never>, Scalars['String']['output'] | string>
  },
  Course?: {
    backgroundColor?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    classLevelAge?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    classLevelKey?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    classLevelLabel?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    closedAt?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    collaborators?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Array<WithTypename<CourseCollaborator> | string>>,
    countryKey?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    countryLabel?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    days?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Array<Scalars['String']['output'] | string>>,
    externalCourseMappings?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Array<WithTypename<ExternalCourseMapping> | string>>,
    foregroundColor?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    hasOrigin?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    languageKey?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    languageLabel?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    lastOriginSyncAt?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    origin?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, WithTypename<Course> | string>,
    originDetails?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, WithTypename<OriginDetails> | string>,
    owner?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, WithTypename<User> | string>,
    permissions?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, WithTypename<UserCoursePermission> | string>,
    promptingAddition?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    schoolTypeKey?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    schoolTypeLabel?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    schoolYear?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, WithTypename<SchoolYear> | string>,
    shortName?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    stateKey?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    stateLabel?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    subject?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, WithTypename<Subject> | string>,
    subjectKey?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    subjectLabel?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String']['output'] | string>,
    tenant?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, WithTypename<Tenant> | string>,
    usage?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, UsageType | string>
  },
  CourseCalendarDay?: {
    calendarEvents?: GraphCacheResolver<WithTypename<CourseCalendarDay>, Record<string, never>, Array<WithTypename<CalendarEvent> | string>>,
    day?: GraphCacheResolver<WithTypename<CourseCalendarDay>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<CourseCalendarDay>, Record<string, never>, Scalars['String']['output'] | string>,
    periodCourse?: GraphCacheResolver<WithTypename<CourseCalendarDay>, Record<string, never>, WithTypename<PeriodCourse> | string>
  },
  CourseCollaborator?: {
    courseRole?: GraphCacheResolver<WithTypename<CourseCollaborator>, Record<string, never>, CourseMembershipRole | string>,
    fullName?: GraphCacheResolver<WithTypename<CourseCollaborator>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<CourseCollaborator>, Record<string, never>, Scalars['String']['output'] | string>,
    joinedAt?: GraphCacheResolver<WithTypename<CourseCollaborator>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    userId?: GraphCacheResolver<WithTypename<CourseCollaborator>, Record<string, never>, Scalars['String']['output'] | string>
  },
  CourseCollaboratorResult?: {
    courseCollaborator?: GraphCacheResolver<WithTypename<CourseCollaboratorResult>, Record<string, never>, WithTypename<CourseCollaborator> | string>
  },
  CourseContentVisibility?: {
    contentVisibility?: GraphCacheResolver<WithTypename<CourseContentVisibility>, Record<string, never>, ContentVisibility | string>,
    createdAt?: GraphCacheResolver<WithTypename<CourseContentVisibility>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<CourseContentVisibility>, Record<string, never>, Scalars['String']['output'] | string>
  },
  CourseFolder?: {
    courseId?: GraphCacheResolver<WithTypename<CourseFolder>, Record<string, never>, Scalars['String']['output'] | string>,
    courseMaterials?: GraphCacheResolver<WithTypename<CourseFolder>, Record<string, never>, Array<WithTypename<CourseMaterial> | string>>,
    endDate?: GraphCacheResolver<WithTypename<CourseFolder>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    folder?: GraphCacheResolver<WithTypename<CourseFolder>, Record<string, never>, WithTypename<Folder> | string>,
    id?: GraphCacheResolver<WithTypename<CourseFolder>, Record<string, never>, Scalars['String']['output'] | string>,
    materialCount?: GraphCacheResolver<WithTypename<CourseFolder>, Record<string, never>, Scalars['Float']['output'] | string>,
    startDate?: GraphCacheResolver<WithTypename<CourseFolder>, Record<string, never>, Scalars['DateTime']['output'] | string>
  },
  CourseFolderResult?: {
    courseFolder?: GraphCacheResolver<WithTypename<CourseFolderResult>, Record<string, never>, WithTypename<CourseFolder> | string>
  },
  CourseInvite?: {
    code?: GraphCacheResolver<WithTypename<CourseInvite>, Record<string, never>, Scalars['String']['output'] | string>,
    course?: GraphCacheResolver<WithTypename<CourseInvite>, Record<string, never>, WithTypename<Course> | string>,
    courseMembershipRole?: GraphCacheResolver<WithTypename<CourseInvite>, Record<string, never>, CourseMembershipRole | string>,
    createdAt?: GraphCacheResolver<WithTypename<CourseInvite>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    expirationDate?: GraphCacheResolver<WithTypename<CourseInvite>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    expiredAt?: GraphCacheResolver<WithTypename<CourseInvite>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<CourseInvite>, Record<string, never>, Scalars['String']['output'] | string>
  },
  CourseInvitePreview?: {
    backgroundColor?: GraphCacheResolver<WithTypename<CourseInvitePreview>, Record<string, never>, Scalars['String']['output'] | string>,
    courseId?: GraphCacheResolver<WithTypename<CourseInvitePreview>, Record<string, never>, Scalars['String']['output'] | string>,
    courseMember?: GraphCacheResolver<WithTypename<CourseInvitePreview>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    courseName?: GraphCacheResolver<WithTypename<CourseInvitePreview>, Record<string, never>, Scalars['String']['output'] | string>,
    courseOwner?: GraphCacheResolver<WithTypename<CourseInvitePreview>, Record<string, never>, Scalars['String']['output'] | string>,
    expiredAt?: GraphCacheResolver<WithTypename<CourseInvitePreview>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    foregroundColor?: GraphCacheResolver<WithTypename<CourseInvitePreview>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<CourseInvitePreview>, Record<string, never>, Scalars['String']['output'] | string>
  },
  CourseInviteResult?: {
    courseInvite?: GraphCacheResolver<WithTypename<CourseInviteResult>, Record<string, never>, WithTypename<CourseInvite> | string>
  },
  CourseMaterial?: {
    courseId?: GraphCacheResolver<WithTypename<CourseMaterial>, Record<string, never>, Scalars['String']['output'] | string>,
    courseVisibility?: GraphCacheResolver<WithTypename<CourseMaterial>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    courseVisibleAt?: GraphCacheResolver<WithTypename<CourseMaterial>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    dates?: GraphCacheResolver<WithTypename<CourseMaterial>, Record<string, never>, Array<Scalars['String']['output'] | string>>,
    id?: GraphCacheResolver<WithTypename<CourseMaterial>, Record<string, never>, Scalars['String']['output'] | string>,
    material?: GraphCacheResolver<WithTypename<CourseMaterial>, Record<string, never>, WithTypename<Material> | string>
  },
  CourseMaterialResult?: {
    courseMaterial?: GraphCacheResolver<WithTypename<CourseMaterialResult>, Record<string, never>, WithTypename<CourseMaterial> | string>
  },
  CoursePublicAccess?: {
    code?: GraphCacheResolver<WithTypename<CoursePublicAccess>, Record<string, never>, Scalars['String']['output'] | string>,
    course?: GraphCacheResolver<WithTypename<CoursePublicAccess>, Record<string, never>, WithTypename<Course> | string>,
    createdAt?: GraphCacheResolver<WithTypename<CoursePublicAccess>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<CoursePublicAccess>, Record<string, never>, Scalars['String']['output'] | string>
  },
  CoursePublicAccessResult?: {
    coursePublicAccess?: GraphCacheResolver<WithTypename<CoursePublicAccessResult>, Record<string, never>, WithTypename<CoursePublicAccess> | string>
  },
  CourseResult?: {
    course?: GraphCacheResolver<WithTypename<CourseResult>, Record<string, never>, WithTypename<Course> | string>
  },
  Curriculum?: {
    country?: GraphCacheResolver<WithTypename<Curriculum>, Record<string, never>, Scalars['String']['output'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Curriculum>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<Curriculum>, Record<string, never>, Scalars['String']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<Curriculum>, Record<string, never>, Scalars['String']['output'] | string>,
    state?: GraphCacheResolver<WithTypename<Curriculum>, Record<string, never>, Scalars['String']['output'] | string>
  },
  CurriculumContent?: {
    classLevel?: GraphCacheResolver<WithTypename<CurriculumContent>, Record<string, never>, Scalars['String']['output'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<CurriculumContent>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    curriculum?: GraphCacheResolver<WithTypename<CurriculumContent>, Record<string, never>, WithTypename<Curriculum> | string>,
    id?: GraphCacheResolver<WithTypename<CurriculumContent>, Record<string, never>, Scalars['String']['output'] | string>,
    schoolType?: GraphCacheResolver<WithTypename<CurriculumContent>, Record<string, never>, Scalars['String']['output'] | string>,
    subject?: GraphCacheResolver<WithTypename<CurriculumContent>, Record<string, never>, Scalars['String']['output'] | string>
  },
  DoneResult?: {
    done?: GraphCacheResolver<WithTypename<DoneResult>, Record<string, never>, Scalars['Boolean']['output'] | string>
  },
  ExistingCourseMapping?: {
    courses?: GraphCacheResolver<WithTypename<ExistingCourseMapping>, Record<string, never>, Array<WithTypename<Course> | string>>,
    externalCourse?: GraphCacheResolver<WithTypename<ExistingCourseMapping>, Record<string, never>, WithTypename<ExternalCourse> | string>,
    externalId?: GraphCacheResolver<WithTypename<ExistingCourseMapping>, Record<string, never>, Scalars['String']['output'] | string>
  },
  ExistingCourseMappingResult?: {
    existingCourseMappings?: GraphCacheResolver<WithTypename<ExistingCourseMappingResult>, Record<string, never>, Array<WithTypename<ExistingCourseMapping> | string>>
  },
  ExternalContent?: {
    externalContentCategory?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, ExternalContentCategory | string>,
    externalContentType?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, ExternalContentType | string>,
    externalReferenceId?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, Scalars['String']['output'] | string>,
    preview?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, WithTypename<ExternalContentPreview> | string>,
    primaryUrl?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, Scalars['String']['output'] | string>,
    rootId?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, Scalars['String']['output'] | string>,
    secondaryUrl?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, Scalars['String']['output'] | string>,
    source?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, Scalars['String']['output'] | string>,
    sourceCredentialsExternalId?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, Scalars['String']['output'] | string>,
    title?: GraphCacheResolver<WithTypename<ExternalContent>, Record<string, never>, Scalars['String']['output'] | string>
  },
  ExternalContentApiError?: {
    code?: GraphCacheResolver<WithTypename<ExternalContentApiError>, Record<string, never>, ExternalContentErrorCode | string>,
    internalMessage?: GraphCacheResolver<WithTypename<ExternalContentApiError>, Record<string, never>, Scalars['String']['output'] | string>
  },
  ExternalContentPreview?: {
    contentId?: GraphCacheResolver<WithTypename<ExternalContentPreview>, Record<string, never>, Scalars['String']['output'] | string>,
    description?: GraphCacheResolver<WithTypename<ExternalContentPreview>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<ExternalContentPreview>, Record<string, never>, Scalars['String']['output'] | string>,
    primaryUrl?: GraphCacheResolver<WithTypename<ExternalContentPreview>, Record<string, never>, Scalars['String']['output'] | string>,
    secondaryUrl?: GraphCacheResolver<WithTypename<ExternalContentPreview>, Record<string, never>, Scalars['String']['output'] | string>,
    title?: GraphCacheResolver<WithTypename<ExternalContentPreview>, Record<string, never>, Scalars['String']['output'] | string>
  },
  ExternalContentResult?: {
    errors?: GraphCacheResolver<WithTypename<ExternalContentResult>, Record<string, never>, Array<WithTypename<ExternalContentApiError> | string>>,
    externalContent?: GraphCacheResolver<WithTypename<ExternalContentResult>, Record<string, never>, Array<WithTypename<ExternalContent> | string>>
  },
  ExternalCourse?: {
    displayName?: GraphCacheResolver<WithTypename<ExternalCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    externalId?: GraphCacheResolver<WithTypename<ExternalCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    externalUserCredentialsId?: GraphCacheResolver<WithTypename<ExternalCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    roleInCourse?: GraphCacheResolver<WithTypename<ExternalCourse>, Record<string, never>, CourseMembershipRole | string>
  },
  ExternalCourseMapping?: {
    course?: GraphCacheResolver<WithTypename<ExternalCourseMapping>, Record<string, never>, WithTypename<Course> | string>,
    createdAt?: GraphCacheResolver<WithTypename<ExternalCourseMapping>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    displayName?: GraphCacheResolver<WithTypename<ExternalCourseMapping>, Record<string, never>, Scalars['String']['output'] | string>,
    externalId?: GraphCacheResolver<WithTypename<ExternalCourseMapping>, Record<string, never>, Scalars['String']['output'] | string>,
    externalUserCredentials?: GraphCacheResolver<WithTypename<ExternalCourseMapping>, Record<string, never>, WithTypename<ExternalUserCredentials> | string>,
    id?: GraphCacheResolver<WithTypename<ExternalCourseMapping>, Record<string, never>, Scalars['String']['output'] | string>,
    roleInCourse?: GraphCacheResolver<WithTypename<ExternalCourseMapping>, Record<string, never>, CourseMembershipRole | string>
  },
  ExternalCoursesResult?: {
    connectedCourses?: GraphCacheResolver<WithTypename<ExternalCoursesResult>, Record<string, never>, Array<WithTypename<ConnectedCourse> | string>>,
    ignoredCourses?: GraphCacheResolver<WithTypename<ExternalCoursesResult>, Record<string, never>, Array<WithTypename<IgnoredCourse> | string>>,
    unmappedCourses?: GraphCacheResolver<WithTypename<ExternalCoursesResult>, Record<string, never>, Array<WithTypename<UnmappedCourse> | string>>
  },
  ExternalIntegrationSetting?: {
    additionalIdentifier?: GraphCacheResolver<WithTypename<ExternalIntegrationSetting>, Record<string, never>, Scalars['String']['output'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<ExternalIntegrationSetting>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    displayName?: GraphCacheResolver<WithTypename<ExternalIntegrationSetting>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<ExternalIntegrationSetting>, Record<string, never>, Scalars['String']['output'] | string>,
    integrationFeatures?: GraphCacheResolver<WithTypename<ExternalIntegrationSetting>, Record<string, never>, Array<ExternalIntegrationFeature | string>>,
    key?: GraphCacheResolver<WithTypename<ExternalIntegrationSetting>, Record<string, never>, Scalars['String']['output'] | string>,
    tenant?: GraphCacheResolver<WithTypename<ExternalIntegrationSetting>, Record<string, never>, WithTypename<Tenant> | string>
  },
  ExternalUserCredentials?: {
    createdAt?: GraphCacheResolver<WithTypename<ExternalUserCredentials>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    displayName?: GraphCacheResolver<WithTypename<ExternalUserCredentials>, Record<string, never>, Scalars['String']['output'] | string>,
    email?: GraphCacheResolver<WithTypename<ExternalUserCredentials>, Record<string, never>, Scalars['String']['output'] | string>,
    externalId?: GraphCacheResolver<WithTypename<ExternalUserCredentials>, Record<string, never>, Scalars['String']['output'] | string>,
    externalIntegrationSetting?: GraphCacheResolver<WithTypename<ExternalUserCredentials>, Record<string, never>, WithTypename<ExternalIntegrationSetting> | string>,
    id?: GraphCacheResolver<WithTypename<ExternalUserCredentials>, Record<string, never>, Scalars['String']['output'] | string>,
    user?: GraphCacheResolver<WithTypename<ExternalUserCredentials>, Record<string, never>, WithTypename<User> | string>
  },
  Feature?: {
    createdAt?: GraphCacheResolver<WithTypename<Feature>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<Feature>, Record<string, never>, Scalars['String']['output'] | string>,
    key?: GraphCacheResolver<WithTypename<Feature>, Record<string, never>, Scalars['String']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<Feature>, Record<string, never>, Scalars['String']['output'] | string>
  },
  FeatureFlag?: {
    key?: GraphCacheResolver<WithTypename<FeatureFlag>, Record<string, never>, Scalars['String']['output'] | string>,
    settings?: GraphCacheResolver<WithTypename<FeatureFlag>, Record<string, never>, Scalars['JSON']['output'] | string>
  },
  Folder?: {
    createdAt?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    deletedAt?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    externalContent?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, WithTypename<ExternalContent> | string>,
    goals?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, Scalars['String']['output'] | string>,
    hasOrigin?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, Scalars['String']['output'] | string>,
    lastOriginSyncAt?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    libraryFolder?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, WithTypename<LibraryFolder> | string>,
    name?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, Scalars['String']['output'] | string>,
    originDetails?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, WithTypename<OriginDetails> | string>,
    owner?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, WithTypename<User> | string>,
    permissions?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, WithTypename<UserTopicPermission> | string>,
    position?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, Scalars['Int']['output'] | string>,
    syncContentUpdatedAt?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    topicCourses?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, Array<WithTypename<Course> | string>>,
    topicStatistics?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, WithTypename<TopicStatistics> | string>,
    usage?: GraphCacheResolver<WithTypename<Folder>, Record<string, never>, UsageType | string>
  },
  FolderResult?: {
    folder?: GraphCacheResolver<WithTypename<FolderResult>, Record<string, never>, WithTypename<Folder> | string>
  },
  GlobalConfiguration?: {
    uploadConfiguration?: GraphCacheResolver<WithTypename<GlobalConfiguration>, Record<string, never>, Scalars['JSON']['output'] | string>
  },
  IgnoredCourse?: {
    displayName?: GraphCacheResolver<WithTypename<IgnoredCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    externalCourseMappingId?: GraphCacheResolver<WithTypename<IgnoredCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    externalId?: GraphCacheResolver<WithTypename<IgnoredCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    externalUserCredentialsId?: GraphCacheResolver<WithTypename<IgnoredCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    roleInCourse?: GraphCacheResolver<WithTypename<IgnoredCourse>, Record<string, never>, CourseMembershipRole | string>
  },
  InitialIpiPromptResult?: {
    initialIpiPrompt?: GraphCacheResolver<WithTypename<InitialIpiPromptResult>, Record<string, never>, Scalars['String']['output'] | string>
  },
  IntegrationCheckResult?: {
    connectedUserAuthResult?: GraphCacheResolver<WithTypename<IntegrationCheckResult>, Record<string, never>, WithTypename<AuthResult> | string>,
    integrationToS?: GraphCacheResolver<WithTypename<IntegrationCheckResult>, Record<string, never>, Scalars['String']['output'] | string>,
    temporaryExternalCredentials?: GraphCacheResolver<WithTypename<IntegrationCheckResult>, Record<string, never>, WithTypename<TemporaryExternalCredentials> | string>
  },
  IpiPromptHistoryItem?: {
    createdAt?: GraphCacheResolver<WithTypename<IpiPromptHistoryItem>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<IpiPromptHistoryItem>, Record<string, never>, Scalars['String']['output'] | string>,
    userPrompt?: GraphCacheResolver<WithTypename<IpiPromptHistoryItem>, Record<string, never>, Scalars['String']['output'] | string>
  },
  IpiPromptHistoryResult?: {
    prompts?: GraphCacheResolver<WithTypename<IpiPromptHistoryResult>, Record<string, never>, Array<WithTypename<IpiPromptHistoryItem> | string>>
  },
  IpiPromptSuggestion?: {
    icon?: GraphCacheResolver<WithTypename<IpiPromptSuggestion>, Record<string, never>, Scalars['String']['output'] | string>,
    prompt?: GraphCacheResolver<WithTypename<IpiPromptSuggestion>, Record<string, never>, Scalars['String']['output'] | string>,
    title?: GraphCacheResolver<WithTypename<IpiPromptSuggestion>, Record<string, never>, Scalars['String']['output'] | string>
  },
  ItemContent?: {
    id?: GraphCacheResolver<WithTypename<ItemContent>, Record<string, never>, Scalars['String']['output'] | string>,
    item?: GraphCacheResolver<WithTypename<ItemContent>, Record<string, never>, WithTypename<Material> | string>,
    itemInstances?: GraphCacheResolver<WithTypename<ItemContent>, Record<string, never>, Array<WithTypename<ItemInstance> | string>>
  },
  ItemInstance?: {
    course?: GraphCacheResolver<WithTypename<ItemInstance>, Record<string, never>, WithTypename<Course> | string>,
    courseContentVisibility?: GraphCacheResolver<WithTypename<ItemInstance>, Record<string, never>, WithTypename<CourseContentVisibility> | string>,
    createdAt?: GraphCacheResolver<WithTypename<ItemInstance>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    dates?: GraphCacheResolver<WithTypename<ItemInstance>, Record<string, never>, Array<Scalars['String']['output'] | string>>,
    id?: GraphCacheResolver<WithTypename<ItemInstance>, Record<string, never>, Scalars['String']['output'] | string>,
    item?: GraphCacheResolver<WithTypename<ItemInstance>, Record<string, never>, WithTypename<Material> | string>,
    lockedAt?: GraphCacheResolver<WithTypename<ItemInstance>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    topicInstance?: GraphCacheResolver<WithTypename<ItemInstance>, Record<string, never>, WithTypename<TopicInstance> | string>
  },
  ItemInstanceResult?: {
    itemInstance?: GraphCacheResolver<WithTypename<ItemInstanceResult>, Record<string, never>, WithTypename<ItemInstance> | string>
  },
  ItemResult?: {
    item?: GraphCacheResolver<WithTypename<ItemResult>, Record<string, never>, WithTypename<Material> | string>
  },
  LibraryFolder?: {
    children?: GraphCacheResolver<WithTypename<LibraryFolder>, Record<string, never>, Array<WithTypename<LibraryFolder> | string>>,
    createdAt?: GraphCacheResolver<WithTypename<LibraryFolder>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    folderColor?: GraphCacheResolver<WithTypename<LibraryFolder>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<LibraryFolder>, Record<string, never>, Scalars['String']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<LibraryFolder>, Record<string, never>, Scalars['String']['output'] | string>,
    parentFolder?: GraphCacheResolver<WithTypename<LibraryFolder>, Record<string, never>, WithTypename<LibraryFolder> | string>,
    parents?: GraphCacheResolver<WithTypename<LibraryFolder>, Record<string, never>, Array<WithTypename<LibraryFolder> | string>>,
    position?: GraphCacheResolver<WithTypename<LibraryFolder>, Record<string, never>, Scalars['Int']['output'] | string>,
    user?: GraphCacheResolver<WithTypename<LibraryFolder>, Record<string, never>, WithTypename<User> | string>
  },
  LibraryFolderResult?: {
    libraryFolder?: GraphCacheResolver<WithTypename<LibraryFolderResult>, Record<string, never>, WithTypename<LibraryFolder> | string>
  },
  LibraryMetaResult?: {
    totalTopicsCount?: GraphCacheResolver<WithTypename<LibraryMetaResult>, Record<string, never>, Scalars['Float']['output'] | string>,
    unsortedTopicsCount?: GraphCacheResolver<WithTypename<LibraryMetaResult>, Record<string, never>, Scalars['Float']['output'] | string>
  },
  LibraryNewestContentResult?: {
    id?: GraphCacheResolver<WithTypename<LibraryNewestContentResult>, Record<string, never>, Scalars['String']['output'] | string>,
    materials?: GraphCacheResolver<WithTypename<LibraryNewestContentResult>, Record<string, never>, Array<WithTypename<Material> | string>>,
    topics?: GraphCacheResolver<WithTypename<LibraryNewestContentResult>, Record<string, never>, Array<WithTypename<Folder> | string>>
  },
  License?: {
    createdAt?: GraphCacheResolver<WithTypename<License>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    cycleRenewalAt?: GraphCacheResolver<WithTypename<License>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    cycleStartAt?: GraphCacheResolver<WithTypename<License>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    expiresAt?: GraphCacheResolver<WithTypename<License>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    holderType?: GraphCacheResolver<WithTypename<License>, Record<string, never>, LicenseHolderType | string>,
    id?: GraphCacheResolver<WithTypename<License>, Record<string, never>, Scalars['String']['output'] | string>,
    plan?: GraphCacheResolver<WithTypename<License>, Record<string, never>, WithTypename<Plan> | string>,
    planStartAt?: GraphCacheResolver<WithTypename<License>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    tenant?: GraphCacheResolver<WithTypename<License>, Record<string, never>, WithTypename<Tenant> | string>
  },
  LinkPreviewExtra?: {
    description?: GraphCacheResolver<WithTypename<LinkPreviewExtra>, Record<string, never>, Scalars['String']['output'] | string>,
    iframe?: GraphCacheResolver<WithTypename<LinkPreviewExtra>, Record<string, never>, Scalars['String']['output'] | string>,
    imageUrl?: GraphCacheResolver<WithTypename<LinkPreviewExtra>, Record<string, never>, Scalars['String']['output'] | string>,
    title?: GraphCacheResolver<WithTypename<LinkPreviewExtra>, Record<string, never>, Scalars['String']['output'] | string>,
    url?: GraphCacheResolver<WithTypename<LinkPreviewExtra>, Record<string, never>, Scalars['String']['output'] | string>
  },
  Material?: {
    annotationToolToken?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['String']['output'] | string>,
    contentHtml?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, WithTypename<MaterialContentHtml> | string>,
    contentStatistics?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, WithTypename<MaterialContentStatistics> | string>,
    createdAt?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    deletedAt?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    duration?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['Float']['output'] | string>,
    externalContent?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, WithTypename<ExternalContent> | string>,
    hasOrigin?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    icon?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['String']['output'] | string>,
    initialIpiRequestId?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['String']['output'] | string>,
    lastOriginSyncAt?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    linkedTopics?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Array<WithTypename<Folder> | string>>,
    migratedToMaterial?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['String']['output'] | string>,
    newEditor?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    originDetails?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, WithTypename<OriginDetails> | string>,
    owner?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, WithTypename<User> | string>,
    permissions?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, WithTypename<UserItemPermission> | string>,
    position?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['Float']['output'] | string>,
    syncContentUpdatedAt?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    topic?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, WithTypename<Folder> | string>,
    updatedAt?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    usage?: GraphCacheResolver<WithTypename<Material>, Record<string, never>, UsageType | string>
  },
  MaterialAnnotationToolAccess?: {
    expiresAt?: GraphCacheResolver<WithTypename<MaterialAnnotationToolAccess>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    token?: GraphCacheResolver<WithTypename<MaterialAnnotationToolAccess>, Record<string, never>, Scalars['String']['output'] | string>
  },
  MaterialContentHtml?: {
    html?: GraphCacheResolver<WithTypename<MaterialContentHtml>, Record<string, never>, Scalars['String']['output'] | string>
  },
  MaterialContentStatistics?: {
    fileCount?: GraphCacheResolver<WithTypename<MaterialContentStatistics>, Record<string, never>, Scalars['Float']['output'] | string>,
    imageCount?: GraphCacheResolver<WithTypename<MaterialContentStatistics>, Record<string, never>, Scalars['Float']['output'] | string>,
    interactiveAssignmentCount?: GraphCacheResolver<WithTypename<MaterialContentStatistics>, Record<string, never>, Scalars['Float']['output'] | string>,
    linkCount?: GraphCacheResolver<WithTypename<MaterialContentStatistics>, Record<string, never>, Scalars['Float']['output'] | string>,
    noteCount?: GraphCacheResolver<WithTypename<MaterialContentStatistics>, Record<string, never>, Scalars['Float']['output'] | string>
  },
  MaterialCourse?: {
    backgroundColor?: GraphCacheResolver<WithTypename<MaterialCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    code?: GraphCacheResolver<WithTypename<MaterialCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    foregroundColor?: GraphCacheResolver<WithTypename<MaterialCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<MaterialCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    isSharedWithStudents?: GraphCacheResolver<WithTypename<MaterialCourse>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<MaterialCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    shortName?: GraphCacheResolver<WithTypename<MaterialCourse>, Record<string, never>, Scalars['String']['output'] | string>
  },
  MaterialInteractiveAssignmentStatus?: {
    materialId?: GraphCacheResolver<WithTypename<MaterialInteractiveAssignmentStatus>, Record<string, never>, Scalars['String']['output'] | string>,
    started?: GraphCacheResolver<WithTypename<MaterialInteractiveAssignmentStatus>, Record<string, never>, Scalars['Float']['output'] | string>
  },
  MaterialInteractiveAssignmentsStudentOverview?: {
    assignmentsStatus?: GraphCacheResolver<WithTypename<MaterialInteractiveAssignmentsStudentOverview>, Record<string, never>, Array<WithTypename<AssignmentStatus> | string>>,
    lastActivity?: GraphCacheResolver<WithTypename<MaterialInteractiveAssignmentsStudentOverview>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    nickname?: GraphCacheResolver<WithTypename<MaterialInteractiveAssignmentsStudentOverview>, Record<string, never>, Scalars['String']['output'] | string>,
    sessionId?: GraphCacheResolver<WithTypename<MaterialInteractiveAssignmentsStudentOverview>, Record<string, never>, Scalars['String']['output'] | string>
  },
  MaterialResult?: {
    material?: GraphCacheResolver<WithTypename<MaterialResult>, Record<string, never>, WithTypename<Material> | string>
  },
  OriginDetails?: {
    contentChanged?: GraphCacheResolver<WithTypename<OriginDetails>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<OriginDetails>, Record<string, never>, Scalars['String']['output'] | string>,
    newAdditions?: GraphCacheResolver<WithTypename<OriginDetails>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    updatedAt?: GraphCacheResolver<WithTypename<OriginDetails>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    usage?: GraphCacheResolver<WithTypename<OriginDetails>, Record<string, never>, UsageType | string>
  },
  PaymentGatewayManagementData?: {
    gateway?: GraphCacheResolver<WithTypename<PaymentGatewayManagementData>, Record<string, never>, PaymentGateway | string>,
    url?: GraphCacheResolver<WithTypename<PaymentGatewayManagementData>, Record<string, never>, Scalars['String']['output'] | string>
  },
  PeriodCourse?: {
    backgroundColor?: GraphCacheResolver<WithTypename<PeriodCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    external?: GraphCacheResolver<WithTypename<PeriodCourse>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    foregroundColor?: GraphCacheResolver<WithTypename<PeriodCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<PeriodCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<PeriodCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    shortName?: GraphCacheResolver<WithTypename<PeriodCourse>, Record<string, never>, Scalars['String']['output'] | string>
  },
  Plan?: {
    billingCycle?: GraphCacheResolver<WithTypename<Plan>, Record<string, never>, BillingCycle | string>,
    createdAt?: GraphCacheResolver<WithTypename<Plan>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    defaultForKey?: GraphCacheResolver<WithTypename<Plan>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    defaultPrice?: GraphCacheResolver<WithTypename<Plan>, Record<string, never>, Scalars['Float']['output'] | string>,
    defaultPriceMonth?: GraphCacheResolver<WithTypename<Plan>, Record<string, never>, Scalars['Float']['output'] | string>,
    features?: GraphCacheResolver<WithTypename<Plan>, Record<string, never>, Array<WithTypename<Feature> | string>>,
    id?: GraphCacheResolver<WithTypename<Plan>, Record<string, never>, Scalars['String']['output'] | string>,
    key?: GraphCacheResolver<WithTypename<Plan>, Record<string, never>, Scalars['String']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<Plan>, Record<string, never>, Scalars['String']['output'] | string>,
    type?: GraphCacheResolver<WithTypename<Plan>, Record<string, never>, PlanType | string>
  },
  SchoolType?: {
    createdAt?: GraphCacheResolver<WithTypename<SchoolType>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<SchoolType>, Record<string, never>, Scalars['String']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<SchoolType>, Record<string, never>, Scalars['String']['output'] | string>
  },
  SchoolYear?: {
    createdAt?: GraphCacheResolver<WithTypename<SchoolYear>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    endDate?: GraphCacheResolver<WithTypename<SchoolYear>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<SchoolYear>, Record<string, never>, Scalars['String']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<SchoolYear>, Record<string, never>, Scalars['String']['output'] | string>,
    startDate?: GraphCacheResolver<WithTypename<SchoolYear>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    tenant?: GraphCacheResolver<WithTypename<SchoolYear>, Record<string, never>, WithTypename<Tenant> | string>
  },
  StudentAiAssignment?: {
    active?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    code?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, Scalars['String']['output'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    deletedAt?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    description?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, Scalars['String']['output'] | string>,
    studentAiTemplate?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, WithTypename<StudentAiTemplate> | string>,
    studentTasks?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, Array<Scalars['String']['output'] | string>>,
    systemPrompt?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, Scalars['String']['output'] | string>,
    title?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, Scalars['String']['output'] | string>,
    user?: GraphCacheResolver<WithTypename<StudentAiAssignment>, Record<string, never>, WithTypename<User> | string>
  },
  StudentAiAssignmentResult?: {
    studentAiAssignment?: GraphCacheResolver<WithTypename<StudentAiAssignmentResult>, Record<string, never>, WithTypename<StudentAiAssignment> | string>
  },
  StudentAiTemplate?: {
    categories?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Array<Scalars['String']['output'] | string>>,
    classLevelName?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    description?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>,
    imageUrl?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>,
    key?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>,
    languageName?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>,
    publicDescription?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>,
    published?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    status?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, StudentAiTemplateStatus | string>,
    studentAge?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>,
    studentTasks?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Array<Scalars['String']['output'] | string>>,
    subjectName?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>,
    systemPrompt?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>,
    tags?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Array<Scalars['String']['output'] | string>>,
    title?: GraphCacheResolver<WithTypename<StudentAiTemplate>, Record<string, never>, Scalars['String']['output'] | string>
  },
  StudentAssignmentOpenQuestionHistory?: {
    attempts?: GraphCacheResolver<WithTypename<StudentAssignmentOpenQuestionHistory>, Record<string, never>, Array<WithTypename<AssignmentOpenQuestionAttempt> | string>>,
    nickname?: GraphCacheResolver<WithTypename<StudentAssignmentOpenQuestionHistory>, Record<string, never>, Scalars['String']['output'] | string>
  },
  Subject?: {
    createdAt?: GraphCacheResolver<WithTypename<Subject>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<Subject>, Record<string, never>, Scalars['String']['output'] | string>,
    key?: GraphCacheResolver<WithTypename<Subject>, Record<string, never>, Scalars['String']['output'] | string>,
    name?: GraphCacheResolver<WithTypename<Subject>, Record<string, never>, Scalars['String']['output'] | string>,
    type?: GraphCacheResolver<WithTypename<Subject>, Record<string, never>, Scalars['String']['output'] | string>
  },
  SupportTokenResult?: {
    createdAt?: GraphCacheResolver<WithTypename<SupportTokenResult>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    token?: GraphCacheResolver<WithTypename<SupportTokenResult>, Record<string, never>, Scalars['String']['output'] | string>
  },
  TeachinoAiArea?: {
    aiGroups?: GraphCacheResolver<WithTypename<TeachinoAiArea>, Record<string, never>, Array<WithTypename<TeachinoAiGroup> | string>>,
    freeInputTask?: GraphCacheResolver<WithTypename<TeachinoAiArea>, Record<string, never>, WithTypename<TeachinoAiTask> | string>,
    id?: GraphCacheResolver<WithTypename<TeachinoAiArea>, Record<string, never>, Scalars['String']['output'] | string>
  },
  TeachinoAiGroup?: {
    aiTasks?: GraphCacheResolver<WithTypename<TeachinoAiGroup>, Record<string, never>, Array<WithTypename<TeachinoAiTask> | string>>,
    description?: GraphCacheResolver<WithTypename<TeachinoAiGroup>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TeachinoAiGroup>, Record<string, never>, Scalars['String']['output'] | string>,
    title?: GraphCacheResolver<WithTypename<TeachinoAiGroup>, Record<string, never>, Scalars['String']['output'] | string>
  },
  TeachinoAiTask?: {
    description?: GraphCacheResolver<WithTypename<TeachinoAiTask>, Record<string, never>, Scalars['String']['output'] | string>,
    icon?: GraphCacheResolver<WithTypename<TeachinoAiTask>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TeachinoAiTask>, Record<string, never>, Scalars['String']['output'] | string>,
    supportedInputBlocks?: GraphCacheResolver<WithTypename<TeachinoAiTask>, Record<string, never>, Array<Scalars['String']['output'] | string>>,
    taskType?: GraphCacheResolver<WithTypename<TeachinoAiTask>, Record<string, never>, AiTaskType | string>,
    title?: GraphCacheResolver<WithTypename<TeachinoAiTask>, Record<string, never>, Scalars['String']['output'] | string>
  },
  TemporaryExternalCredentials?: {
    createdAt?: GraphCacheResolver<WithTypename<TemporaryExternalCredentials>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    displayName?: GraphCacheResolver<WithTypename<TemporaryExternalCredentials>, Record<string, never>, Scalars['String']['output'] | string>,
    email?: GraphCacheResolver<WithTypename<TemporaryExternalCredentials>, Record<string, never>, Scalars['String']['output'] | string>,
    externalId?: GraphCacheResolver<WithTypename<TemporaryExternalCredentials>, Record<string, never>, Scalars['String']['output'] | string>,
    externalIntegrationSetting?: GraphCacheResolver<WithTypename<TemporaryExternalCredentials>, Record<string, never>, WithTypename<ExternalIntegrationSetting> | string>,
    id?: GraphCacheResolver<WithTypename<TemporaryExternalCredentials>, Record<string, never>, Scalars['String']['output'] | string>,
    temporaryCode?: GraphCacheResolver<WithTypename<TemporaryExternalCredentials>, Record<string, never>, Scalars['String']['output'] | string>,
    user?: GraphCacheResolver<WithTypename<TemporaryExternalCredentials>, Record<string, never>, WithTypename<User> | string>
  },
  Tenant?: {
    city?: GraphCacheResolver<WithTypename<Tenant>, Record<string, never>, Scalars['String']['output'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Tenant>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<Tenant>, Record<string, never>, Scalars['String']['output'] | string>,
    language?: GraphCacheResolver<WithTypename<Tenant>, Record<string, never>, Language | string>,
    managementType?: GraphCacheResolver<WithTypename<Tenant>, Record<string, never>, TenantManagementType | string>,
    members?: GraphCacheResolver<WithTypename<Tenant>, Record<string, never>, Array<WithTypename<TenantMember> | string>>,
    name?: GraphCacheResolver<WithTypename<Tenant>, Record<string, never>, Scalars['String']['output'] | string>,
    parent?: GraphCacheResolver<WithTypename<Tenant>, Record<string, never>, WithTypename<Tenant> | string>,
    permissions?: GraphCacheResolver<WithTypename<Tenant>, Record<string, never>, WithTypename<UserTenantPermission> | string>,
    type?: GraphCacheResolver<WithTypename<Tenant>, Record<string, never>, TenantType | string>
  },
  TenantInvite?: {
    code?: GraphCacheResolver<WithTypename<TenantInvite>, Record<string, never>, Scalars['String']['output'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<TenantInvite>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    expirationDate?: GraphCacheResolver<WithTypename<TenantInvite>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    expiredAt?: GraphCacheResolver<WithTypename<TenantInvite>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TenantInvite>, Record<string, never>, Scalars['String']['output'] | string>,
    tenant?: GraphCacheResolver<WithTypename<TenantInvite>, Record<string, never>, WithTypename<Tenant> | string>,
    tenantMembershipRole?: GraphCacheResolver<WithTypename<TenantInvite>, Record<string, never>, TenantMembershipRole | string>
  },
  TenantInvitePreview?: {
    expiredAt?: GraphCacheResolver<WithTypename<TenantInvitePreview>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TenantInvitePreview>, Record<string, never>, Scalars['String']['output'] | string>,
    tenantId?: GraphCacheResolver<WithTypename<TenantInvitePreview>, Record<string, never>, Scalars['String']['output'] | string>,
    tenantMember?: GraphCacheResolver<WithTypename<TenantInvitePreview>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    tenantName?: GraphCacheResolver<WithTypename<TenantInvitePreview>, Record<string, never>, Scalars['String']['output'] | string>
  },
  TenantMember?: {
    fullName?: GraphCacheResolver<WithTypename<TenantMember>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TenantMember>, Record<string, never>, Scalars['String']['output'] | string>,
    joinedAt?: GraphCacheResolver<WithTypename<TenantMember>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    tenantId?: GraphCacheResolver<WithTypename<TenantMember>, Record<string, never>, Scalars['String']['output'] | string>,
    tenantName?: GraphCacheResolver<WithTypename<TenantMember>, Record<string, never>, Scalars['String']['output'] | string>,
    tenantRole?: GraphCacheResolver<WithTypename<TenantMember>, Record<string, never>, TenantMembershipRole | string>,
    userId?: GraphCacheResolver<WithTypename<TenantMember>, Record<string, never>, Scalars['String']['output'] | string>
  },
  TextToSpeechLog?: {
    createdAt?: GraphCacheResolver<WithTypename<TextToSpeechLog>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TextToSpeechLog>, Record<string, never>, Scalars['String']['output'] | string>,
    lastListenedAt?: GraphCacheResolver<WithTypename<TextToSpeechLog>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    speechUrl?: GraphCacheResolver<WithTypename<TextToSpeechLog>, Record<string, never>, Scalars['String']['output'] | string>,
    textHash?: GraphCacheResolver<WithTypename<TextToSpeechLog>, Record<string, never>, Scalars['String']['output'] | string>,
    textLength?: GraphCacheResolver<WithTypename<TextToSpeechLog>, Record<string, never>, Scalars['Float']['output'] | string>,
    user?: GraphCacheResolver<WithTypename<TextToSpeechLog>, Record<string, never>, WithTypename<User> | string>
  },
  TextToSpeechLogResult?: {
    textToSpeechLog?: GraphCacheResolver<WithTypename<TextToSpeechLogResult>, Record<string, never>, WithTypename<TextToSpeechLog> | string>
  },
  Timetable?: {
    createdAt?: GraphCacheResolver<WithTypename<Timetable>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<Timetable>, Record<string, never>, Scalars['String']['output'] | string>,
    inputMode?: GraphCacheResolver<WithTypename<Timetable>, Record<string, never>, TimetableInputMode | string>,
    timetableEntries?: GraphCacheResolver<WithTypename<Timetable>, Record<string, never>, Array<WithTypename<TimetableEntry> | string>>,
    timetableGrid?: GraphCacheResolver<WithTypename<Timetable>, Record<string, never>, Array<WithTypename<TimetableGridEntry> | string>>,
    user?: GraphCacheResolver<WithTypename<Timetable>, Record<string, never>, WithTypename<User> | string>
  },
  TimetableDay?: {
    day?: GraphCacheResolver<WithTypename<TimetableDay>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TimetableDay>, Record<string, never>, Scalars['String']['output'] | string>,
    periods?: GraphCacheResolver<WithTypename<TimetableDay>, Record<string, never>, Array<WithTypename<TimetablePeriod> | string>>
  },
  TimetableDayError?: {
    code?: GraphCacheResolver<WithTypename<TimetableDayError>, Record<string, never>, Scalars['String']['output'] | string>,
    message?: GraphCacheResolver<WithTypename<TimetableDayError>, Record<string, never>, Scalars['String']['output'] | string>,
    source?: GraphCacheResolver<WithTypename<TimetableDayError>, Record<string, never>, Scalars['String']['output'] | string>
  },
  TimetableDayResult?: {
    timetableDays?: GraphCacheResolver<WithTypename<TimetableDayResult>, Record<string, never>, Array<WithTypename<TimetableDay> | string>>,
    timetableErrors?: GraphCacheResolver<WithTypename<TimetableDayResult>, Record<string, never>, Array<WithTypename<TimetableDayError> | string>>
  },
  TimetableEntry?: {
    course?: GraphCacheResolver<WithTypename<TimetableEntry>, Record<string, never>, WithTypename<Course> | string>,
    createdAt?: GraphCacheResolver<WithTypename<TimetableEntry>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    dayOfWeek?: GraphCacheResolver<WithTypename<TimetableEntry>, Record<string, never>, Scalars['String']['output'] | string>,
    fromTime?: GraphCacheResolver<WithTypename<TimetableEntry>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TimetableEntry>, Record<string, never>, Scalars['String']['output'] | string>,
    timetable?: GraphCacheResolver<WithTypename<TimetableEntry>, Record<string, never>, WithTypename<Timetable> | string>,
    toTime?: GraphCacheResolver<WithTypename<TimetableEntry>, Record<string, never>, Scalars['String']['output'] | string>,
    user?: GraphCacheResolver<WithTypename<TimetableEntry>, Record<string, never>, WithTypename<User> | string>
  },
  TimetableExtension?: {
    course?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, WithTypename<Course> | string>,
    createdAt?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    fromDay?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, Scalars['String']['output'] | string>,
    fromTime?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, Scalars['String']['output'] | string>,
    label?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, Scalars['String']['output'] | string>,
    timetable?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, WithTypename<Timetable> | string>,
    timetableEntry?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, WithTypename<TimetableEntry> | string>,
    toDay?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, Scalars['String']['output'] | string>,
    toTime?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, Scalars['String']['output'] | string>,
    type?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, PeriodType | string>,
    user?: GraphCacheResolver<WithTypename<TimetableExtension>, Record<string, never>, WithTypename<User> | string>
  },
  TimetableExtensionResult?: {
    timetableExtension?: GraphCacheResolver<WithTypename<TimetableExtensionResult>, Record<string, never>, WithTypename<TimetableExtension> | string>
  },
  TimetableGridEntry?: {
    fromTime?: GraphCacheResolver<WithTypename<TimetableGridEntry>, Record<string, never>, Scalars['String']['output'] | string>,
    toTime?: GraphCacheResolver<WithTypename<TimetableGridEntry>, Record<string, never>, Scalars['String']['output'] | string>
  },
  TimetablePeriod?: {
    endTime?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    extensionId?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, Scalars['String']['output'] | string>,
    externalId?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, Scalars['String']['output'] | string>,
    integrationId?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, Scalars['String']['output'] | string>,
    label?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, Scalars['String']['output'] | string>,
    periodCourse?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, WithTypename<PeriodCourse> | string>,
    source?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, Scalars['String']['output'] | string>,
    startTime?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    timeZone?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, Scalars['String']['output'] | string>,
    timetableEntryId?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, Scalars['String']['output'] | string>,
    type?: GraphCacheResolver<WithTypename<TimetablePeriod>, Record<string, never>, PeriodType | string>
  },
  ToDo?: {
    createdAt?: GraphCacheResolver<WithTypename<ToDo>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    deletedAt?: GraphCacheResolver<WithTypename<ToDo>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    doneAt?: GraphCacheResolver<WithTypename<ToDo>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    dueAt?: GraphCacheResolver<WithTypename<ToDo>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<ToDo>, Record<string, never>, Scalars['String']['output'] | string>,
    owner?: GraphCacheResolver<WithTypename<ToDo>, Record<string, never>, WithTypename<User> | string>,
    text?: GraphCacheResolver<WithTypename<ToDo>, Record<string, never>, Scalars['String']['output'] | string>
  },
  TodoResult?: {
    toDo?: GraphCacheResolver<WithTypename<TodoResult>, Record<string, never>, WithTypename<ToDo> | string>
  },
  TopicContent?: {
    id?: GraphCacheResolver<WithTypename<TopicContent>, Record<string, never>, WithTypename<Folder> | string>,
    itemContents?: GraphCacheResolver<WithTypename<TopicContent>, Record<string, never>, Array<WithTypename<ItemContent> | string>>,
    topic?: GraphCacheResolver<WithTypename<TopicContent>, Record<string, never>, WithTypename<Folder> | string>,
    topicInstances?: GraphCacheResolver<WithTypename<TopicContent>, Record<string, never>, Array<WithTypename<TopicInstance> | string>>
  },
  TopicInstance?: {
    completedAt?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    course?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, WithTypename<Course> | string>,
    createdAt?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    endDate?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    expanded?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    highlighted?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, Scalars['String']['output'] | string>,
    lockedAt?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    position?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, Scalars['Int']['output'] | string>,
    startDate?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    statistics?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, WithTypename<TopicInstanceStatistics> | string>,
    topic?: GraphCacheResolver<WithTypename<TopicInstance>, Record<string, never>, WithTypename<Folder> | string>
  },
  TopicInstanceResult?: {
    topicInstance?: GraphCacheResolver<WithTypename<TopicInstanceResult>, Record<string, never>, WithTypename<TopicInstance> | string>
  },
  TopicInstanceStatistics?: {
    doneItemInstances?: GraphCacheResolver<WithTypename<TopicInstanceStatistics>, Record<string, never>, Scalars['Float']['output'] | string>,
    plannedItemInstances?: GraphCacheResolver<WithTypename<TopicInstanceStatistics>, Record<string, never>, Scalars['Float']['output'] | string>,
    totalItemInstances?: GraphCacheResolver<WithTypename<TopicInstanceStatistics>, Record<string, never>, Scalars['Float']['output'] | string>,
    visibleItemInstances?: GraphCacheResolver<WithTypename<TopicInstanceStatistics>, Record<string, never>, Scalars['Float']['output'] | string>
  },
  TopicResult?: {
    topic?: GraphCacheResolver<WithTypename<TopicResult>, Record<string, never>, WithTypename<Folder> | string>
  },
  TopicStatistics?: {
    linkedItemsTotal?: GraphCacheResolver<WithTypename<TopicStatistics>, Record<string, never>, Scalars['Float']['output'] | string>
  },
  UnmappedCourse?: {
    displayName?: GraphCacheResolver<WithTypename<UnmappedCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    externalId?: GraphCacheResolver<WithTypename<UnmappedCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    externalUserCredentialsId?: GraphCacheResolver<WithTypename<UnmappedCourse>, Record<string, never>, Scalars['String']['output'] | string>,
    roleInCourse?: GraphCacheResolver<WithTypename<UnmappedCourse>, Record<string, never>, CourseMembershipRole | string>
  },
  User?: {
    countryKey?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    countryLabel?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    defaultTenant?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<Tenant> | string>,
    email?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    emailVerificationStatus?: GraphCacheResolver<WithTypename<User>, Record<string, never>, MailVerificationStatus | string>,
    emailVerifiedAt?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    firstName?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    forceNewEditor?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    fullName?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    language?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Language | string>,
    lastActiveAt?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    lastLoginAt?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['DateTime']['output'] | string>,
    lastName?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    schoolTypeKey?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    schoolTypeLabel?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    signedUp?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    stateKey?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    stateLabel?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>,
    username?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String']['output'] | string>
  },
  UserCalendarDay?: {
    courseCalendarDays?: GraphCacheResolver<WithTypename<UserCalendarDay>, Record<string, never>, Array<WithTypename<CourseCalendarDay> | string>>,
    day?: GraphCacheResolver<WithTypename<UserCalendarDay>, Record<string, never>, Scalars['String']['output'] | string>,
    id?: GraphCacheResolver<WithTypename<UserCalendarDay>, Record<string, never>, Scalars['String']['output'] | string>,
    userId?: GraphCacheResolver<WithTypename<UserCalendarDay>, Record<string, never>, Scalars['String']['output'] | string>
  },
  UserCoursePermission?: {
    canAddCalendarNote?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canAddCourseFolder?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canAddCourseTopicInstance?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canArchiveCourse?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canChangeCourseSharingSettings?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canCloseCourse?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canConnectToCourse?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditCalendarNote?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditCourseItemInstance?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditCourseMaterial?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditCoursePublicSettings?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditCourseSettings?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditCourseTopicInstance?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canRemoveCourseTopicInstance?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    courseRole?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, CourseMembershipRole | string>,
    hasNoAccess?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    isCourseOwner?: GraphCacheResolver<WithTypename<UserCoursePermission>, Record<string, never>, Scalars['Boolean']['output'] | string>
  },
  UserEmailNotificationSubscription?: {
    description?: GraphCacheResolver<WithTypename<UserEmailNotificationSubscription>, Record<string, never>, Scalars['String']['output'] | string>,
    hidden?: GraphCacheResolver<WithTypename<UserEmailNotificationSubscription>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    key?: GraphCacheResolver<WithTypename<UserEmailNotificationSubscription>, Record<string, never>, Scalars['String']['output'] | string>,
    notificationId?: GraphCacheResolver<WithTypename<UserEmailNotificationSubscription>, Record<string, never>, Scalars['String']['output'] | string>,
    subscribed?: GraphCacheResolver<WithTypename<UserEmailNotificationSubscription>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    unsubscribable?: GraphCacheResolver<WithTypename<UserEmailNotificationSubscription>, Record<string, never>, Scalars['Boolean']['output'] | string>
  },
  UserItemPermission?: {
    canDeleteCourseMaterialFromCourseFolder?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canDeleteItemFromTopic?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canDuplicateCourseMaterialIntoCourseFolder?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canDuplicateItemIntoTopic?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditCourseMaterial?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditItem?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditItemContentNote?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditItemSnippetNote?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canViewCourseMaterial?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canViewItem?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canViewItemContentNote?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canViewItemSnippetNote?: GraphCacheResolver<WithTypename<UserItemPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>
  },
  UserResult?: {
    user?: GraphCacheResolver<WithTypename<UserResult>, Record<string, never>, WithTypename<User> | string>
  },
  UserTenantPermission?: {
    canCreateCourse?: GraphCacheResolver<WithTypename<UserTenantPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canManageLicense?: GraphCacheResolver<WithTypename<UserTenantPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    hasNoAccess?: GraphCacheResolver<WithTypename<UserTenantPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    isAdmin?: GraphCacheResolver<WithTypename<UserTenantPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    isTenantTeacher?: GraphCacheResolver<WithTypename<UserTenantPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>
  },
  UserTopicPermission?: {
    canChangeTopicSharingSettings?: GraphCacheResolver<WithTypename<UserTopicPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canDeleteTopicFromOwnLibrary?: GraphCacheResolver<WithTypename<UserTopicPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canDuplicateTopic?: GraphCacheResolver<WithTypename<UserTopicPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditCourseFolder?: GraphCacheResolver<WithTypename<UserTopicPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canEditTopic?: GraphCacheResolver<WithTypename<UserTopicPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canModifyCourseMaterials?: GraphCacheResolver<WithTypename<UserTopicPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canModifyMaterials?: GraphCacheResolver<WithTypename<UserTopicPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canMoveTopic?: GraphCacheResolver<WithTypename<UserTopicPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    canViewTopic?: GraphCacheResolver<WithTypename<UserTopicPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>,
    isTopicOwner?: GraphCacheResolver<WithTypename<UserTopicPermission>, Record<string, never>, Scalars['Boolean']['output'] | string>
  }
};

export type GraphCacheOptimisticUpdaters = {
  acceptCourseCollaborationInvite?: GraphCacheOptimisticMutationResolver<MutationAcceptCourseCollaborationInviteArgs, WithTypename<DoneResult>>,
  acceptTenantInvite?: GraphCacheOptimisticMutationResolver<MutationAcceptTenantInviteArgs, WithTypename<DoneResult>>,
  addCalendarEvent?: GraphCacheOptimisticMutationResolver<MutationAddCalendarEventArgs, WithTypename<CalendarEventResult>>,
  addCalendarEvents?: GraphCacheOptimisticMutationResolver<MutationAddCalendarEventsArgs, WithTypename<CalendarEventListResult>>,
  addCalendarNote?: GraphCacheOptimisticMutationResolver<MutationAddCalendarNoteArgs, WithTypename<CalendarNoteResult>>,
  addCollaborator?: GraphCacheOptimisticMutationResolver<MutationAddCollaboratorArgs, WithTypename<CourseCollaboratorResult>>,
  addItemToCalendar?: GraphCacheOptimisticMutationResolver<MutationAddItemToCalendarArgs, WithTypename<CalendarEventResult>>,
  addTimetableExtension?: GraphCacheOptimisticMutationResolver<MutationAddTimetableExtensionArgs, WithTypename<TimetableExtensionResult>>,
  addTopicsToCourses?: GraphCacheOptimisticMutationResolver<MutationAddTopicsToCoursesArgs, WithTypename<DoneResult>>,
  aiToolTextToSpeech?: GraphCacheOptimisticMutationResolver<MutationAiToolTextToSpeechArgs, WithTypename<TextToSpeechLogResult>>,
  changePassword?: GraphCacheOptimisticMutationResolver<MutationChangePasswordArgs, WithTypename<DoneResult>>,
  checkCoursePermission?: GraphCacheOptimisticMutationResolver<MutationCheckCoursePermissionArgs, WithTypename<UserCoursePermission>>,
  checkExistingExternalCourses?: GraphCacheOptimisticMutationResolver<MutationCheckExistingExternalCoursesArgs, WithTypename<ExistingCourseMappingResult>>,
  checkTenantPermission?: GraphCacheOptimisticMutationResolver<MutationCheckTenantPermissionArgs, WithTypename<UserTenantPermission>>,
  closeCourse?: GraphCacheOptimisticMutationResolver<MutationCloseCourseArgs, WithTypename<CourseResult>>,
  connectExternalCourse?: GraphCacheOptimisticMutationResolver<MutationConnectExternalCourseArgs, WithTypename<DoneResult>>,
  connectExternalIntegration?: GraphCacheOptimisticMutationResolver<MutationConnectExternalIntegrationArgs, WithTypename<DoneResult>>,
  connectTemplateToCourse?: GraphCacheOptimisticMutationResolver<MutationConnectTemplateToCourseArgs, WithTypename<DoneResult>>,
  copyFolderToCourse?: GraphCacheOptimisticMutationResolver<MutationCopyFolderToCourseArgs, WithTypename<DoneResult>>,
  copyMaterialToFolder?: GraphCacheOptimisticMutationResolver<MutationCopyMaterialToFolderArgs, WithTypename<DoneResult>>,
  createAiSettingsForCourse?: GraphCacheOptimisticMutationResolver<MutationCreateAiSettingsForCourseArgs, WithTypename<AiSettingsResult>>,
  createCourse?: GraphCacheOptimisticMutationResolver<MutationCreateCourseArgs, WithTypename<CourseResult>>,
  createCourseCollaborationInvite?: GraphCacheOptimisticMutationResolver<MutationCreateCourseCollaborationInviteArgs, WithTypename<CourseInviteResult>>,
  createCourseFolder?: GraphCacheOptimisticMutationResolver<MutationCreateCourseFolderArgs, WithTypename<CourseFolderResult>>,
  createCourseMaterial?: GraphCacheOptimisticMutationResolver<MutationCreateCourseMaterialArgs, WithTypename<CourseMaterialResult>>,
  createCoursePublicAccess?: GraphCacheOptimisticMutationResolver<MutationCreateCoursePublicAccessArgs, WithTypename<CoursePublicAccessResult>>,
  createLibraryFolder?: GraphCacheOptimisticMutationResolver<MutationCreateLibraryFolderArgs, WithTypename<LibraryFolderResult>>,
  createMaterial?: GraphCacheOptimisticMutationResolver<MutationCreateMaterialArgs, WithTypename<MaterialResult>>,
  createStudentAiAssignment?: GraphCacheOptimisticMutationResolver<MutationCreateStudentAiAssignmentArgs, WithTypename<StudentAiAssignmentResult>>,
  createToDo?: GraphCacheOptimisticMutationResolver<MutationCreateToDoArgs, WithTypename<TodoResult>>,
  createTopic?: GraphCacheOptimisticMutationResolver<MutationCreateTopicArgs, WithTypename<TopicResult>>,
  createTopicInstance?: GraphCacheOptimisticMutationResolver<MutationCreateTopicInstanceArgs, WithTypename<TopicInstanceResult>>,
  deleteInteractiveAssignmentSession?: GraphCacheOptimisticMutationResolver<MutationDeleteInteractiveAssignmentSessionArgs, WithTypename<DoneResult>>,
  deleteToDo?: GraphCacheOptimisticMutationResolver<MutationDeleteToDoArgs, WithTypename<DoneResult>>,
  disconnectExternalCourse?: GraphCacheOptimisticMutationResolver<MutationDisconnectExternalCourseArgs, WithTypename<DoneResult>>,
  disconnectExternalIntegration?: GraphCacheOptimisticMutationResolver<MutationDisconnectExternalIntegrationArgs, WithTypename<DoneResult>>,
  duplicateItems?: GraphCacheOptimisticMutationResolver<MutationDuplicateItemsArgs, Array<WithTypename<Material>>>,
  duplicateMaterials?: GraphCacheOptimisticMutationResolver<MutationDuplicateMaterialsArgs, Array<WithTypename<Material>>>,
  duplicateTopics?: GraphCacheOptimisticMutationResolver<MutationDuplicateTopicsArgs, Array<WithTypename<Folder>>>,
  duplicateTopicsToFolder?: GraphCacheOptimisticMutationResolver<MutationDuplicateTopicsToFolderArgs, WithTypename<DoneResult>>,
  emailSignup?: GraphCacheOptimisticMutationResolver<MutationEmailSignupArgs, WithTypename<AuthResult>>,
  exportLibraryContent?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<DoneResult>>,
  generateLinkPreview?: GraphCacheOptimisticMutationResolver<MutationGenerateLinkPreviewArgs, WithTypename<LinkPreviewExtra>>,
  generatePromptSuggestions?: GraphCacheOptimisticMutationResolver<MutationGeneratePromptSuggestionsArgs, Array<WithTypename<IpiPromptSuggestion>>>,
  ignoreExternalCourse?: GraphCacheOptimisticMutationResolver<MutationIgnoreExternalCourseArgs, WithTypename<DoneResult>>,
  initialMaterialIpiPrompt?: GraphCacheOptimisticMutationResolver<MutationInitialMaterialIpiPromptArgs, WithTypename<InitialIpiPromptResult>>,
  integrationCheck?: GraphCacheOptimisticMutationResolver<MutationIntegrationCheckArgs, WithTypename<IntegrationCheckResult>>,
  invalidateCourseCollaborationInvite?: GraphCacheOptimisticMutationResolver<MutationInvalidateCourseCollaborationInviteArgs, WithTypename<DoneResult>>,
  invalidateCoursePublicAccess?: GraphCacheOptimisticMutationResolver<MutationInvalidateCoursePublicAccessArgs, WithTypename<DoneResult>>,
  joinExistingExternalCourse?: GraphCacheOptimisticMutationResolver<MutationJoinExistingExternalCourseArgs, WithTypename<DoneResult>>,
  login?: GraphCacheOptimisticMutationResolver<MutationLoginArgs, WithTypename<AuthResult>>,
  migrateMaterial?: GraphCacheOptimisticMutationResolver<MutationMigrateMaterialArgs, WithTypename<DoneResult>>,
  moveCalendarEvent?: GraphCacheOptimisticMutationResolver<MutationMoveCalendarEventArgs, WithTypename<CalendarEventResult>>,
  moveItems?: GraphCacheOptimisticMutationResolver<MutationMoveItemsArgs, WithTypename<DoneResult>>,
  moveLibraryFolder?: GraphCacheOptimisticMutationResolver<MutationMoveLibraryFolderArgs, WithTypename<LibraryFolderResult>>,
  moveMaterial?: GraphCacheOptimisticMutationResolver<MutationMoveMaterialArgs, WithTypename<DoneResult>>,
  moveMaterials?: GraphCacheOptimisticMutationResolver<MutationMoveMaterialsArgs, WithTypename<DoneResult>>,
  moveTopic?: GraphCacheOptimisticMutationResolver<MutationMoveTopicArgs, WithTypename<TopicResult>>,
  moveTopics?: GraphCacheOptimisticMutationResolver<MutationMoveTopicsArgs, WithTypename<DoneResult>>,
  pushEntireUserTimetable?: GraphCacheOptimisticMutationResolver<MutationPushEntireUserTimetableArgs, WithTypename<DoneResult>>,
  pushLessonToExternalSource?: GraphCacheOptimisticMutationResolver<MutationPushLessonToExternalSourceArgs, WithTypename<DoneResult>>,
  pushOnboardingProgress?: GraphCacheOptimisticMutationResolver<MutationPushOnboardingProgressArgs, WithTypename<DoneResult>>,
  rateIpiRequest?: GraphCacheOptimisticMutationResolver<MutationRateIpiRequestArgs, WithTypename<DoneResult>>,
  refreshToken?: GraphCacheOptimisticMutationResolver<MutationRefreshTokenArgs, WithTypename<AuthResult>>,
  removeCalendarEvent?: GraphCacheOptimisticMutationResolver<MutationRemoveCalendarEventArgs, WithTypename<DoneResult>>,
  removeCollaborator?: GraphCacheOptimisticMutationResolver<MutationRemoveCollaboratorArgs, WithTypename<DoneResult>>,
  removeCourseFolder?: GraphCacheOptimisticMutationResolver<MutationRemoveCourseFolderArgs, WithTypename<DoneResult>>,
  removeFolder?: GraphCacheOptimisticMutationResolver<MutationRemoveFolderArgs, WithTypename<DoneResult>>,
  removeItem?: GraphCacheOptimisticMutationResolver<MutationRemoveItemArgs, WithTypename<DoneResult>>,
  removeItems?: GraphCacheOptimisticMutationResolver<MutationRemoveItemsArgs, WithTypename<DoneResult>>,
  removeLibraryFolder?: GraphCacheOptimisticMutationResolver<MutationRemoveLibraryFolderArgs, WithTypename<DoneResult>>,
  removeMaterial?: GraphCacheOptimisticMutationResolver<MutationRemoveMaterialArgs, WithTypename<DoneResult>>,
  removeMaterials?: GraphCacheOptimisticMutationResolver<MutationRemoveMaterialsArgs, WithTypename<DoneResult>>,
  removeStudentAiAssignment?: GraphCacheOptimisticMutationResolver<MutationRemoveStudentAiAssignmentArgs, WithTypename<DoneResult>>,
  removeTimetableExtension?: GraphCacheOptimisticMutationResolver<MutationRemoveTimetableExtensionArgs, WithTypename<DoneResult>>,
  removeTopic?: GraphCacheOptimisticMutationResolver<MutationRemoveTopicArgs, WithTypename<DoneResult>>,
  removeTopicInstance?: GraphCacheOptimisticMutationResolver<MutationRemoveTopicInstanceArgs, WithTypename<DoneResult>>,
  removeTopicInstances?: GraphCacheOptimisticMutationResolver<MutationRemoveTopicInstancesArgs, WithTypename<DoneResult>>,
  removeTopics?: GraphCacheOptimisticMutationResolver<MutationRemoveTopicsArgs, WithTypename<DoneResult>>,
  reorderCourse?: GraphCacheOptimisticMutationResolver<MutationReorderCourseArgs, WithTypename<DoneResult>>,
  reorderCourseFolder?: GraphCacheOptimisticMutationResolver<MutationReorderCourseFolderArgs, WithTypename<CourseFolderResult>>,
  reorderItem?: GraphCacheOptimisticMutationResolver<MutationReorderItemArgs, WithTypename<ItemResult>>,
  reorderMaterial?: GraphCacheOptimisticMutationResolver<MutationReorderMaterialArgs, WithTypename<MaterialResult>>,
  reorderTopic?: GraphCacheOptimisticMutationResolver<MutationReorderTopicArgs, WithTypename<TopicResult>>,
  reorderTopicInstance?: GraphCacheOptimisticMutationResolver<MutationReorderTopicInstanceArgs, WithTypename<TopicInstanceResult>>,
  requestCheckoutSessionData?: GraphCacheOptimisticMutationResolver<MutationRequestCheckoutSessionDataArgs, WithTypename<PaymentGatewayManagementData>>,
  requestPaymentGatewayPortalData?: GraphCacheOptimisticMutationResolver<MutationRequestPaymentGatewayPortalDataArgs, WithTypename<PaymentGatewayManagementData>>,
  requestUserPasswordReset?: GraphCacheOptimisticMutationResolver<MutationRequestUserPasswordResetArgs, WithTypename<DoneResult>>,
  requestVerificationEmail?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<DoneResult>>,
  setCourseFirstFeatureToggle?: GraphCacheOptimisticMutationResolver<MutationSetCourseFirstFeatureToggleArgs, WithTypename<DoneResult>>,
  ssoSignup?: GraphCacheOptimisticMutationResolver<MutationSsoSignupArgs, WithTypename<AuthResult>>,
  syncCourseWithTemplate?: GraphCacheOptimisticMutationResolver<MutationSyncCourseWithTemplateArgs, WithTypename<DoneResult>>,
  syncItemWithTemplate?: GraphCacheOptimisticMutationResolver<MutationSyncItemWithTemplateArgs, WithTypename<DoneResult>>,
  syncTopicWithTemplate?: GraphCacheOptimisticMutationResolver<MutationSyncTopicWithTemplateArgs, WithTypename<DoneResult>>,
  toggleCourseMaterialVisibility?: GraphCacheOptimisticMutationResolver<MutationToggleCourseMaterialVisibilityArgs, WithTypename<DoneResult>>,
  toggleItemInstanceVisibility?: GraphCacheOptimisticMutationResolver<MutationToggleItemInstanceVisibilityArgs, WithTypename<ItemInstanceResult>>,
  toggleStudentAiAssignment?: GraphCacheOptimisticMutationResolver<MutationToggleStudentAiAssignmentArgs, WithTypename<StudentAiAssignmentResult>>,
  unIgnoreExternalCourse?: GraphCacheOptimisticMutationResolver<MutationUnIgnoreExternalCourseArgs, WithTypename<DoneResult>>,
  updateAiSettingsForCourse?: GraphCacheOptimisticMutationResolver<MutationUpdateAiSettingsForCourseArgs, WithTypename<AiSettingsResult>>,
  updateCalendarNote?: GraphCacheOptimisticMutationResolver<MutationUpdateCalendarNoteArgs, WithTypename<CalendarNoteResult>>,
  updateCollaborator?: GraphCacheOptimisticMutationResolver<MutationUpdateCollaboratorArgs, WithTypename<DoneResult>>,
  updateCourse?: GraphCacheOptimisticMutationResolver<MutationUpdateCourseArgs, WithTypename<CourseResult>>,
  updateFolder?: GraphCacheOptimisticMutationResolver<MutationUpdateFolderArgs, WithTypename<FolderResult>>,
  updateItem?: GraphCacheOptimisticMutationResolver<MutationUpdateItemArgs, WithTypename<ItemResult>>,
  updateLibraryFolder?: GraphCacheOptimisticMutationResolver<MutationUpdateLibraryFolderArgs, WithTypename<LibraryFolderResult>>,
  updateMaterial?: GraphCacheOptimisticMutationResolver<MutationUpdateMaterialArgs, WithTypename<MaterialResult>>,
  updateStudentAiAssignment?: GraphCacheOptimisticMutationResolver<MutationUpdateStudentAiAssignmentArgs, WithTypename<StudentAiAssignmentResult>>,
  updateTimetableExtension?: GraphCacheOptimisticMutationResolver<MutationUpdateTimetableExtensionArgs, WithTypename<TimetableExtensionResult>>,
  updateToDo?: GraphCacheOptimisticMutationResolver<MutationUpdateToDoArgs, WithTypename<TodoResult>>,
  updateTopic?: GraphCacheOptimisticMutationResolver<MutationUpdateTopicArgs, WithTypename<TopicResult>>,
  updateTopicInstance?: GraphCacheOptimisticMutationResolver<MutationUpdateTopicInstanceArgs, WithTypename<TopicInstanceResult>>,
  updateUser?: GraphCacheOptimisticMutationResolver<MutationUpdateUserArgs, WithTypename<UserResult>>,
  updateUserEmail?: GraphCacheOptimisticMutationResolver<MutationUpdateUserEmailArgs, WithTypename<UserResult>>,
  updateUserEmailNotificationSubscription?: GraphCacheOptimisticMutationResolver<MutationUpdateUserEmailNotificationSubscriptionArgs, WithTypename<DoneResult>>,
  updateUserPreferences?: GraphCacheOptimisticMutationResolver<MutationUpdateUserPreferencesArgs, WithTypename<DoneResult>>,
  verifyUserEmail?: GraphCacheOptimisticMutationResolver<MutationVerifyUserEmailArgs, WithTypename<UserResult>>,
  verifyUserPasswordReset?: GraphCacheOptimisticMutationResolver<MutationVerifyUserPasswordResetArgs, WithTypename<AuthResult>>
};

export type GraphCacheUpdaters = {
  Query?: {
    aiArea?: GraphCacheUpdateResolver<{ aiArea: WithTypename<TeachinoAiArea> }, QueryAiAreaArgs>,
    aiSettings?: GraphCacheUpdateResolver<{ aiSettings: Maybe<WithTypename<AiSettings>> }, QueryAiSettingsArgs>,
    aiTask?: GraphCacheUpdateResolver<{ aiTask: WithTypename<TeachinoAiTask> }, QueryAiTaskArgs>,
    assignmentChatbotHistory?: GraphCacheUpdateResolver<{ assignmentChatbotHistory: Maybe<WithTypename<AssignmentChatbotHistory>> }, QueryAssignmentChatbotHistoryArgs>,
    assignmentChatbotsForMaterial?: GraphCacheUpdateResolver<{ assignmentChatbotsForMaterial: Array<WithTypename<AssignmentChatbot>> }, QueryAssignmentChatbotsForMaterialArgs>,
    assignmentOpenQuestionHistory?: GraphCacheUpdateResolver<{ assignmentOpenQuestionHistory: Maybe<WithTypename<AssignmentOpenQuestionHistory>> }, QueryAssignmentOpenQuestionHistoryArgs>,
    assignmentOpenQuestionsForMaterial?: GraphCacheUpdateResolver<{ assignmentOpenQuestionsForMaterial: Array<WithTypename<AssignmentOpenQuestion>> }, QueryAssignmentOpenQuestionsForMaterialArgs>,
    availableCoursesToAddTopic?: GraphCacheUpdateResolver<{ availableCoursesToAddTopic: Array<WithTypename<Course>> }, QueryAvailableCoursesToAddTopicArgs>,
    calendarDays?: GraphCacheUpdateResolver<{ calendarDays: Array<WithTypename<CourseCalendarDay>> }, QueryCalendarDaysArgs>,
    config?: GraphCacheUpdateResolver<{ config: WithTypename<Configuration> }, Record<string, never>>,
    countriesWithStates?: GraphCacheUpdateResolver<{ countriesWithStates: Array<WithTypename<CountryStateCombo>> }, Record<string, never>>,
    course?: GraphCacheUpdateResolver<{ course: WithTypename<Course> }, QueryCourseArgs>,
    courseCalendarDays?: GraphCacheUpdateResolver<{ courseCalendarDays: Array<WithTypename<CourseCalendarDay>> }, QueryCourseCalendarDaysArgs>,
    courseCollaborators?: GraphCacheUpdateResolver<{ courseCollaborators: Array<WithTypename<CourseCollaborator>> }, QueryCourseCollaboratorsArgs>,
    courseFolders?: GraphCacheUpdateResolver<{ courseFolders: Array<WithTypename<CourseFolder>> }, QueryCourseFoldersArgs>,
    courseInvitePreview?: GraphCacheUpdateResolver<{ courseInvitePreview: WithTypename<CourseInvitePreview> }, QueryCourseInvitePreviewArgs>,
    courseInvites?: GraphCacheUpdateResolver<{ courseInvites: Maybe<Array<WithTypename<CourseInvite>>> }, QueryCourseInvitesArgs>,
    coursePublicAccess?: GraphCacheUpdateResolver<{ coursePublicAccess: Maybe<WithTypename<CoursePublicAccess>> }, QueryCoursePublicAccessArgs>,
    coursesForItem?: GraphCacheUpdateResolver<{ coursesForItem: Array<WithTypename<Course>> }, QueryCoursesForItemArgs>,
    coursesForItemInstance?: GraphCacheUpdateResolver<{ coursesForItemInstance: Array<WithTypename<Course>> }, QueryCoursesForItemInstanceArgs>,
    coursesForMaterial?: GraphCacheUpdateResolver<{ coursesForMaterial: Array<WithTypename<MaterialCourse>> }, QueryCoursesForMaterialArgs>,
    coursesForTopic?: GraphCacheUpdateResolver<{ coursesForTopic: Array<WithTypename<Course>> }, QueryCoursesForTopicArgs>,
    currentLicense?: GraphCacheUpdateResolver<{ currentLicense: WithTypename<License> }, Record<string, never>>,
    curriculumContent?: GraphCacheUpdateResolver<{ curriculumContent: Array<WithTypename<CurriculumContent>> }, QueryCurriculumContentArgs>,
    curriculums?: GraphCacheUpdateResolver<{ curriculums: Array<WithTypename<Curriculum>> }, Record<string, never>>,
    dueToDos?: GraphCacheUpdateResolver<{ dueToDos: Array<WithTypename<ToDo>> }, QueryDueToDosArgs>,
    editableTopicInstancesForTopic?: GraphCacheUpdateResolver<{ editableTopicInstancesForTopic: Array<WithTypename<TopicInstance>> }, QueryEditableTopicInstancesForTopicArgs>,
    exportTree?: GraphCacheUpdateResolver<{ exportTree: Array<WithTypename<LibraryFolder>> }, Record<string, never>>,
    externalContent?: GraphCacheUpdateResolver<{ externalContent: WithTypename<ExternalContentResult> }, QueryExternalContentArgs>,
    externalCourses?: GraphCacheUpdateResolver<{ externalCourses: WithTypename<ExternalCoursesResult> }, Record<string, never>>,
    externalIntegrations?: GraphCacheUpdateResolver<{ externalIntegrations: Array<WithTypename<ExternalUserCredentials>> }, Record<string, never>>,
    globalSubjects?: GraphCacheUpdateResolver<{ globalSubjects: Array<WithTypename<Subject>> }, Record<string, never>>,
    interactiveAssignmentsOverview?: GraphCacheUpdateResolver<{ interactiveAssignmentsOverview: Array<WithTypename<MaterialInteractiveAssignmentsStudentOverview>> }, QueryInteractiveAssignmentsOverviewArgs>,
    interactiveAssignmentsStatusByTopic?: GraphCacheUpdateResolver<{ interactiveAssignmentsStatusByTopic: Array<WithTypename<MaterialInteractiveAssignmentStatus>> }, QueryInteractiveAssignmentsStatusByTopicArgs>,
    item?: GraphCacheUpdateResolver<{ item: WithTypename<Material> }, QueryItemArgs>,
    itemInstances?: GraphCacheUpdateResolver<{ itemInstances: Array<WithTypename<ItemInstance>> }, QueryItemInstancesArgs>,
    items?: GraphCacheUpdateResolver<{ items: Array<WithTypename<Material>> }, QueryItemsArgs>,
    libraryFolder?: GraphCacheUpdateResolver<{ libraryFolder: WithTypename<LibraryFolder> }, QueryLibraryFolderArgs>,
    libraryFolders?: GraphCacheUpdateResolver<{ libraryFolders: Array<WithTypename<LibraryFolder>> }, Record<string, never>>,
    libraryMeta?: GraphCacheUpdateResolver<{ libraryMeta: WithTypename<LibraryMetaResult> }, Record<string, never>>,
    libraryNewestContent?: GraphCacheUpdateResolver<{ libraryNewestContent: WithTypename<LibraryNewestContentResult> }, QueryLibraryNewestContentArgs>,
    licenses?: GraphCacheUpdateResolver<{ licenses: Array<WithTypename<License>> }, Record<string, never>>,
    material?: GraphCacheUpdateResolver<{ material: WithTypename<Material> }, QueryMaterialArgs>,
    materialAnnotationToolAccess?: GraphCacheUpdateResolver<{ materialAnnotationToolAccess: Maybe<WithTypename<MaterialAnnotationToolAccess>> }, QueryMaterialAnnotationToolAccessArgs>,
    materials?: GraphCacheUpdateResolver<{ materials: Array<WithTypename<Material>> }, QueryMaterialsArgs>,
    me?: GraphCacheUpdateResolver<{ me: WithTypename<User> }, Record<string, never>>,
    myCourses?: GraphCacheUpdateResolver<{ myCourses: Array<WithTypename<Course>> }, QueryMyCoursesArgs>,
    myIpiPromptHistory?: GraphCacheUpdateResolver<{ myIpiPromptHistory: WithTypename<IpiPromptHistoryResult> }, Record<string, never>>,
    myTenants?: GraphCacheUpdateResolver<{ myTenants: Array<WithTypename<Tenant>> }, Record<string, never>>,
    previewExternalContent?: GraphCacheUpdateResolver<{ previewExternalContent: Maybe<WithTypename<ExternalContentPreview>> }, QueryPreviewExternalContentArgs>,
    publicCourse?: GraphCacheUpdateResolver<{ publicCourse: Maybe<WithTypename<Course>> }, QueryPublicCourseArgs>,
    publicCourseCalendarDays?: GraphCacheUpdateResolver<{ publicCourseCalendarDays: Array<WithTypename<CourseCalendarDay>> }, QueryPublicCourseCalendarDaysArgs>,
    publicCourseFeatures?: GraphCacheUpdateResolver<{ publicCourseFeatures: Array<WithTypename<Feature>> }, QueryPublicCourseFeaturesArgs>,
    publicCourseFolders?: GraphCacheUpdateResolver<{ publicCourseFolders: Array<WithTypename<CourseFolder>> }, QueryPublicCourseFoldersArgs>,
    publicItem?: GraphCacheUpdateResolver<{ publicItem: WithTypename<Material> }, QueryPublicItemArgs>,
    publicItemInstance?: GraphCacheUpdateResolver<{ publicItemInstance: WithTypename<ItemInstance> }, QueryPublicItemInstanceArgs>,
    publicItemInstances?: GraphCacheUpdateResolver<{ publicItemInstances: Array<WithTypename<ItemInstance>> }, QueryPublicItemInstancesArgs>,
    publicMaterial?: GraphCacheUpdateResolver<{ publicMaterial: WithTypename<Material> }, QueryPublicMaterialArgs>,
    publicMaterialAnnotationToolAccess?: GraphCacheUpdateResolver<{ publicMaterialAnnotationToolAccess: Maybe<WithTypename<MaterialAnnotationToolAccess>> }, QueryPublicMaterialAnnotationToolAccessArgs>,
    publicStudentAiAssignment?: GraphCacheUpdateResolver<{ publicStudentAiAssignment: WithTypename<StudentAiAssignment> }, QueryPublicStudentAiAssignmentArgs>,
    publicTopic?: GraphCacheUpdateResolver<{ publicTopic: WithTypename<Folder> }, QueryPublicTopicArgs>,
    publicTopicInstances?: GraphCacheUpdateResolver<{ publicTopicInstances: Array<WithTypename<TopicInstance>> }, QueryPublicTopicInstancesArgs>,
    recentExternalContent?: GraphCacheUpdateResolver<{ recentExternalContent: WithTypename<ExternalContentResult> }, QueryRecentExternalContentArgs>,
    schoolTypes?: GraphCacheUpdateResolver<{ schoolTypes: Array<WithTypename<SchoolType>> }, QuerySchoolTypesArgs>,
    searchContent?: GraphCacheUpdateResolver<{ searchContent: Array<WithTypename<Content>> }, QuerySearchContentArgs>,
    searchExternalContent?: GraphCacheUpdateResolver<{ searchExternalContent: WithTypename<ExternalContentResult> }, QuerySearchExternalContentArgs>,
    studentAiAssignment?: GraphCacheUpdateResolver<{ studentAiAssignment: WithTypename<StudentAiAssignment> }, QueryStudentAiAssignmentArgs>,
    studentAiAssignments?: GraphCacheUpdateResolver<{ studentAiAssignments: Array<WithTypename<StudentAiAssignment>> }, Record<string, never>>,
    studentAiTemplate?: GraphCacheUpdateResolver<{ studentAiTemplate: WithTypename<StudentAiTemplate> }, QueryStudentAiTemplateArgs>,
    studentAiTemplates?: GraphCacheUpdateResolver<{ studentAiTemplates: Array<WithTypename<StudentAiTemplate>> }, Record<string, never>>,
    studentAssignmentOpenQuestionHistory?: GraphCacheUpdateResolver<{ studentAssignmentOpenQuestionHistory: Maybe<WithTypename<StudentAssignmentOpenQuestionHistory>> }, QueryStudentAssignmentOpenQuestionHistoryArgs>,
    supportToken?: GraphCacheUpdateResolver<{ supportToken: WithTypename<SupportTokenResult> }, Record<string, never>>,
    tenantEditableSchoolYears?: GraphCacheUpdateResolver<{ tenantEditableSchoolYears: Array<WithTypename<SchoolYear>> }, QueryTenantEditableSchoolYearsArgs>,
    tenantInvitePreview?: GraphCacheUpdateResolver<{ tenantInvitePreview: WithTypename<TenantInvitePreview> }, QueryTenantInvitePreviewArgs>,
    tenantMembers?: GraphCacheUpdateResolver<{ tenantMembers: Array<WithTypename<TenantMember>> }, QueryTenantMembersArgs>,
    timetableExtension?: GraphCacheUpdateResolver<{ timetableExtension: WithTypename<TimetableExtension> }, QueryTimetableExtensionArgs>,
    timetableExtensions?: GraphCacheUpdateResolver<{ timetableExtensions: Array<WithTypename<TimetableExtension>> }, QueryTimetableExtensionsArgs>,
    timetableForCourse?: GraphCacheUpdateResolver<{ timetableForCourse: Array<WithTypename<TimetableDay>> }, QueryTimetableForCourseArgs>,
    timetableForUser?: GraphCacheUpdateResolver<{ timetableForUser: WithTypename<TimetableDayResult> }, QueryTimetableForUserArgs>,
    timetablePeriodAlternativesForCourse?: GraphCacheUpdateResolver<{ timetablePeriodAlternativesForCourse: Array<WithTypename<TimetablePeriod>> }, QueryTimetablePeriodAlternativesForCourseArgs>,
    timetableStructure?: GraphCacheUpdateResolver<{ timetableStructure: WithTypename<Timetable> }, Record<string, never>>,
    toDos?: GraphCacheUpdateResolver<{ toDos: Array<WithTypename<ToDo>> }, Record<string, never>>,
    topic?: GraphCacheUpdateResolver<{ topic: WithTypename<Folder> }, QueryTopicArgs>,
    topicContent?: GraphCacheUpdateResolver<{ topicContent: WithTypename<TopicContent> }, QueryTopicContentArgs>,
    topicInstance?: GraphCacheUpdateResolver<{ topicInstance: WithTypename<TopicInstance> }, QueryTopicInstanceArgs>,
    topicInstanceForTopicInCourse?: GraphCacheUpdateResolver<{ topicInstanceForTopicInCourse: WithTypename<TopicInstance> }, QueryTopicInstanceForTopicInCourseArgs>,
    topicInstances?: GraphCacheUpdateResolver<{ topicInstances: Array<WithTypename<TopicInstance>> }, QueryTopicInstancesArgs>,
    topics?: GraphCacheUpdateResolver<{ topics: Array<WithTypename<Folder>> }, QueryTopicsArgs>,
    userCalendarDays?: GraphCacheUpdateResolver<{ userCalendarDays: Array<WithTypename<UserCalendarDay>> }, QueryUserCalendarDaysArgs>,
    userEmailNotificationSubscriptions?: GraphCacheUpdateResolver<{ userEmailNotificationSubscriptions: Array<WithTypename<UserEmailNotificationSubscription>> }, Record<string, never>>,
    userPlans?: GraphCacheUpdateResolver<{ userPlans: Array<WithTypename<Plan>> }, Record<string, never>>
  },
  Mutation?: {
    acceptCourseCollaborationInvite?: GraphCacheUpdateResolver<{ acceptCourseCollaborationInvite: WithTypename<DoneResult> }, MutationAcceptCourseCollaborationInviteArgs>,
    acceptTenantInvite?: GraphCacheUpdateResolver<{ acceptTenantInvite: WithTypename<DoneResult> }, MutationAcceptTenantInviteArgs>,
    addCalendarEvent?: GraphCacheUpdateResolver<{ addCalendarEvent: WithTypename<CalendarEventResult> }, MutationAddCalendarEventArgs>,
    addCalendarEvents?: GraphCacheUpdateResolver<{ addCalendarEvents: WithTypename<CalendarEventListResult> }, MutationAddCalendarEventsArgs>,
    addCalendarNote?: GraphCacheUpdateResolver<{ addCalendarNote: WithTypename<CalendarNoteResult> }, MutationAddCalendarNoteArgs>,
    addCollaborator?: GraphCacheUpdateResolver<{ addCollaborator: WithTypename<CourseCollaboratorResult> }, MutationAddCollaboratorArgs>,
    addItemToCalendar?: GraphCacheUpdateResolver<{ addItemToCalendar: WithTypename<CalendarEventResult> }, MutationAddItemToCalendarArgs>,
    addTimetableExtension?: GraphCacheUpdateResolver<{ addTimetableExtension: WithTypename<TimetableExtensionResult> }, MutationAddTimetableExtensionArgs>,
    addTopicsToCourses?: GraphCacheUpdateResolver<{ addTopicsToCourses: WithTypename<DoneResult> }, MutationAddTopicsToCoursesArgs>,
    aiToolTextToSpeech?: GraphCacheUpdateResolver<{ aiToolTextToSpeech: WithTypename<TextToSpeechLogResult> }, MutationAiToolTextToSpeechArgs>,
    changePassword?: GraphCacheUpdateResolver<{ changePassword: WithTypename<DoneResult> }, MutationChangePasswordArgs>,
    checkCoursePermission?: GraphCacheUpdateResolver<{ checkCoursePermission: WithTypename<UserCoursePermission> }, MutationCheckCoursePermissionArgs>,
    checkExistingExternalCourses?: GraphCacheUpdateResolver<{ checkExistingExternalCourses: WithTypename<ExistingCourseMappingResult> }, MutationCheckExistingExternalCoursesArgs>,
    checkTenantPermission?: GraphCacheUpdateResolver<{ checkTenantPermission: WithTypename<UserTenantPermission> }, MutationCheckTenantPermissionArgs>,
    closeCourse?: GraphCacheUpdateResolver<{ closeCourse: WithTypename<CourseResult> }, MutationCloseCourseArgs>,
    connectExternalCourse?: GraphCacheUpdateResolver<{ connectExternalCourse: WithTypename<DoneResult> }, MutationConnectExternalCourseArgs>,
    connectExternalIntegration?: GraphCacheUpdateResolver<{ connectExternalIntegration: WithTypename<DoneResult> }, MutationConnectExternalIntegrationArgs>,
    connectTemplateToCourse?: GraphCacheUpdateResolver<{ connectTemplateToCourse: WithTypename<DoneResult> }, MutationConnectTemplateToCourseArgs>,
    copyFolderToCourse?: GraphCacheUpdateResolver<{ copyFolderToCourse: WithTypename<DoneResult> }, MutationCopyFolderToCourseArgs>,
    copyMaterialToFolder?: GraphCacheUpdateResolver<{ copyMaterialToFolder: WithTypename<DoneResult> }, MutationCopyMaterialToFolderArgs>,
    createAiSettingsForCourse?: GraphCacheUpdateResolver<{ createAiSettingsForCourse: WithTypename<AiSettingsResult> }, MutationCreateAiSettingsForCourseArgs>,
    createCourse?: GraphCacheUpdateResolver<{ createCourse: WithTypename<CourseResult> }, MutationCreateCourseArgs>,
    createCourseCollaborationInvite?: GraphCacheUpdateResolver<{ createCourseCollaborationInvite: WithTypename<CourseInviteResult> }, MutationCreateCourseCollaborationInviteArgs>,
    createCourseFolder?: GraphCacheUpdateResolver<{ createCourseFolder: WithTypename<CourseFolderResult> }, MutationCreateCourseFolderArgs>,
    createCourseMaterial?: GraphCacheUpdateResolver<{ createCourseMaterial: WithTypename<CourseMaterialResult> }, MutationCreateCourseMaterialArgs>,
    createCoursePublicAccess?: GraphCacheUpdateResolver<{ createCoursePublicAccess: WithTypename<CoursePublicAccessResult> }, MutationCreateCoursePublicAccessArgs>,
    createLibraryFolder?: GraphCacheUpdateResolver<{ createLibraryFolder: WithTypename<LibraryFolderResult> }, MutationCreateLibraryFolderArgs>,
    createMaterial?: GraphCacheUpdateResolver<{ createMaterial: WithTypename<MaterialResult> }, MutationCreateMaterialArgs>,
    createStudentAiAssignment?: GraphCacheUpdateResolver<{ createStudentAiAssignment: WithTypename<StudentAiAssignmentResult> }, MutationCreateStudentAiAssignmentArgs>,
    createToDo?: GraphCacheUpdateResolver<{ createToDo: WithTypename<TodoResult> }, MutationCreateToDoArgs>,
    createTopic?: GraphCacheUpdateResolver<{ createTopic: WithTypename<TopicResult> }, MutationCreateTopicArgs>,
    createTopicInstance?: GraphCacheUpdateResolver<{ createTopicInstance: WithTypename<TopicInstanceResult> }, MutationCreateTopicInstanceArgs>,
    deleteInteractiveAssignmentSession?: GraphCacheUpdateResolver<{ deleteInteractiveAssignmentSession: WithTypename<DoneResult> }, MutationDeleteInteractiveAssignmentSessionArgs>,
    deleteToDo?: GraphCacheUpdateResolver<{ deleteToDo: WithTypename<DoneResult> }, MutationDeleteToDoArgs>,
    disconnectExternalCourse?: GraphCacheUpdateResolver<{ disconnectExternalCourse: WithTypename<DoneResult> }, MutationDisconnectExternalCourseArgs>,
    disconnectExternalIntegration?: GraphCacheUpdateResolver<{ disconnectExternalIntegration: WithTypename<DoneResult> }, MutationDisconnectExternalIntegrationArgs>,
    duplicateItems?: GraphCacheUpdateResolver<{ duplicateItems: Array<WithTypename<Material>> }, MutationDuplicateItemsArgs>,
    duplicateMaterials?: GraphCacheUpdateResolver<{ duplicateMaterials: Array<WithTypename<Material>> }, MutationDuplicateMaterialsArgs>,
    duplicateTopics?: GraphCacheUpdateResolver<{ duplicateTopics: Array<WithTypename<Folder>> }, MutationDuplicateTopicsArgs>,
    duplicateTopicsToFolder?: GraphCacheUpdateResolver<{ duplicateTopicsToFolder: WithTypename<DoneResult> }, MutationDuplicateTopicsToFolderArgs>,
    emailSignup?: GraphCacheUpdateResolver<{ emailSignup: WithTypename<AuthResult> }, MutationEmailSignupArgs>,
    exportLibraryContent?: GraphCacheUpdateResolver<{ exportLibraryContent: WithTypename<DoneResult> }, Record<string, never>>,
    generateLinkPreview?: GraphCacheUpdateResolver<{ generateLinkPreview: WithTypename<LinkPreviewExtra> }, MutationGenerateLinkPreviewArgs>,
    generatePromptSuggestions?: GraphCacheUpdateResolver<{ generatePromptSuggestions: Array<WithTypename<IpiPromptSuggestion>> }, MutationGeneratePromptSuggestionsArgs>,
    ignoreExternalCourse?: GraphCacheUpdateResolver<{ ignoreExternalCourse: WithTypename<DoneResult> }, MutationIgnoreExternalCourseArgs>,
    initialMaterialIpiPrompt?: GraphCacheUpdateResolver<{ initialMaterialIpiPrompt: WithTypename<InitialIpiPromptResult> }, MutationInitialMaterialIpiPromptArgs>,
    integrationCheck?: GraphCacheUpdateResolver<{ integrationCheck: WithTypename<IntegrationCheckResult> }, MutationIntegrationCheckArgs>,
    invalidateCourseCollaborationInvite?: GraphCacheUpdateResolver<{ invalidateCourseCollaborationInvite: WithTypename<DoneResult> }, MutationInvalidateCourseCollaborationInviteArgs>,
    invalidateCoursePublicAccess?: GraphCacheUpdateResolver<{ invalidateCoursePublicAccess: WithTypename<DoneResult> }, MutationInvalidateCoursePublicAccessArgs>,
    joinExistingExternalCourse?: GraphCacheUpdateResolver<{ joinExistingExternalCourse: WithTypename<DoneResult> }, MutationJoinExistingExternalCourseArgs>,
    login?: GraphCacheUpdateResolver<{ login: WithTypename<AuthResult> }, MutationLoginArgs>,
    migrateMaterial?: GraphCacheUpdateResolver<{ migrateMaterial: WithTypename<DoneResult> }, MutationMigrateMaterialArgs>,
    moveCalendarEvent?: GraphCacheUpdateResolver<{ moveCalendarEvent: WithTypename<CalendarEventResult> }, MutationMoveCalendarEventArgs>,
    moveItems?: GraphCacheUpdateResolver<{ moveItems: WithTypename<DoneResult> }, MutationMoveItemsArgs>,
    moveLibraryFolder?: GraphCacheUpdateResolver<{ moveLibraryFolder: WithTypename<LibraryFolderResult> }, MutationMoveLibraryFolderArgs>,
    moveMaterial?: GraphCacheUpdateResolver<{ moveMaterial: WithTypename<DoneResult> }, MutationMoveMaterialArgs>,
    moveMaterials?: GraphCacheUpdateResolver<{ moveMaterials: WithTypename<DoneResult> }, MutationMoveMaterialsArgs>,
    moveTopic?: GraphCacheUpdateResolver<{ moveTopic: WithTypename<TopicResult> }, MutationMoveTopicArgs>,
    moveTopics?: GraphCacheUpdateResolver<{ moveTopics: WithTypename<DoneResult> }, MutationMoveTopicsArgs>,
    pushEntireUserTimetable?: GraphCacheUpdateResolver<{ pushEntireUserTimetable: WithTypename<DoneResult> }, MutationPushEntireUserTimetableArgs>,
    pushLessonToExternalSource?: GraphCacheUpdateResolver<{ pushLessonToExternalSource: WithTypename<DoneResult> }, MutationPushLessonToExternalSourceArgs>,
    pushOnboardingProgress?: GraphCacheUpdateResolver<{ pushOnboardingProgress: WithTypename<DoneResult> }, MutationPushOnboardingProgressArgs>,
    rateIpiRequest?: GraphCacheUpdateResolver<{ rateIpiRequest: WithTypename<DoneResult> }, MutationRateIpiRequestArgs>,
    refreshToken?: GraphCacheUpdateResolver<{ refreshToken: WithTypename<AuthResult> }, MutationRefreshTokenArgs>,
    removeCalendarEvent?: GraphCacheUpdateResolver<{ removeCalendarEvent: WithTypename<DoneResult> }, MutationRemoveCalendarEventArgs>,
    removeCollaborator?: GraphCacheUpdateResolver<{ removeCollaborator: WithTypename<DoneResult> }, MutationRemoveCollaboratorArgs>,
    removeCourseFolder?: GraphCacheUpdateResolver<{ removeCourseFolder: WithTypename<DoneResult> }, MutationRemoveCourseFolderArgs>,
    removeFolder?: GraphCacheUpdateResolver<{ removeFolder: WithTypename<DoneResult> }, MutationRemoveFolderArgs>,
    removeItem?: GraphCacheUpdateResolver<{ removeItem: WithTypename<DoneResult> }, MutationRemoveItemArgs>,
    removeItems?: GraphCacheUpdateResolver<{ removeItems: WithTypename<DoneResult> }, MutationRemoveItemsArgs>,
    removeLibraryFolder?: GraphCacheUpdateResolver<{ removeLibraryFolder: WithTypename<DoneResult> }, MutationRemoveLibraryFolderArgs>,
    removeMaterial?: GraphCacheUpdateResolver<{ removeMaterial: WithTypename<DoneResult> }, MutationRemoveMaterialArgs>,
    removeMaterials?: GraphCacheUpdateResolver<{ removeMaterials: WithTypename<DoneResult> }, MutationRemoveMaterialsArgs>,
    removeStudentAiAssignment?: GraphCacheUpdateResolver<{ removeStudentAiAssignment: WithTypename<DoneResult> }, MutationRemoveStudentAiAssignmentArgs>,
    removeTimetableExtension?: GraphCacheUpdateResolver<{ removeTimetableExtension: WithTypename<DoneResult> }, MutationRemoveTimetableExtensionArgs>,
    removeTopic?: GraphCacheUpdateResolver<{ removeTopic: WithTypename<DoneResult> }, MutationRemoveTopicArgs>,
    removeTopicInstance?: GraphCacheUpdateResolver<{ removeTopicInstance: WithTypename<DoneResult> }, MutationRemoveTopicInstanceArgs>,
    removeTopicInstances?: GraphCacheUpdateResolver<{ removeTopicInstances: WithTypename<DoneResult> }, MutationRemoveTopicInstancesArgs>,
    removeTopics?: GraphCacheUpdateResolver<{ removeTopics: WithTypename<DoneResult> }, MutationRemoveTopicsArgs>,
    reorderCourse?: GraphCacheUpdateResolver<{ reorderCourse: WithTypename<DoneResult> }, MutationReorderCourseArgs>,
    reorderCourseFolder?: GraphCacheUpdateResolver<{ reorderCourseFolder: WithTypename<CourseFolderResult> }, MutationReorderCourseFolderArgs>,
    reorderItem?: GraphCacheUpdateResolver<{ reorderItem: WithTypename<ItemResult> }, MutationReorderItemArgs>,
    reorderMaterial?: GraphCacheUpdateResolver<{ reorderMaterial: WithTypename<MaterialResult> }, MutationReorderMaterialArgs>,
    reorderTopic?: GraphCacheUpdateResolver<{ reorderTopic: WithTypename<TopicResult> }, MutationReorderTopicArgs>,
    reorderTopicInstance?: GraphCacheUpdateResolver<{ reorderTopicInstance: WithTypename<TopicInstanceResult> }, MutationReorderTopicInstanceArgs>,
    requestCheckoutSessionData?: GraphCacheUpdateResolver<{ requestCheckoutSessionData: WithTypename<PaymentGatewayManagementData> }, MutationRequestCheckoutSessionDataArgs>,
    requestPaymentGatewayPortalData?: GraphCacheUpdateResolver<{ requestPaymentGatewayPortalData: WithTypename<PaymentGatewayManagementData> }, MutationRequestPaymentGatewayPortalDataArgs>,
    requestUserPasswordReset?: GraphCacheUpdateResolver<{ requestUserPasswordReset: WithTypename<DoneResult> }, MutationRequestUserPasswordResetArgs>,
    requestVerificationEmail?: GraphCacheUpdateResolver<{ requestVerificationEmail: WithTypename<DoneResult> }, Record<string, never>>,
    setCourseFirstFeatureToggle?: GraphCacheUpdateResolver<{ setCourseFirstFeatureToggle: WithTypename<DoneResult> }, MutationSetCourseFirstFeatureToggleArgs>,
    ssoSignup?: GraphCacheUpdateResolver<{ ssoSignup: WithTypename<AuthResult> }, MutationSsoSignupArgs>,
    syncCourseWithTemplate?: GraphCacheUpdateResolver<{ syncCourseWithTemplate: WithTypename<DoneResult> }, MutationSyncCourseWithTemplateArgs>,
    syncItemWithTemplate?: GraphCacheUpdateResolver<{ syncItemWithTemplate: WithTypename<DoneResult> }, MutationSyncItemWithTemplateArgs>,
    syncTopicWithTemplate?: GraphCacheUpdateResolver<{ syncTopicWithTemplate: WithTypename<DoneResult> }, MutationSyncTopicWithTemplateArgs>,
    toggleCourseMaterialVisibility?: GraphCacheUpdateResolver<{ toggleCourseMaterialVisibility: WithTypename<DoneResult> }, MutationToggleCourseMaterialVisibilityArgs>,
    toggleItemInstanceVisibility?: GraphCacheUpdateResolver<{ toggleItemInstanceVisibility: WithTypename<ItemInstanceResult> }, MutationToggleItemInstanceVisibilityArgs>,
    toggleStudentAiAssignment?: GraphCacheUpdateResolver<{ toggleStudentAiAssignment: WithTypename<StudentAiAssignmentResult> }, MutationToggleStudentAiAssignmentArgs>,
    unIgnoreExternalCourse?: GraphCacheUpdateResolver<{ unIgnoreExternalCourse: WithTypename<DoneResult> }, MutationUnIgnoreExternalCourseArgs>,
    updateAiSettingsForCourse?: GraphCacheUpdateResolver<{ updateAiSettingsForCourse: WithTypename<AiSettingsResult> }, MutationUpdateAiSettingsForCourseArgs>,
    updateCalendarNote?: GraphCacheUpdateResolver<{ updateCalendarNote: WithTypename<CalendarNoteResult> }, MutationUpdateCalendarNoteArgs>,
    updateCollaborator?: GraphCacheUpdateResolver<{ updateCollaborator: WithTypename<DoneResult> }, MutationUpdateCollaboratorArgs>,
    updateCourse?: GraphCacheUpdateResolver<{ updateCourse: WithTypename<CourseResult> }, MutationUpdateCourseArgs>,
    updateFolder?: GraphCacheUpdateResolver<{ updateFolder: WithTypename<FolderResult> }, MutationUpdateFolderArgs>,
    updateItem?: GraphCacheUpdateResolver<{ updateItem: WithTypename<ItemResult> }, MutationUpdateItemArgs>,
    updateLibraryFolder?: GraphCacheUpdateResolver<{ updateLibraryFolder: WithTypename<LibraryFolderResult> }, MutationUpdateLibraryFolderArgs>,
    updateMaterial?: GraphCacheUpdateResolver<{ updateMaterial: WithTypename<MaterialResult> }, MutationUpdateMaterialArgs>,
    updateStudentAiAssignment?: GraphCacheUpdateResolver<{ updateStudentAiAssignment: WithTypename<StudentAiAssignmentResult> }, MutationUpdateStudentAiAssignmentArgs>,
    updateTimetableExtension?: GraphCacheUpdateResolver<{ updateTimetableExtension: WithTypename<TimetableExtensionResult> }, MutationUpdateTimetableExtensionArgs>,
    updateToDo?: GraphCacheUpdateResolver<{ updateToDo: WithTypename<TodoResult> }, MutationUpdateToDoArgs>,
    updateTopic?: GraphCacheUpdateResolver<{ updateTopic: WithTypename<TopicResult> }, MutationUpdateTopicArgs>,
    updateTopicInstance?: GraphCacheUpdateResolver<{ updateTopicInstance: WithTypename<TopicInstanceResult> }, MutationUpdateTopicInstanceArgs>,
    updateUser?: GraphCacheUpdateResolver<{ updateUser: WithTypename<UserResult> }, MutationUpdateUserArgs>,
    updateUserEmail?: GraphCacheUpdateResolver<{ updateUserEmail: WithTypename<UserResult> }, MutationUpdateUserEmailArgs>,
    updateUserEmailNotificationSubscription?: GraphCacheUpdateResolver<{ updateUserEmailNotificationSubscription: WithTypename<DoneResult> }, MutationUpdateUserEmailNotificationSubscriptionArgs>,
    updateUserPreferences?: GraphCacheUpdateResolver<{ updateUserPreferences: WithTypename<DoneResult> }, MutationUpdateUserPreferencesArgs>,
    verifyUserEmail?: GraphCacheUpdateResolver<{ verifyUserEmail: WithTypename<UserResult> }, MutationVerifyUserEmailArgs>,
    verifyUserPasswordReset?: GraphCacheUpdateResolver<{ verifyUserPasswordReset: WithTypename<AuthResult> }, MutationVerifyUserPasswordResetArgs>
  },
  Subscription?: object,
  AiSettings?: {
    age?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    curriculum?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    language?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    linkedCurriculum?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    linkedCurriculumContent?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    subject?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>
  },
  AiSettingsResult?: {
    age?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettingsResult>>, Record<string, never>>,
    curriculum?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettingsResult>>, Record<string, never>>,
    language?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettingsResult>>, Record<string, never>>,
    linkedCurriculum?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettingsResult>>, Record<string, never>>,
    linkedCurriculumContent?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettingsResult>>, Record<string, never>>,
    subject?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettingsResult>>, Record<string, never>>
  },
  AssignmentChatbot?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbot>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbot>>, Record<string, never>>
  },
  AssignmentChatbotHistory?: {
    assignmentId?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotHistory>>, Record<string, never>>,
    instances?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotHistory>>, Record<string, never>>,
    nickname?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotHistory>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotHistory>>, Record<string, never>>
  },
  AssignmentChatbotInstanceSummary?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotInstanceSummary>>, Record<string, never>>,
    instanceId?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotInstanceSummary>>, Record<string, never>>,
    isActive?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotInstanceSummary>>, Record<string, never>>,
    messages?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotInstanceSummary>>, Record<string, never>>
  },
  AssignmentChatbotMessage?: {
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotMessage>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotMessage>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotMessage>>, Record<string, never>>,
    role?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentChatbotMessage>>, Record<string, never>>
  },
  AssignmentOpenQuestion?: {
    guidance?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestion>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestion>>, Record<string, never>>,
    question?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestion>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestion>>, Record<string, never>>
  },
  AssignmentOpenQuestionAttempt?: {
    answer?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestionAttempt>>, Record<string, never>>,
    feedback?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestionAttempt>>, Record<string, never>>,
    hints?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestionAttempt>>, Record<string, never>>,
    rating?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestionAttempt>>, Record<string, never>>
  },
  AssignmentOpenQuestionHistory?: {
    attempts?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestionHistory>>, Record<string, never>>,
    guidance?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestionHistory>>, Record<string, never>>,
    nickname?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestionHistory>>, Record<string, never>>,
    question?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentOpenQuestionHistory>>, Record<string, never>>
  },
  AssignmentStatus?: {
    assignmentId?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentStatus>>, Record<string, never>>,
    feedbackCount?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentStatus>>, Record<string, never>>,
    hintCount?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentStatus>>, Record<string, never>>,
    latestAnswer?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentStatus>>, Record<string, never>>,
    latestSelectedOptionIds?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentStatus>>, Record<string, never>>,
    messageCount?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentStatus>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<AssignmentStatus>>, Record<string, never>>
  },
  AuthResult?: {
    access_token?: GraphCacheUpdateResolver<Maybe<WithTypename<AuthResult>>, Record<string, never>>,
    refresh_token?: GraphCacheUpdateResolver<Maybe<WithTypename<AuthResult>>, Record<string, never>>,
    userId?: GraphCacheUpdateResolver<Maybe<WithTypename<AuthResult>>, Record<string, never>>
  },
  CalendarEventListResult?: {
    calendarEvents?: GraphCacheUpdateResolver<Maybe<WithTypename<CalendarEventListResult>>, Record<string, never>>
  },
  CalendarEventResult?: {
    calendarEvent?: GraphCacheUpdateResolver<Maybe<WithTypename<CalendarEventResult>>, Record<string, never>>
  },
  CalendarNote?: {
    backgroundColor?: GraphCacheUpdateResolver<Maybe<WithTypename<CalendarNote>>, Record<string, never>>,
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<CalendarNote>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CalendarNote>>, Record<string, never>>,
    foregroundColor?: GraphCacheUpdateResolver<Maybe<WithTypename<CalendarNote>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CalendarNote>>, Record<string, never>>,
    note?: GraphCacheUpdateResolver<Maybe<WithTypename<CalendarNote>>, Record<string, never>>
  },
  CalendarNoteResult?: {
    calendarNote?: GraphCacheUpdateResolver<Maybe<WithTypename<CalendarNoteResult>>, Record<string, never>>
  },
  Configuration?: {
    featureFlags?: GraphCacheUpdateResolver<Maybe<WithTypename<Configuration>>, Record<string, never>>,
    global?: GraphCacheUpdateResolver<Maybe<WithTypename<Configuration>>, Record<string, never>>
  },
  ConnectedCourse?: {
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<ConnectedCourse>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<ConnectedCourse>>, Record<string, never>>,
    externalCourseMappingId?: GraphCacheUpdateResolver<Maybe<WithTypename<ConnectedCourse>>, Record<string, never>>,
    externalId?: GraphCacheUpdateResolver<Maybe<WithTypename<ConnectedCourse>>, Record<string, never>>,
    externalUserCredentialsId?: GraphCacheUpdateResolver<Maybe<WithTypename<ConnectedCourse>>, Record<string, never>>,
    roleInCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<ConnectedCourse>>, Record<string, never>>
  },
  Country?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Country>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Country>>, Record<string, never>>,
    languageDefault?: GraphCacheUpdateResolver<Maybe<WithTypename<Country>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Country>>, Record<string, never>>
  },
  CountryStateCombo?: {
    countryName?: GraphCacheUpdateResolver<Maybe<WithTypename<CountryStateCombo>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<CountryStateCombo>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CountryStateCombo>>, Record<string, never>>,
    language?: GraphCacheUpdateResolver<Maybe<WithTypename<CountryStateCombo>>, Record<string, never>>,
    stateId?: GraphCacheUpdateResolver<Maybe<WithTypename<CountryStateCombo>>, Record<string, never>>,
    stateName?: GraphCacheUpdateResolver<Maybe<WithTypename<CountryStateCombo>>, Record<string, never>>
  },
  Course?: {
    backgroundColor?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    classLevelAge?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    classLevelKey?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    classLevelLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    closedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    collaborators?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    countryKey?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    countryLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    days?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    externalCourseMappings?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    foregroundColor?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    hasOrigin?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    languageKey?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    languageLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    lastOriginSyncAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    origin?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    originDetails?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    owner?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    permissions?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    promptingAddition?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    schoolTypeKey?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    schoolTypeLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    schoolYear?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    shortName?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    stateKey?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    stateLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    subject?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    subjectKey?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    subjectLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    tenant?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    usage?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>
  },
  CourseCalendarDay?: {
    calendarEvents?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseCalendarDay>>, Record<string, never>>,
    day?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseCalendarDay>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseCalendarDay>>, Record<string, never>>,
    periodCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseCalendarDay>>, Record<string, never>>
  },
  CourseCollaborator?: {
    courseRole?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseCollaborator>>, Record<string, never>>,
    fullName?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseCollaborator>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseCollaborator>>, Record<string, never>>,
    joinedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseCollaborator>>, Record<string, never>>,
    userId?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseCollaborator>>, Record<string, never>>
  },
  CourseCollaboratorResult?: {
    courseCollaborator?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseCollaboratorResult>>, Record<string, never>>
  },
  CourseContentVisibility?: {
    contentVisibility?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseContentVisibility>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseContentVisibility>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseContentVisibility>>, Record<string, never>>
  },
  CourseFolder?: {
    courseId?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseFolder>>, Record<string, never>>,
    courseMaterials?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseFolder>>, Record<string, never>>,
    endDate?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseFolder>>, Record<string, never>>,
    folder?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseFolder>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseFolder>>, Record<string, never>>,
    materialCount?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseFolder>>, Record<string, never>>,
    startDate?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseFolder>>, Record<string, never>>
  },
  CourseFolderResult?: {
    courseFolder?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseFolderResult>>, Record<string, never>>
  },
  CourseInvite?: {
    code?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvite>>, Record<string, never>>,
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvite>>, Record<string, never>>,
    courseMembershipRole?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvite>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvite>>, Record<string, never>>,
    expirationDate?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvite>>, Record<string, never>>,
    expiredAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvite>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvite>>, Record<string, never>>
  },
  CourseInvitePreview?: {
    backgroundColor?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvitePreview>>, Record<string, never>>,
    courseId?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvitePreview>>, Record<string, never>>,
    courseMember?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvitePreview>>, Record<string, never>>,
    courseName?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvitePreview>>, Record<string, never>>,
    courseOwner?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvitePreview>>, Record<string, never>>,
    expiredAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvitePreview>>, Record<string, never>>,
    foregroundColor?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvitePreview>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInvitePreview>>, Record<string, never>>
  },
  CourseInviteResult?: {
    courseInvite?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseInviteResult>>, Record<string, never>>
  },
  CourseMaterial?: {
    courseId?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseMaterial>>, Record<string, never>>,
    courseVisibility?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseMaterial>>, Record<string, never>>,
    courseVisibleAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseMaterial>>, Record<string, never>>,
    dates?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseMaterial>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseMaterial>>, Record<string, never>>,
    material?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseMaterial>>, Record<string, never>>
  },
  CourseMaterialResult?: {
    courseMaterial?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseMaterialResult>>, Record<string, never>>
  },
  CoursePublicAccess?: {
    code?: GraphCacheUpdateResolver<Maybe<WithTypename<CoursePublicAccess>>, Record<string, never>>,
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<CoursePublicAccess>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CoursePublicAccess>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CoursePublicAccess>>, Record<string, never>>
  },
  CoursePublicAccessResult?: {
    coursePublicAccess?: GraphCacheUpdateResolver<Maybe<WithTypename<CoursePublicAccessResult>>, Record<string, never>>
  },
  CourseResult?: {
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseResult>>, Record<string, never>>
  },
  Curriculum?: {
    country?: GraphCacheUpdateResolver<Maybe<WithTypename<Curriculum>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Curriculum>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Curriculum>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Curriculum>>, Record<string, never>>,
    state?: GraphCacheUpdateResolver<Maybe<WithTypename<Curriculum>>, Record<string, never>>
  },
  CurriculumContent?: {
    classLevel?: GraphCacheUpdateResolver<Maybe<WithTypename<CurriculumContent>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CurriculumContent>>, Record<string, never>>,
    curriculum?: GraphCacheUpdateResolver<Maybe<WithTypename<CurriculumContent>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CurriculumContent>>, Record<string, never>>,
    schoolType?: GraphCacheUpdateResolver<Maybe<WithTypename<CurriculumContent>>, Record<string, never>>,
    subject?: GraphCacheUpdateResolver<Maybe<WithTypename<CurriculumContent>>, Record<string, never>>
  },
  DoneResult?: {
    done?: GraphCacheUpdateResolver<Maybe<WithTypename<DoneResult>>, Record<string, never>>
  },
  ExistingCourseMapping?: {
    courses?: GraphCacheUpdateResolver<Maybe<WithTypename<ExistingCourseMapping>>, Record<string, never>>,
    externalCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<ExistingCourseMapping>>, Record<string, never>>,
    externalId?: GraphCacheUpdateResolver<Maybe<WithTypename<ExistingCourseMapping>>, Record<string, never>>
  },
  ExistingCourseMappingResult?: {
    existingCourseMappings?: GraphCacheUpdateResolver<Maybe<WithTypename<ExistingCourseMappingResult>>, Record<string, never>>
  },
  ExternalContent?: {
    externalContentCategory?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>,
    externalContentType?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>,
    externalReferenceId?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>,
    preview?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>,
    primaryUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>,
    rootId?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>,
    secondaryUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>,
    source?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>,
    sourceCredentialsExternalId?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContent>>, Record<string, never>>
  },
  ExternalContentApiError?: {
    code?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContentApiError>>, Record<string, never>>,
    internalMessage?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContentApiError>>, Record<string, never>>
  },
  ExternalContentPreview?: {
    contentId?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContentPreview>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContentPreview>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContentPreview>>, Record<string, never>>,
    primaryUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContentPreview>>, Record<string, never>>,
    secondaryUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContentPreview>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContentPreview>>, Record<string, never>>
  },
  ExternalContentResult?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContentResult>>, Record<string, never>>,
    externalContent?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalContentResult>>, Record<string, never>>
  },
  ExternalCourse?: {
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourse>>, Record<string, never>>,
    externalId?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourse>>, Record<string, never>>,
    externalUserCredentialsId?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourse>>, Record<string, never>>,
    roleInCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourse>>, Record<string, never>>
  },
  ExternalCourseMapping?: {
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourseMapping>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourseMapping>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourseMapping>>, Record<string, never>>,
    externalId?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourseMapping>>, Record<string, never>>,
    externalUserCredentials?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourseMapping>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourseMapping>>, Record<string, never>>,
    roleInCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCourseMapping>>, Record<string, never>>
  },
  ExternalCoursesResult?: {
    connectedCourses?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCoursesResult>>, Record<string, never>>,
    ignoredCourses?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCoursesResult>>, Record<string, never>>,
    unmappedCourses?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalCoursesResult>>, Record<string, never>>
  },
  ExternalIntegrationSetting?: {
    additionalIdentifier?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalIntegrationSetting>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalIntegrationSetting>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalIntegrationSetting>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalIntegrationSetting>>, Record<string, never>>,
    integrationFeatures?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalIntegrationSetting>>, Record<string, never>>,
    key?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalIntegrationSetting>>, Record<string, never>>,
    tenant?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalIntegrationSetting>>, Record<string, never>>
  },
  ExternalUserCredentials?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalUserCredentials>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalUserCredentials>>, Record<string, never>>,
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalUserCredentials>>, Record<string, never>>,
    externalId?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalUserCredentials>>, Record<string, never>>,
    externalIntegrationSetting?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalUserCredentials>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalUserCredentials>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalUserCredentials>>, Record<string, never>>
  },
  Feature?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Feature>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Feature>>, Record<string, never>>,
    key?: GraphCacheUpdateResolver<Maybe<WithTypename<Feature>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Feature>>, Record<string, never>>
  },
  FeatureFlag?: {
    key?: GraphCacheUpdateResolver<Maybe<WithTypename<FeatureFlag>>, Record<string, never>>,
    settings?: GraphCacheUpdateResolver<Maybe<WithTypename<FeatureFlag>>, Record<string, never>>
  },
  Folder?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    deletedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    externalContent?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    goals?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    hasOrigin?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    lastOriginSyncAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    libraryFolder?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    originDetails?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    owner?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    permissions?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    position?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    syncContentUpdatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    topicCourses?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    topicStatistics?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>,
    usage?: GraphCacheUpdateResolver<Maybe<WithTypename<Folder>>, Record<string, never>>
  },
  FolderResult?: {
    folder?: GraphCacheUpdateResolver<Maybe<WithTypename<FolderResult>>, Record<string, never>>
  },
  GlobalConfiguration?: {
    uploadConfiguration?: GraphCacheUpdateResolver<Maybe<WithTypename<GlobalConfiguration>>, Record<string, never>>
  },
  IgnoredCourse?: {
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<IgnoredCourse>>, Record<string, never>>,
    externalCourseMappingId?: GraphCacheUpdateResolver<Maybe<WithTypename<IgnoredCourse>>, Record<string, never>>,
    externalId?: GraphCacheUpdateResolver<Maybe<WithTypename<IgnoredCourse>>, Record<string, never>>,
    externalUserCredentialsId?: GraphCacheUpdateResolver<Maybe<WithTypename<IgnoredCourse>>, Record<string, never>>,
    roleInCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<IgnoredCourse>>, Record<string, never>>
  },
  InitialIpiPromptResult?: {
    initialIpiPrompt?: GraphCacheUpdateResolver<Maybe<WithTypename<InitialIpiPromptResult>>, Record<string, never>>
  },
  IntegrationCheckResult?: {
    connectedUserAuthResult?: GraphCacheUpdateResolver<Maybe<WithTypename<IntegrationCheckResult>>, Record<string, never>>,
    integrationToS?: GraphCacheUpdateResolver<Maybe<WithTypename<IntegrationCheckResult>>, Record<string, never>>,
    temporaryExternalCredentials?: GraphCacheUpdateResolver<Maybe<WithTypename<IntegrationCheckResult>>, Record<string, never>>
  },
  IpiPromptHistoryItem?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<IpiPromptHistoryItem>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<IpiPromptHistoryItem>>, Record<string, never>>,
    userPrompt?: GraphCacheUpdateResolver<Maybe<WithTypename<IpiPromptHistoryItem>>, Record<string, never>>
  },
  IpiPromptHistoryResult?: {
    prompts?: GraphCacheUpdateResolver<Maybe<WithTypename<IpiPromptHistoryResult>>, Record<string, never>>
  },
  IpiPromptSuggestion?: {
    icon?: GraphCacheUpdateResolver<Maybe<WithTypename<IpiPromptSuggestion>>, Record<string, never>>,
    prompt?: GraphCacheUpdateResolver<Maybe<WithTypename<IpiPromptSuggestion>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<IpiPromptSuggestion>>, Record<string, never>>
  },
  ItemContent?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemContent>>, Record<string, never>>,
    item?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemContent>>, Record<string, never>>,
    itemInstances?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemContent>>, Record<string, never>>
  },
  ItemInstance?: {
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemInstance>>, Record<string, never>>,
    courseContentVisibility?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemInstance>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemInstance>>, Record<string, never>>,
    dates?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemInstance>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemInstance>>, Record<string, never>>,
    item?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemInstance>>, Record<string, never>>,
    lockedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemInstance>>, Record<string, never>>,
    topicInstance?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemInstance>>, Record<string, never>>
  },
  ItemInstanceResult?: {
    itemInstance?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemInstanceResult>>, Record<string, never>>
  },
  ItemResult?: {
    item?: GraphCacheUpdateResolver<Maybe<WithTypename<ItemResult>>, Record<string, never>>
  },
  LibraryFolder?: {
    children?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryFolder>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryFolder>>, Record<string, never>>,
    folderColor?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryFolder>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryFolder>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryFolder>>, Record<string, never>>,
    parentFolder?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryFolder>>, Record<string, never>>,
    parents?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryFolder>>, Record<string, never>>,
    position?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryFolder>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryFolder>>, Record<string, never>>
  },
  LibraryFolderResult?: {
    libraryFolder?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryFolderResult>>, Record<string, never>>
  },
  LibraryMetaResult?: {
    totalTopicsCount?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryMetaResult>>, Record<string, never>>,
    unsortedTopicsCount?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryMetaResult>>, Record<string, never>>
  },
  LibraryNewestContentResult?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryNewestContentResult>>, Record<string, never>>,
    materials?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryNewestContentResult>>, Record<string, never>>,
    topics?: GraphCacheUpdateResolver<Maybe<WithTypename<LibraryNewestContentResult>>, Record<string, never>>
  },
  License?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<License>>, Record<string, never>>,
    cycleRenewalAt?: GraphCacheUpdateResolver<Maybe<WithTypename<License>>, Record<string, never>>,
    cycleStartAt?: GraphCacheUpdateResolver<Maybe<WithTypename<License>>, Record<string, never>>,
    expiresAt?: GraphCacheUpdateResolver<Maybe<WithTypename<License>>, Record<string, never>>,
    holderType?: GraphCacheUpdateResolver<Maybe<WithTypename<License>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<License>>, Record<string, never>>,
    plan?: GraphCacheUpdateResolver<Maybe<WithTypename<License>>, Record<string, never>>,
    planStartAt?: GraphCacheUpdateResolver<Maybe<WithTypename<License>>, Record<string, never>>,
    tenant?: GraphCacheUpdateResolver<Maybe<WithTypename<License>>, Record<string, never>>
  },
  LinkPreviewExtra?: {
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<LinkPreviewExtra>>, Record<string, never>>,
    iframe?: GraphCacheUpdateResolver<Maybe<WithTypename<LinkPreviewExtra>>, Record<string, never>>,
    imageUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<LinkPreviewExtra>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<LinkPreviewExtra>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<LinkPreviewExtra>>, Record<string, never>>
  },
  Material?: {
    annotationToolToken?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    contentHtml?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    contentStatistics?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    deletedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    duration?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    externalContent?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    hasOrigin?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    icon?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    initialIpiRequestId?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    lastOriginSyncAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    linkedTopics?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    migratedToMaterial?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    newEditor?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    originDetails?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    owner?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    permissions?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    position?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    syncContentUpdatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    topic?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>,
    usage?: GraphCacheUpdateResolver<Maybe<WithTypename<Material>>, Record<string, never>>
  },
  MaterialAnnotationToolAccess?: {
    expiresAt?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialAnnotationToolAccess>>, Record<string, never>>,
    token?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialAnnotationToolAccess>>, Record<string, never>>
  },
  MaterialContentHtml?: {
    html?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialContentHtml>>, Record<string, never>>
  },
  MaterialContentStatistics?: {
    fileCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialContentStatistics>>, Record<string, never>>,
    imageCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialContentStatistics>>, Record<string, never>>,
    interactiveAssignmentCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialContentStatistics>>, Record<string, never>>,
    linkCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialContentStatistics>>, Record<string, never>>,
    noteCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialContentStatistics>>, Record<string, never>>
  },
  MaterialCourse?: {
    backgroundColor?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialCourse>>, Record<string, never>>,
    code?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialCourse>>, Record<string, never>>,
    foregroundColor?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialCourse>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialCourse>>, Record<string, never>>,
    isSharedWithStudents?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialCourse>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialCourse>>, Record<string, never>>,
    shortName?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialCourse>>, Record<string, never>>
  },
  MaterialInteractiveAssignmentStatus?: {
    materialId?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialInteractiveAssignmentStatus>>, Record<string, never>>,
    started?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialInteractiveAssignmentStatus>>, Record<string, never>>
  },
  MaterialInteractiveAssignmentsStudentOverview?: {
    assignmentsStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialInteractiveAssignmentsStudentOverview>>, Record<string, never>>,
    lastActivity?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialInteractiveAssignmentsStudentOverview>>, Record<string, never>>,
    nickname?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialInteractiveAssignmentsStudentOverview>>, Record<string, never>>,
    sessionId?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialInteractiveAssignmentsStudentOverview>>, Record<string, never>>
  },
  MaterialResult?: {
    material?: GraphCacheUpdateResolver<Maybe<WithTypename<MaterialResult>>, Record<string, never>>
  },
  OriginDetails?: {
    contentChanged?: GraphCacheUpdateResolver<Maybe<WithTypename<OriginDetails>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<OriginDetails>>, Record<string, never>>,
    newAdditions?: GraphCacheUpdateResolver<Maybe<WithTypename<OriginDetails>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<OriginDetails>>, Record<string, never>>,
    usage?: GraphCacheUpdateResolver<Maybe<WithTypename<OriginDetails>>, Record<string, never>>
  },
  PaymentGatewayManagementData?: {
    gateway?: GraphCacheUpdateResolver<Maybe<WithTypename<PaymentGatewayManagementData>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<PaymentGatewayManagementData>>, Record<string, never>>
  },
  PeriodCourse?: {
    backgroundColor?: GraphCacheUpdateResolver<Maybe<WithTypename<PeriodCourse>>, Record<string, never>>,
    external?: GraphCacheUpdateResolver<Maybe<WithTypename<PeriodCourse>>, Record<string, never>>,
    foregroundColor?: GraphCacheUpdateResolver<Maybe<WithTypename<PeriodCourse>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PeriodCourse>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<PeriodCourse>>, Record<string, never>>,
    shortName?: GraphCacheUpdateResolver<Maybe<WithTypename<PeriodCourse>>, Record<string, never>>
  },
  Plan?: {
    billingCycle?: GraphCacheUpdateResolver<Maybe<WithTypename<Plan>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Plan>>, Record<string, never>>,
    defaultForKey?: GraphCacheUpdateResolver<Maybe<WithTypename<Plan>>, Record<string, never>>,
    defaultPrice?: GraphCacheUpdateResolver<Maybe<WithTypename<Plan>>, Record<string, never>>,
    defaultPriceMonth?: GraphCacheUpdateResolver<Maybe<WithTypename<Plan>>, Record<string, never>>,
    features?: GraphCacheUpdateResolver<Maybe<WithTypename<Plan>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Plan>>, Record<string, never>>,
    key?: GraphCacheUpdateResolver<Maybe<WithTypename<Plan>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Plan>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<Plan>>, Record<string, never>>
  },
  SchoolType?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolType>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolType>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolType>>, Record<string, never>>
  },
  SchoolYear?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolYear>>, Record<string, never>>,
    endDate?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolYear>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolYear>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolYear>>, Record<string, never>>,
    startDate?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolYear>>, Record<string, never>>,
    tenant?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolYear>>, Record<string, never>>
  },
  StudentAiAssignment?: {
    active?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>,
    code?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>,
    deletedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>,
    studentAiTemplate?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>,
    studentTasks?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>,
    systemPrompt?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignment>>, Record<string, never>>
  },
  StudentAiAssignmentResult?: {
    studentAiAssignment?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiAssignmentResult>>, Record<string, never>>
  },
  StudentAiTemplate?: {
    categories?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    classLevelName?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    imageUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    key?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    languageName?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    publicDescription?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    published?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    studentAge?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    studentTasks?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    subjectName?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    systemPrompt?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    tags?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAiTemplate>>, Record<string, never>>
  },
  StudentAssignmentOpenQuestionHistory?: {
    attempts?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAssignmentOpenQuestionHistory>>, Record<string, never>>,
    nickname?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentAssignmentOpenQuestionHistory>>, Record<string, never>>
  },
  Subject?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Subject>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Subject>>, Record<string, never>>,
    key?: GraphCacheUpdateResolver<Maybe<WithTypename<Subject>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Subject>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<Subject>>, Record<string, never>>
  },
  SupportTokenResult?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportTokenResult>>, Record<string, never>>,
    token?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportTokenResult>>, Record<string, never>>
  },
  TeachinoAiArea?: {
    aiGroups?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiArea>>, Record<string, never>>,
    freeInputTask?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiArea>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiArea>>, Record<string, never>>
  },
  TeachinoAiGroup?: {
    aiTasks?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiGroup>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiGroup>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiGroup>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiGroup>>, Record<string, never>>
  },
  TeachinoAiTask?: {
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiTask>>, Record<string, never>>,
    icon?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiTask>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiTask>>, Record<string, never>>,
    supportedInputBlocks?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiTask>>, Record<string, never>>,
    taskType?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiTask>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<TeachinoAiTask>>, Record<string, never>>
  },
  TemporaryExternalCredentials?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TemporaryExternalCredentials>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<TemporaryExternalCredentials>>, Record<string, never>>,
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<TemporaryExternalCredentials>>, Record<string, never>>,
    externalId?: GraphCacheUpdateResolver<Maybe<WithTypename<TemporaryExternalCredentials>>, Record<string, never>>,
    externalIntegrationSetting?: GraphCacheUpdateResolver<Maybe<WithTypename<TemporaryExternalCredentials>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TemporaryExternalCredentials>>, Record<string, never>>,
    temporaryCode?: GraphCacheUpdateResolver<Maybe<WithTypename<TemporaryExternalCredentials>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<TemporaryExternalCredentials>>, Record<string, never>>
  },
  Tenant?: {
    city?: GraphCacheUpdateResolver<Maybe<WithTypename<Tenant>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Tenant>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Tenant>>, Record<string, never>>,
    language?: GraphCacheUpdateResolver<Maybe<WithTypename<Tenant>>, Record<string, never>>,
    managementType?: GraphCacheUpdateResolver<Maybe<WithTypename<Tenant>>, Record<string, never>>,
    members?: GraphCacheUpdateResolver<Maybe<WithTypename<Tenant>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Tenant>>, Record<string, never>>,
    parent?: GraphCacheUpdateResolver<Maybe<WithTypename<Tenant>>, Record<string, never>>,
    permissions?: GraphCacheUpdateResolver<Maybe<WithTypename<Tenant>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<Tenant>>, Record<string, never>>
  },
  TenantInvite?: {
    code?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvite>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvite>>, Record<string, never>>,
    expirationDate?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvite>>, Record<string, never>>,
    expiredAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvite>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvite>>, Record<string, never>>,
    tenant?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvite>>, Record<string, never>>,
    tenantMembershipRole?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvite>>, Record<string, never>>
  },
  TenantInvitePreview?: {
    expiredAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvitePreview>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvitePreview>>, Record<string, never>>,
    tenantId?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvitePreview>>, Record<string, never>>,
    tenantMember?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvitePreview>>, Record<string, never>>,
    tenantName?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantInvitePreview>>, Record<string, never>>
  },
  TenantMember?: {
    fullName?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantMember>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantMember>>, Record<string, never>>,
    joinedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantMember>>, Record<string, never>>,
    tenantId?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantMember>>, Record<string, never>>,
    tenantName?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantMember>>, Record<string, never>>,
    tenantRole?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantMember>>, Record<string, never>>,
    userId?: GraphCacheUpdateResolver<Maybe<WithTypename<TenantMember>>, Record<string, never>>
  },
  TextToSpeechLog?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TextToSpeechLog>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TextToSpeechLog>>, Record<string, never>>,
    lastListenedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TextToSpeechLog>>, Record<string, never>>,
    speechUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<TextToSpeechLog>>, Record<string, never>>,
    textHash?: GraphCacheUpdateResolver<Maybe<WithTypename<TextToSpeechLog>>, Record<string, never>>,
    textLength?: GraphCacheUpdateResolver<Maybe<WithTypename<TextToSpeechLog>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<TextToSpeechLog>>, Record<string, never>>
  },
  TextToSpeechLogResult?: {
    textToSpeechLog?: GraphCacheUpdateResolver<Maybe<WithTypename<TextToSpeechLogResult>>, Record<string, never>>
  },
  Timetable?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Timetable>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Timetable>>, Record<string, never>>,
    inputMode?: GraphCacheUpdateResolver<Maybe<WithTypename<Timetable>>, Record<string, never>>,
    timetableEntries?: GraphCacheUpdateResolver<Maybe<WithTypename<Timetable>>, Record<string, never>>,
    timetableGrid?: GraphCacheUpdateResolver<Maybe<WithTypename<Timetable>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<Timetable>>, Record<string, never>>
  },
  TimetableDay?: {
    day?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableDay>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableDay>>, Record<string, never>>,
    periods?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableDay>>, Record<string, never>>
  },
  TimetableDayError?: {
    code?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableDayError>>, Record<string, never>>,
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableDayError>>, Record<string, never>>,
    source?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableDayError>>, Record<string, never>>
  },
  TimetableDayResult?: {
    timetableDays?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableDayResult>>, Record<string, never>>,
    timetableErrors?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableDayResult>>, Record<string, never>>
  },
  TimetableEntry?: {
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableEntry>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableEntry>>, Record<string, never>>,
    dayOfWeek?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableEntry>>, Record<string, never>>,
    fromTime?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableEntry>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableEntry>>, Record<string, never>>,
    timetable?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableEntry>>, Record<string, never>>,
    toTime?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableEntry>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableEntry>>, Record<string, never>>
  },
  TimetableExtension?: {
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    fromDay?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    fromTime?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    label?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    timetable?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    timetableEntry?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    toDay?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    toTime?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtension>>, Record<string, never>>
  },
  TimetableExtensionResult?: {
    timetableExtension?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableExtensionResult>>, Record<string, never>>
  },
  TimetableGridEntry?: {
    fromTime?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableGridEntry>>, Record<string, never>>,
    toTime?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetableGridEntry>>, Record<string, never>>
  },
  TimetablePeriod?: {
    endTime?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    extensionId?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    externalId?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    integrationId?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    label?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    periodCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    source?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    startTime?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    timeZone?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    timetableEntryId?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<TimetablePeriod>>, Record<string, never>>
  },
  ToDo?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ToDo>>, Record<string, never>>,
    deletedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ToDo>>, Record<string, never>>,
    doneAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ToDo>>, Record<string, never>>,
    dueAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ToDo>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ToDo>>, Record<string, never>>,
    owner?: GraphCacheUpdateResolver<Maybe<WithTypename<ToDo>>, Record<string, never>>,
    text?: GraphCacheUpdateResolver<Maybe<WithTypename<ToDo>>, Record<string, never>>
  },
  TodoResult?: {
    toDo?: GraphCacheUpdateResolver<Maybe<WithTypename<TodoResult>>, Record<string, never>>
  },
  TopicContent?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicContent>>, Record<string, never>>,
    itemContents?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicContent>>, Record<string, never>>,
    topic?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicContent>>, Record<string, never>>,
    topicInstances?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicContent>>, Record<string, never>>
  },
  TopicInstance?: {
    completedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    course?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    endDate?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    expanded?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    highlighted?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    lockedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    position?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    startDate?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    statistics?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>,
    topic?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstance>>, Record<string, never>>
  },
  TopicInstanceResult?: {
    topicInstance?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstanceResult>>, Record<string, never>>
  },
  TopicInstanceStatistics?: {
    doneItemInstances?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstanceStatistics>>, Record<string, never>>,
    plannedItemInstances?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstanceStatistics>>, Record<string, never>>,
    totalItemInstances?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstanceStatistics>>, Record<string, never>>,
    visibleItemInstances?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicInstanceStatistics>>, Record<string, never>>
  },
  TopicResult?: {
    topic?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicResult>>, Record<string, never>>
  },
  TopicStatistics?: {
    linkedItemsTotal?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicStatistics>>, Record<string, never>>
  },
  UnmappedCourse?: {
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<UnmappedCourse>>, Record<string, never>>,
    externalId?: GraphCacheUpdateResolver<Maybe<WithTypename<UnmappedCourse>>, Record<string, never>>,
    externalUserCredentialsId?: GraphCacheUpdateResolver<Maybe<WithTypename<UnmappedCourse>>, Record<string, never>>,
    roleInCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<UnmappedCourse>>, Record<string, never>>
  },
  User?: {
    countryKey?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    countryLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    defaultTenant?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    emailVerificationStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    emailVerifiedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    firstName?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    forceNewEditor?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    fullName?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    language?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    lastActiveAt?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    lastLoginAt?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    lastName?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    schoolTypeKey?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    schoolTypeLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    signedUp?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    stateKey?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    stateLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    username?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>
  },
  UserCalendarDay?: {
    courseCalendarDays?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCalendarDay>>, Record<string, never>>,
    day?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCalendarDay>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCalendarDay>>, Record<string, never>>,
    userId?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCalendarDay>>, Record<string, never>>
  },
  UserCoursePermission?: {
    canAddCalendarNote?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canAddCourseFolder?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canAddCourseTopicInstance?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canArchiveCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canChangeCourseSharingSettings?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canCloseCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canConnectToCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canEditCalendarNote?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canEditCourseItemInstance?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canEditCourseMaterial?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canEditCoursePublicSettings?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canEditCourseSettings?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canEditCourseTopicInstance?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    canRemoveCourseTopicInstance?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    courseRole?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    hasNoAccess?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>,
    isCourseOwner?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCoursePermission>>, Record<string, never>>
  },
  UserEmailNotificationSubscription?: {
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEmailNotificationSubscription>>, Record<string, never>>,
    hidden?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEmailNotificationSubscription>>, Record<string, never>>,
    key?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEmailNotificationSubscription>>, Record<string, never>>,
    notificationId?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEmailNotificationSubscription>>, Record<string, never>>,
    subscribed?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEmailNotificationSubscription>>, Record<string, never>>,
    unsubscribable?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEmailNotificationSubscription>>, Record<string, never>>
  },
  UserItemPermission?: {
    canDeleteCourseMaterialFromCourseFolder?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canDeleteItemFromTopic?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canDuplicateCourseMaterialIntoCourseFolder?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canDuplicateItemIntoTopic?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canEditCourseMaterial?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canEditItem?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canEditItemContentNote?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canEditItemSnippetNote?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canViewCourseMaterial?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canViewItem?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canViewItemContentNote?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>,
    canViewItemSnippetNote?: GraphCacheUpdateResolver<Maybe<WithTypename<UserItemPermission>>, Record<string, never>>
  },
  UserResult?: {
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<UserResult>>, Record<string, never>>
  },
  UserTenantPermission?: {
    canCreateCourse?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTenantPermission>>, Record<string, never>>,
    canManageLicense?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTenantPermission>>, Record<string, never>>,
    hasNoAccess?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTenantPermission>>, Record<string, never>>,
    isAdmin?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTenantPermission>>, Record<string, never>>,
    isTenantTeacher?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTenantPermission>>, Record<string, never>>
  },
  UserTopicPermission?: {
    canChangeTopicSharingSettings?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTopicPermission>>, Record<string, never>>,
    canDeleteTopicFromOwnLibrary?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTopicPermission>>, Record<string, never>>,
    canDuplicateTopic?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTopicPermission>>, Record<string, never>>,
    canEditCourseFolder?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTopicPermission>>, Record<string, never>>,
    canEditTopic?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTopicPermission>>, Record<string, never>>,
    canModifyCourseMaterials?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTopicPermission>>, Record<string, never>>,
    canModifyMaterials?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTopicPermission>>, Record<string, never>>,
    canMoveTopic?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTopicPermission>>, Record<string, never>>,
    canViewTopic?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTopicPermission>>, Record<string, never>>,
    isTopicOwner?: GraphCacheUpdateResolver<Maybe<WithTypename<UserTopicPermission>>, Record<string, never>>
  },
};

export type GraphCacheConfig = Parameters<typeof cacheExchange>[0] & {
  updates?: GraphCacheUpdaters,
  keys?: GraphCacheKeysConfig,
  optimistic?: GraphCacheOptimisticUpdaters,
  resolvers?: GraphCacheResolvers,
};